import React, { useState, useEffect, useLayoutEffect, useRef, lazy, Suspense } from 'react';
import { Channel, Server, User, Friend, PulseActivity, Role, Member, ConnectionState, PREMIUM_AVATAR_URLS, Bot } from './types';
import Dashboard from './components/Dashboard';
import { GoogleOAuthProvider } from '@react-oauth/google';
import KurucuTopluluklar from './components/KurucuTopluluklar';
import B2BEmbedPortal from './components/ApiEnterprise/B2BEmbedPortal';
import SesgelioStudiosDashboard from './components/ApiEnterprise/SesgelioStudiosDashboard';
import { io, Socket } from 'socket.io-client';
import { 
  Hash, 
  Volume2, 
  Settings2, 
  MicVocal, 
  MicOff, 
  AudioLines, 
  PhoneOff, 
  Plus, 
  Compass, 
  MessageSquare, 
  User as UserIcon, 
  X, 
  Signal, 
  ChevronDown, 
  UserPlus, 
  Trash2, 
  Settings, 
  Sparkles, 
  LogOut, 
  Monitor,
  Info,
  ShieldAlert,
  Bot as BotIcon, 
  Loader2, 
  AlertTriangle,
  Crown,
  Trophy,
  Key,
  Users,
  AlertCircle,
  Brain,
  UserMinus,
  ShieldCheck,
  Check,
  Video,
  VideoOff,
  MonitorUp,
  Search,
  Ghost,
  Command,
  Menu,
  FolderPlus,
  Folder,
  VolumeX,
  MonitorOff
} from 'lucide-react';

// 🚀 SİBER MÜHÜR: Bu ağır bileşenler artık SADECE giriş yapıldıktan sonra indirilecek.
// Böylece anasayfayı/giriş ekranını gören misafir kullanıcı LiveKit, Gemini AI gibi
// dev boyutlu kütüphaneleri hiç indirmeyecek, sayfa çok daha hafif ve hızlı açılacak.
const VoiceStage = lazy(() => import('./components/VoiceStage'));
const ChatArea = lazy(() => import('./components/ChatArea'));
const HomeDashboard = lazy(() => import('./components/HomeDashboard'));
const UserSettings = lazy(() => import('./components/UserSettings'));
const DirectMessageChat = lazy(() => import('./components/DirectMessageChat'));
const CreateServerModal = lazy(() => import('./components/CreateServerModal'));
const CreateChannelModal = lazy(() => import('./components/CreateChannelModal'));
const ServerSettingsModal = lazy(() => import('./components/ServerSettingsModal'));
const ServerDiscovery = lazy(() => import('./components/ServerDiscovery'));
const IncomingCallModal = lazy(() => import('./components/IncomingCallModal'));
const LeaderboardModal = lazy(() => import('./components/LeaderboardModal'));
const GeminiMarketingView = lazy(() => import('./components/GeminiMarketingView'));
const GlobalGeminiSession = lazy(() => import('./components/GlobalGeminiSession'));
const SesgelioTour = lazy(() => import('./components/SesgelioTour'));
const ServerTour = lazy(() => import('./components/ServerTour'));
const GroupChatArea = lazy(() => import('./components/GroupChatArea'));


// 🚀 KUSURSUZ BACKEND BAĞLANTISI (Vite + Klasik React + Localhost Uyumlu)
// YAPIŞTIRACAĞIN YENİ KOD:
const SOCKET_URL = 'https://sesgelio.com';
const BACKEND_URL = `${SOCKET_URL}/api`;

  // 🚀 HAYALET POSTACI: Anonim Analitik Gönderici
export const trackAnonymousEvent = async (user: User | null, category: string, action: string, metadata?: any) => {
  // 🛡️ 1. MÜHÜR: Kullanıcı yoksa veya ayarlardan veri paylaşımını KAPATTIYSA anında dur!
  if (!user || !user.allowAnalytics) return;

  try {
    // 🛡️ 2. MÜHÜR: Tarayıcı ve Cihaz bilgisini anonim olarak çek (Opsiyonel ama çok işe yarar)
    const systemInfo = {
      browser: navigator.userAgent.includes("Chrome") ? "Chrome" : navigator.userAgent.includes("Firefox") ? "Firefox" : navigator.userAgent.includes("Safari") ? "Safari" : "Other",
      isMobile: /Mobi|Android/i.test(navigator.userAgent),
      ...metadata // Bizim özel gönderdiğimiz verilerle birleştir
    };

    // Arkadan sessizce fırlat, uygulamanın hızını yavaşlatmaması için 'await' yapıp beklemiyoruz (fire-and-forget)
    fetch(`${BACKEND_URL}/api/analytics`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        category,
        action,
        metadata: systemInfo
      })
    }).catch(() => {}); // Hata verirse sessizce yut
  } catch (e) {}
};

const ipcRenderer = (window as any).ipcRenderer ?? null;

// --- 🛡️ SESGELİO GLOBAL API MUHAFIZI (INTERCEPTOR) ---
const originalFetch = window.fetch;
window.fetch = async (...args) => {
  let [resource, config] = args;
  
  // Sadece bizim backend'e giden isteklere müdahale et
  if (typeof resource === 'string' && resource.includes(BACKEND_URL) && !resource.includes('/api/b2b')) {
    config = config || {};
    
    // 🚀 SİHİRLİ DOKUNUŞ 1: Tarayıcının çerezleri (Cookie) otomatik göndermesini ZORUNLU kılıyoruz.
    config.credentials = 'include';
    
    const customHeaders: any = { ...config.headers };
    
    // 🚀 SİHİRLİ DOKUNUŞ 2: Diğer dosyalardaki eski "localStorage" kodlarını KISIRLAŞTIRIYORUZ!
    // Hangi dosya "Authorization: Bearer null" veya eski token göndermeye çalışırsa çalışsın, 
    // muhafızımız bunu sunucuya gitmeden havada yakalayıp çöpe atacak.
    delete customHeaders['Authorization'];
    delete customHeaders['authorization'];
    
    // Paket FormData (Dosya) ise Content-Type'ı SİL, değilse JSON yap
    if (config.body instanceof FormData) {
        delete customHeaders['Content-Type'];
    } else if (!customHeaders['Content-Type']) {
        customHeaders['Content-Type'] = 'application/json';
    }
    
    config.headers = customHeaders;
  }

  // İstegi sunucuya fırlat
let response;
  try {
      response = await originalFetch(resource, config);
  } catch (networkError) {
      console.error("Fetch Interceptor Ağ Hatası:", networkError);
      throw networkError;
  }

  // 🛡️ 401 OTURUM MÜHRÜ KONTROLÜ (DÜZELTİLEN KISIM BURASI)
  const isAuthRoute = typeof resource === 'string' && (resource.includes('/login') || resource.includes('/register') || resource.includes('/auth/google'));
  
  // 🚀 SİBER MÜHÜR: Hata veren yer gerçekten BİZİM sunucumuz mu?
  const isOurBackend = typeof resource === 'string' && resource.includes(BACKEND_URL);

  // Eğer 401 hatası BİZİM sunucudan geliyorsa dışarı at (Giphy gibi dış servisleri es geç)
  if (isOurBackend && response.status === 401 && !isAuthRoute) {
      console.warn("🛡️ Oturum mührü bozuldu veya çerez yok, tahliye ediliyorsun...");
      sessionStorage.clear(); 
      localStorage.removeItem('saved_user_profile'); 
      window.location.href = "/"; 
  }
  
  return response;
};
declare global {
  interface Window {
    SESGELIO_SELECTED_OUTPUT_ID?: string;
  }
}

// 2. Global Ses Muhafızı (Yama)
(function() {
  const originalPlay = HTMLAudioElement.prototype.play;

  HTMLAudioElement.prototype.play = function(this: HTMLAudioElement) {
    const outputId = window.SESGELIO_SELECTED_OUTPUT_ID;

    // setSinkId her tarayıcıda olmayabilir, o yüzden tip kontrolü yapıyoruz
    const audioAny = this as any;

    if (outputId && outputId !== 'default' && audioAny.setSinkId) {
      return audioAny.setSinkId(outputId)
        .then(() => originalPlay.apply(this, arguments as any))
        .catch((err: any) => {
          console.warn("Global ses mühürü takıldı, varsayılandan çalınıyor:", err);
          return originalPlay.apply(this, arguments as any);
        });
    }
    
    return originalPlay.apply(this, arguments as any);
  };
})();

const DEFAULT_ROLES: Role[] = [
  { id: 'r-admin', name: 'Yönetici', color: '#ff2b5e', iconName: 'Crown', permissions: ['ADMIN'] },
  { id: 'r-coadmin', name: 'Yardımcı Yönetici', color: '#eab308', iconName: 'ShieldAlert', permissions: ['MANAGE_SERVER', 'MANAGE_CHANNELS', 'MANAGE_ROLES', 'BAN_MEMBERS', 'KICK_MEMBERS', 'MANAGE_MESSAGES', 'SEND_MESSAGES', 'CONNECT', 'VIEW_CHANNELS'] },
  { id: 'r-mod', name: 'Moderatör', color: '#3b82f6', iconName: 'ShieldCheck', permissions: ['MANAGE_MESSAGES', 'KICK_MEMBERS'] },
  { id: 'r-member', name: 'Kayıtlı Üye', color: '#10b981', iconName: 'User', permissions: ['SEND_MESSAGES'] },
  { id: 'r-guest', name: 'Misafir', color: '#99aab5', iconName: 'Ghost', permissions: [] },
];

const FULL_BOT_SET: Bot[] = [
  { 
    id: 'b-ai', 
    instanceId: 'b-ai-default',
    name: 'Sesgelio AI', 
    description: ' Akıllı yapay zeka asistanı.', 
    avatarUrl: 'https://images.unsplash.com/photo-1620712943543-bcc4688e7485?q=80&w=400&auto=format&fit=crop', 
    bannerUrl: 'https://images.unsplash.com/photo-1614850523459-c2f4c699c52e?q=80&w=800&auto=format&fit=crop',
    active: true 
  },
  { 
    id: 'b-music', 
    instanceId: 'b-music-default',
    name: 'Sesgelio AudioLink', 
    description: 'Yüksek kaliteli 7/24 müzik botu.', 
    avatarUrl: 'https://images.unsplash.com/photo-1598488035139-bdbb2231ce04?q=80&w=400&auto=format&fit=crop', 
    bannerUrl: 'https://images.unsplash.com/photo-1470225620780-dba8ba36b745?q=80&w=800&auto=format&fit=crop',
    active: true 
  },
  { 
    id: 'b-mod', 
    instanceId: 'b-mod-default',
    name: 'Aegis Sentinel', 
    description: 'Otomatik moderasyon ve spam filtresi.', 
    avatarUrl: 'https://images.unsplash.com/photo-1593349480506-8433634cdcbe?q=80&w=400&auto=format&fit=crop', 
    bannerUrl: 'https://images.unsplash.com/photo-1550751827-4bd374c3f58b?q=80&w=800&auto=format&fit=crop',
    active: true 
  },
  { 
    id: 'b-level', 
    instanceId: 'b-level-default',
    name: 'StatMatrix', 
    description: 'Sohbet aktivite ve XP sistemi.', 
    avatarUrl: 'https://images.unsplash.com/photo-1550745165-9bc0b252726f?q=80&w=400&auto=format&fit=crop', 
    bannerUrl: 'https://images.unsplash.com/photo-1511512578047-dfb367046420?q=80&w=1200&auto=format&fit=crop',
    active: true 
  },
  { 
    id: 'b-tool', 
    instanceId: 'b-tool-default',
    name: 'Nexus Desk', 
    description: 'Destek talebi ve yönetim sistemi.', 
    avatarUrl: 'https://images.unsplash.com/photo-1531403009284-440f080d1e12?q=80&w=400&auto=format&fit=crop', 
    bannerUrl: 'https://images.unsplash.com/photo-1556745757-8d76bdb6984b?q=80&w=1200&auto=format&fit=crop',
    active: true 
  }
];

const OFFICIAL_SERVERS: Server[] = [
  {
    id: 's-main',
    name: 'Sesgelio Ana Üs',
    iconUrl: 'https://images.unsplash.com/photo-1614728263952-84ea256f9679?q=90&w=600&auto=format&fit=crop',
    ownerId: 'system',
    inviteCode: 'SESGEL',
    channels: [
      {id:'c-main-welcome', name:'👋 hoşgeldiniz', type:'text'},
      {id:'c-main-rules', name:'📜 kurallar', type:'text'},
      {id:'c-main-ann', name:'📢 duyurular', type:'text'},
      {id:'c-main-gen', name:'💬 genel-sohbet', type:'text'},
      {id:'c-main-media', name:'📷 medya-paylaşım', type:'text'},
      {id:'c-main-support', name:'🆘 destek', type:'text'},
      {id:'v-main-lobby', name:'☕ Lobi', type:'voice', voiceMode:'standard'},
      {id:'v-main-chat1', name:'🔊 Sohbet Odası #1', type:'voice', voiceMode:'standard'},
      {id:'v-main-music', name:'🎵 Müzik Odası', type:'voice', voiceMode:'standard'},
      {id:'v-main-afk', name:'💤 AFK', type:'voice', voiceMode:'standard'}
    ],
    roles: [...DEFAULT_ROLES],
    members: [], 
    bots: [...FULL_BOT_SET], 
    moderation: { verificationLevel: 'high', explicitContentFilter: true }
  },
  {
    id: 's-valorant',
    name: 'Valorant TR',
    iconUrl: 'https://images.unsplash.com/photo-1542751371-adc38448a05e?q=90&w=600&auto=format&fit=crop',
    ownerId: 'system',
    inviteCode: 'VALOTR',
    channels: [
      {id:'c-val-welcome', name:'🚀 başlangıç', type:'text'},
      {id:'c-val-rules', name:'⚠️ kurallar', type:'text'},
      {id:'c-val-patch', name:'📝 yama-notları', type:'text'},
      {id:'c-val-lfg', name:'🎯 takım-bul', type:'text'},
      {id:'c-val-clips', name:'🎬 klipler', type:'text'},
      {id:'v-val-lobby', name:'🎌 Lobideyiz', type:'voice', voiceMode:'standard'},
      {id:'v-val-rank', name:'🏆 Dereceli', type:'voice', voiceMode:'standard'},
      {id:'v-val-unrank', name:'🎲 Derecesiz', type:'voice', voiceMode:'standard'},
      {id:'v-val-duo', name:'👥 Duo Queue', type:'voice', voiceMode:'standard'}
    ],
    roles: [...DEFAULT_ROLES],
    members: [],
    bots: [...FULL_BOT_SET], 
    moderation: { verificationLevel: 'low', explicitContentFilter: true }
  },
  {
    id: 's-lofi',
    name: 'Lo-Fi Lounge',
    iconUrl: 'https://images.unsplash.com/photo-1470225620780-dba8ba36b745?q=90&w=600&auto=format&fit=crop',
    ownerId: 'system',
    inviteCode: 'LOFICHILL',
    channels: [
      {id:'c-lofi-welcome', name:'☕ giriş', type:'text'},
      {id:'c-lofi-chat', name:'💭 sohbet', type:'text'},
      {id:'c-lofi-music', name:'🎵 müzik-önerileri', type:'text'},
      {id:'v-lofi-radio', name:'📻 Lofi Radio 24/7', type:'voice', voiceMode:'standard'},
      {id:'v-lofi-silent', name:'🤫 Sessiz Kütüphane', type:'voice', voiceMode:'standard'},
      {id:'v-lofi-rain', name:'🌧️ Yağmurlu Gün', type:'voice', voiceMode:'standard'}
    ],
    roles: [...DEFAULT_ROLES],
    members: [],
    bots: [...FULL_BOT_SET], 
    moderation: { verificationLevel: 'none', explicitContentFilter: false }
  }
];

const DEFAULT_PULSE_ACTIVITIES: PulseActivity[] = [
  { id: 1, title: 'Haftalık Toplantı', subtitle: 'Şimdi Canlı', server: 's-main', users: ['+120'], image: 'https://images.unsplash.com/photo-1614728263952-84ea256f9679?q=90&w=1200&auto=format&fit=crop', type: 'event' },
  { id: 2, title: 'Dereceli Kasma', subtitle: 'Valorant', server: 's-valorant', users: ['Ahmet', 'Mehmet', '+3'], image: 'https://images.unsplash.com/photo-1542751371-adc38448a05e?q=90&w=1200&auto=format&fit=crop', type: 'game' },
  { id: 3, title: 'Study With Me', subtitle: 'Müzik', server: 's-lofi', users: ['Zeynep', '+14'], image: 'https://images.unsplash.com/photo-1470225620780-dba8ba36b745?q=90&w=1200&auto=format&fit=crop', type: 'music' }
];

interface MusicQueueItem {
  title: string;
  requester: string;
  url: string; 
}

const App: React.FC = () => {

// 🚀 V2 (HİBRİT MOTOR): Masaüstünde esnetir, Mobilde serbest bırakır!
  useLayoutEffect(() => { // 🚀 ÇELİK MÜHÜR: useEffect yerine useLayoutEffect kullandık! Ekran çizilmeden ölçüyü alır, donmayı %100 keser!
    const handleResize = () => {
      const width = window.innerWidth;

      // 📱 MOBİL MÜHRÜ: Ekran 768px'den (telefon) küçükse, esnetme motorunu durdur!
      // Sistemi kendi doğal haline bırakıyoruz ki telefonun ekranına tam otursun.
      if (width < 768) {
        document.documentElement.style.fontSize = '16px'; 
        return; // Kodu burada kes, aşağı inme!
      }

      // 💻 MASAÜSTÜ MÜHRÜ: 768px ve üzeri ekranlarda amcanın vizyonu (esnetme) devreye girer
      const currentWidth = Math.max(width, 800);
      const scaleFactor = Math.min(currentWidth / 1920, 1);
      document.documentElement.style.fontSize = `${16 * scaleFactor}px`;
    };

    // Siteye ilk girildiğinde hemen ölçüyü al ve ayarla
    handleResize();
    
    // Adam tarayıcı penceresini veya telefonunu yan çevirdikçe sistemi otomatik uyarla
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  
  // 🛡️ ARAMA MODALI İÇİN KUSURSUZ AVATAR KURTARICI
  const getAbsoluteAvatar = (url?: string) => {
      if (!url) return 'https://ui-avatars.com/api/?name=User';
      if (url.startsWith('http') || url.startsWith('data:')) return url;
      const cleanBase = BACKEND_URL.endsWith('/') ? BACKEND_URL.slice(0, -1) : BACKEND_URL;
      const cleanUrl = url.startsWith('/') ? url : `/${url}`;
      return `${cleanBase}${cleanUrl}`;
  };
  const [theme, setTheme] = useState<'dark' | 'light'>('dark');
 const [hoverTooltip, setHoverTooltip] = useState<{show: boolean, text: React.ReactNode, top: number, left: number, position?: 'right' | 'top' | 'bottom' | 'left'}>({show: false, text: '', top: 0, left: 0});
  // ⚡ HIZLI GEÇİŞ (QUICK SWITCHER) MOTORU STATE'LERİ
  const [showQuickSwitcher, setShowQuickSwitcher] = useState(false);
  const [quickQuery, setQuickQuery] = useState('');
  const [quickSelectedIndex, setQuickSelectedIndex] = useState(0);
 const [showLanding, setShowLanding] = useState<boolean>(true);
 const [isMobileDrawerOpen, setIsMobileDrawerOpen] = useState(false);
  const [showSettings, setShowSettings] = useState<boolean>(false);
  const [settingsInitialTab, setSettingsInitialTab] = useState<'account' | 'privacy' | 'voice' | 'notifications' | 'appearance' | 'shortcuts' | 'market' | 'subscriptions' | 'billing'>('account'); 
  const [showLeaderboardModal, setShowLeaderboardModal] = useState<boolean>(false); 
  const [showBadgePreview, setShowBadgePreview] = useState<boolean>(false);
  const [showCreateServerModal, setShowCreateServerModal] = useState<boolean>(false);
  const [showServerTour, setShowServerTour] = useState<boolean>(false);
  const [showCreateChannelModal, setShowCreateChannelModal] = useState<boolean>(false);
  const [createChannelDefaultType, setCreateChannelDefaultType] = useState<'text' | 'voice' | null>(null);
  const [createChannelTargetFolderId, setCreateChannelTargetFolderId] = useState<string | null>(null); // 🚀 YENİ MÜHÜR: Hangi klasör seçildi?
  const [showServerSettingsModal, setShowServerSettingsModal] = useState<boolean>(false);
  const [isServerMenuOpen, setIsServerMenuOpen] = useState<boolean>(false);
  const [serverToLeave, setServerToLeave] = useState<{id: string, name: string} | null>(null);
  const [currentUser, setCurrentUser] = useState<User | null>(null);
  const [servers, setServers] = useState<Server[]>([]);
  const [friends, setFriends] = useState<Friend[]>([]);
  const [groups, setGroups] = useState<any[]>([]);
  const [activeGroupId, setActiveGroupId] = useState<string | null>(null);
  const [pulseActivities, setPulseActivities] = useState<PulseActivity[]>([]);

// 🚀 DEEP LINK SEÇİM EKRANI HAFIZASI
  const [inviteChoiceCode, setInviteChoiceCode] = useState<string | null>(null);
  const [showDownloadPrompt, setShowDownloadPrompt] = useState<boolean>(false);

  // 🚀 ANTI-SPAM VE DONMA KORUMASI İÇİN HAFIZALAR
  const isConnectingToVoiceRef = useRef<boolean>(false);
  const connectionActionTimeoutRef = useRef<NodeJS.Timeout | null>(null);

  // 🚀 GRUP ARAMA SİSTEMİ HAFIZASI
  const [showGroupCallModal, setShowGroupCallModal] = useState(false);
  const [selectedCallFriends, setSelectedCallFriends] = useState<string[]>([]);
  const [callSearchQuery, setCallSearchQuery] = useState("");

// 🚀 LOCALSTORAGE DESTEKLİ KANAL HAFIZALARI
  const [collapsedChannelFolders, setCollapsedChannelFolders] = useState<string[]>(() => {
    const saved = localStorage.getItem('sesgelio_collapsedFolders');
    return saved ? JSON.parse(saved) : [];
  });

  const [isTextChannelsExpanded, setIsTextChannelsExpanded] = useState<boolean>(() => {
    const saved = localStorage.getItem('sesgelio_textExpanded');
    return saved !== null ? JSON.parse(saved) : true;
  });

  const [isVoiceChannelsExpanded, setIsVoiceChannelsExpanded] = useState<boolean>(() => {
    const saved = localStorage.getItem('sesgelio_voiceExpanded');
    return saved !== null ? JSON.parse(saved) : true;
  });

  // 🚀 HAFIZA DEĞİŞTİKÇE TARAYICIYA KAYDET
  React.useEffect(() => {
    localStorage.setItem('sesgelio_collapsedFolders', JSON.stringify(collapsedChannelFolders));
  }, [collapsedChannelFolders]);

  React.useEffect(() => {
    localStorage.setItem('sesgelio_textExpanded', JSON.stringify(isTextChannelsExpanded));
  }, [isTextChannelsExpanded]);

  React.useEffect(() => {
    localStorage.setItem('sesgelio_voiceExpanded', JSON.stringify(isVoiceChannelsExpanded));
  }, [isVoiceChannelsExpanded]);

 // 🚀 YAZILI ARKADAŞ GRUBU SİSTEMİ HAFIZASI
  const [showCreateGroupModal, setShowCreateGroupModal] = useState(false);
  const [groupInviteCode, setGroupInviteCode] = useState(""); // 🚀 YENİ: Katılım Kodu Hafızası

// 📞 GRUP ÇAĞRISI HAFIZASI (İsim Çakışmaması İçin Değiştirildi)
  const [incomingGroupCall, setIncomingGroupCall] = useState<{callerId: string, callerName: string, callerAvatar: string, roomId: string} | null>(null);

 const [resetToken, setResetToken] = useState<string | null>(null);
  // 🚀 ŞİFRE SIFIRLAMA İÇİN EKLENEN YENİ HAFIZALAR
  const [newPasswordInput, setNewPasswordInput] = useState('');
  const [confirmNewPasswordInput, setConfirmNewPasswordInput] = useState('');
  const [isResettingPassword, setIsResettingPassword] = useState(false);

  const [voiceSessionId, setVoiceSessionId] = useState<number>(0);

  const [show2FALogin, setShow2FALogin] = useState<boolean>(false);
  const [tempUserId, setTempUserId] = useState<string | null>(null);
  const [twoFALoginCode, setTwoFALoginCode] = useState<string>('');
  
  const [localBotPositions, setLocalBotPositions] = useState<Record<string, string>>({
      'b-music-default': 'v-lofi-radio'
  });

  const [channelOccupancy, setChannelOccupancy] = useState<Record<string, User[]>>({});

// 🚀 KLASÖR SİSTEMİ HAFIZASI
 const [serverFolders, setServerFolders] = useState<{id: string, name: string, color: string, serverIds: string[]}[]>([]);   
 const [isFoldersLoaded, setIsFoldersLoaded] = useState(false); // 🛡️ Zırh: Veri yüklenmeden kaydetmeyi engeller
 const [expandedFolders, setExpandedFolders] = useState<string[]>([]);
 const [showFolderModal, setShowFolderModal] = useState(false);
 const [folderTargetServerId, setFolderTargetServerId] = useState<string | null>(null);
 const [newFolderName, setNewFolderName] = useState('');
 const [newFolderColor, setNewFolderColor] = useState('#3b82f6');

  useEffect(() => {
      // 🛡️ KRİTİK KONTROL: Veriler DB'den yüklenmeden sakın kaydetme (Boş liste gönderip DB'yi silmesin)
      if (!currentUser || !isFoldersLoaded) return;
      
      const syncFolders = async () => {
          try {
              await fetch(`${BACKEND_URL}/api/folders/sync`, {
                  method: 'PUT',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({ folders: serverFolders })
              });
              localStorage.setItem('sesgelio_folders', JSON.stringify(serverFolders));
          } catch (e) {
              console.error("Senkronizasyon hatası:", e);
          }
      };

      const timeoutId = setTimeout(syncFolders, 1000);
      return () => clearTimeout(timeoutId);
  }, [serverFolders, currentUser?.id, isFoldersLoaded]);

  const toggleFolder = (folderId: string) => {
      setExpandedFolders(prev => prev.includes(folderId) ? prev.filter(id => id !== folderId) : [...prev, folderId]);
  };

// 🚀 SOL BAR KİM KONUŞUYOR VE YAYIN YAPIYOR RADARI
  const [globalSpeakingUsers, setGlobalSpeakingUsers] = useState<Record<string, boolean>>({});
  const [globalVideoUsers, setGlobalVideoUsers] = useState<Record<string, boolean>>({});
  const [globalScreenUsers, setGlobalScreenUsers] = useState<Record<string, boolean>>({});
  const [globalMutedUsers, setGlobalMutedUsers] = useState<Record<string, boolean>>({});
  const [globalDeafenedUsers, setGlobalDeafenedUsers] = useState<Record<string, boolean>>({});

// 🚀 SIFIR GECİKMELİ KÖPRÜ ANTENİ (VoiceStage'den gelen şimşek sinyalleri yakalar)
  useEffect(() => {
      const handleGlobalSpeaking = (e: any) => {
          setGlobalSpeakingUsers(prev => {
              const myId = currentUser?.id as string;
              return { ...e.detail, [myId]: prev[myId] || false };
          });
          // 🚀 IŞINLANMA MÜHRÜ (Sol Bar Sıfır Gecikme)
          Object.entries(e.detail).forEach(([userId, isSpeaking]) => {
              const avatar = document.getElementById(`sidebar-avatar-${userId}`);
              if (avatar) {
                  if (isSpeaking) {
                      avatar.classList.remove('ring-transparent');
                      avatar.classList.add('ring-green-500', 'shadow-[0_0_12px_rgba(34,197,94,0.9)]', 'scale-110', 'z-10');
                  } else {
                      avatar.classList.add('ring-transparent');
                      avatar.classList.remove('ring-green-500', 'shadow-[0_0_12px_rgba(34,197,94,0.9)]', 'scale-110', 'z-10');
                  }
              }
          });
      };
      
      const handleLocalSpeaking = (e: any) => {
          if (currentUser) {
              setGlobalSpeakingUsers(prev => ({ ...prev, [currentUser.id]: e.detail }));
              // 🚀 IŞINLANMA MÜHRÜ (Senin Avatarın İçin)
              const avatar = document.getElementById(`sidebar-avatar-${currentUser.id}`);
              if (avatar) {
                  if (e.detail) {
                      avatar.classList.remove('ring-transparent');
                      avatar.classList.add('ring-green-500', 'shadow-[0_0_12px_rgba(34,197,94,0.9)]', 'scale-110', 'z-10');
                  } else {
                      avatar.classList.add('ring-transparent');
                      avatar.classList.remove('ring-green-500', 'shadow-[0_0_12px_rgba(34,197,94,0.9)]', 'scale-110', 'z-10');
                  }
              }
          }
      };

      // 🚀 KENDİ KAMERA VE EKRANIMIZI BACKENDE FIRLATAN ANA KÖPRÜ
      const handleLocalMedia = (e: any) => {
          const { isVideoOn, isScreenSharing } = e.detail;
          
          if (socketRef.current && currentUser) {
              socketRef.current.emit('user-media-status', { isVideoOn, isScreenSharing });
              setGlobalVideoUsers(prev => ({ ...prev, [currentUser.id]: isVideoOn }));
              setGlobalScreenUsers(prev => ({ ...prev, [currentUser.id]: isScreenSharing }));
          }
      };

      window.addEventListener('sesgelio-global-speaking', handleGlobalSpeaking);
      window.addEventListener('sesgelio-local-speaking', handleLocalSpeaking);
      window.addEventListener('sesgelio-local-media', handleLocalMedia);
      
      return () => {
          window.removeEventListener('sesgelio-global-speaking', handleGlobalSpeaking);
          window.removeEventListener('sesgelio-local-speaking', handleLocalSpeaking);
          window.removeEventListener('sesgelio-local-media', handleLocalMedia);
      };
  }, [currentUser]);

  const [activeServerId, setActiveServerId] = useState<string>('home');
  const [activeChannelId, setActiveChannelId] = useState<string | null>(null);
  const [activeDmId, setActiveDmId] = useState<string | null>(null);
  const [isDmMinimized, setIsDmMinimized] = useState(false);
  const [voiceConnected, setVoiceConnected] = useState<boolean>(false);
  const [voiceConnectionStatus, setVoiceConnectionStatus] = useState<ConnectionState>(ConnectionState.DISCONNECTED);
  const [activeVoiceChannel, setActiveVoiceChannel] = useState<string | null>(null);
const [isMuted, setIsMuted] = useState(false); // 🚀 MÜHÜR: Artık sisteme girildiğinde mikrofon açık (false) başlayacak!
  const [hasSystemMic, setHasSystemMic] = useState(true); // 🚀 DİNLEYİCİ MODU: Sisteme bağlı fiziksel mikrofon var mı?
  const [isDeafened, setIsDeafened] = useState(false);

// 🚀 DM ARAMA MOTORU HAFIZASI
  const [ongoingDmCall, setOngoingDmCall] = useState<{ id: string, name: string } | null>(null);

  useEffect(() => {
      const handleCallStart = (e: any) => setOngoingDmCall(e.detail);
      const handleCallEnd = (e: any) => {
          setOngoingDmCall(prev => {
              // Siber Mühür: Eğer kapatma sinyali veren kişi, aktif konuştuğumuz kişi DEĞİLSE, aramayı sakın kesme!
              if (prev && e.detail && e.detail.id && prev.id !== e.detail.id) {
                  return prev;
              }
              return null;
          });
      };

      window.addEventListener('dm-call-started', handleCallStart);
      window.addEventListener('dm-call-ended', handleCallEnd);

      return () => {
          window.removeEventListener('dm-call-started', handleCallStart);
          window.removeEventListener('dm-call-ended', handleCallEnd);
      };
  }, []);

// 🚀 MÜHÜR: HİGHLANDER KURALI (Sadece 1 ses aktif olabilir)
  // Eğer DM araması başladıysa ve sunucu/grup sesindeysek, sunucu sesini ACIMADAN KES!
useEffect(() => {
    if (ongoingDmCall && voiceConnected && !activeVoiceChannel?.startsWith('call-')) {
        handleDisconnect();
    }
}, [ongoingDmCall]);

  // 🚀 DM KÜÇÜLT (ARKA PLANA AL) DİNLEYİCİSİ
  useEffect(() => {
      const handleMinimize = () => {
          setIsDmMinimized(true);
      };
      window.addEventListener('sesgelio-minimize-dm', handleMinimize);
      return () => window.removeEventListener('sesgelio-minimize-dm', handleMinimize);
  }, []);

  // 🚀 DM'E GERİ DÖNÜLDÜĞÜNDE KÜÇÜLTME MODUNU İPTAL ET
useEffect(() => {
    if (activeServerId === 'home' && activeDmId) {
        setIsDmMinimized(false);
    }
    if (activeServerId === 'home' && !activeDmId && activeVoiceChannel?.startsWith('call-')) {
        setIsDmMinimized(true);
    }
}, [activeServerId, activeDmId]);


  const connectionTimeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const [activeGeminiSession, setActiveGeminiSession] = useState<'voice' | 'chat' | null>(null);

  const [musicState, setMusicState] = useState({ 
    isPlaying: false, 
    trackTitle: '', 
    videoId: '',
    volume: 0.5 ,
    startedAt: null as number | null
  });

  const [musicQueue, setMusicQueue] = useState<MusicQueueItem[]>([]);
  const [draggedServerId, setDraggedServerId] = useState<string | null>(null);
  const [incomingCall, setIncomingCall] = useState<{ callerId: string; callerName: string; callerAvatar: string; signal: any; } | null>(null);
  const [didAcceptCall, setDidAcceptCall] = useState(false);
 const [activeCallSignal, setActiveCallSignal] = useState<{callerId: string, signal: any} | null>(null);
  const socketRef = useRef<Socket | null>(null);

  const [globalIceCandidates, setGlobalIceCandidates] = useState<any[]>([]);

// 🚀 F5 KURTARICI (OTOMATİK KONTAK MÜHRÜ): Sayfa yenilendiğinde hafızayı kontrol et!
  useEffect(() => {
const checkSavedSession = () => {
    // Eski güvensiz token kalıntısını temizle (artık HttpOnly cookie kullanıyoruz)
    localStorage.removeItem('token');

    const params = new URLSearchParams(window.location.search);
    const pageParam = params.get('page');
    
// 🚀 IŞINLANMA MOTORU 1 (HİBRİT VERSİYON): WhatsApp'tan gelen linki her formatta yakala!
    let inviteCodeParam = params.get('davet'); // ?davet=KOD formatı için

    // Eğer link /davet/KOD formatındaysa oradan çekip çıkar:
    if (!inviteCodeParam && window.location.pathname.includes('/davet/')) {
        inviteCodeParam = window.location.pathname.split('/davet/')[1].split('/')[0];
    }

    if (inviteCodeParam) {
        // Linkin sonundaki yazıyı anında temizleyip ana sayfaya (tertemiz köke) çeviriyoruz!
        window.history.replaceState({}, document.title, '/');
        
        // 🚀 MÜHÜR: Adam zaten masaüstü uygulamasının içindeyse sorma, direkt al! Tarayıcıdaysa (Web) Modal'ı aç!
        if ((window as any).electronAPI) {
            localStorage.setItem('pendingInvite', inviteCodeParam);
        } else {
            setInviteChoiceCode(inviteCodeParam); // Kullanıcıya "Nerede açalım?" diye sormak için sahneye al!
        }
    }

    // 🚀 İYZİCO TAM EKRAN DÖNÜŞ MÜHRÜ: Başarılı veya Başarısız ödemeyi yakala
    const paymentStatus = params.get('payment_status');
    const productId = params.get('product_id');
    const paramServerId = params.get('server_id');

    if (paymentStatus === 'success') {
        localStorage.setItem('pending_success_product', productId || '');
        localStorage.setItem('pending_success_server', paramServerId || '');
        window.history.replaceState({}, document.title, window.location.pathname);
    } else if (paymentStatus === 'failed') {
        localStorage.setItem('pending_failed_payment', 'true');
        window.history.replaceState({}, document.title, window.location.pathname);
    }
          
          // Ana sayfa atlaması (Bypass) yapılacak sayfaların listesi
          const publicPages = [
              'reset-password', 'terms', 'privacy', 'distance-selling', 
              'cookies', 'guidelines', 'safe-shopping', 'refund-policy', 'pre-information'
          ];

          // Eğer girilen URL bu listeden biriyse, burada kodu kes, içeri alma (Dashboard'da kalsın)
          if (pageParam && publicPages.includes(pageParam)) {
              return;
          }

          try {
              const savedData = localStorage.getItem('saved_user_profile');
              if (savedData) {
                  const savedProfile = JSON.parse(savedData);
                  if (savedProfile && savedProfile.id) {
                      // Eğer hafızada adam varsa, onu direkt state'e at ve giriş ekranını atla!
                      setCurrentUser(savedProfile as User);
                      if (savedProfile.theme) {
                          setTheme(savedProfile.theme as 'dark' | 'light');
                      }
                      setShowLanding(false); // Login ekranını gizle
                      setActiveServerId('home');
                      setPulseActivities(DEFAULT_PULSE_ACTIVITIES);
                      
                      // Güvenlik ve güncel veriler için arka planda sessizce handleConnect'i çalıştır
                      handleConnect();
                      return;
                  }
              }
          } catch (e) {
              console.error("Otomatik giriş başarısız, hafıza bozuk olabilir:", e);
          }
          // Eğer hafızada kimse yoksa, showLanding zaten 'true' olarak kalır ve login ekranı açılır.
      };

      // Uygulama ilk açıldığında sadece bir kere çalıştır
      checkSavedSession();
  }, []);

  const activeServer = (servers || []).find(s => s.id === activeServerId);
  const currentChannels = activeServer?.channels || []; // Kanallar yoksa boş liste olsun, patlamasın
  const currentServerRoles = (activeServer?.roles || []).length > 0 ? (activeServer?.roles || DEFAULT_ROLES) : DEFAULT_ROLES;
  const activeChannel = currentChannels.find(c => c.id === activeChannelId) || currentChannels[0];
  const currentMember = activeServer?.members?.find(m => m.id === currentUser?.id);
  const memberRole = currentServerRoles.find(r => r.id === currentMember?.roleId);
  const isServerOwner = activeServer?.ownerId === currentUser?.id;
  const canManageServer = isServerOwner || (memberRole?.permissions.some(p => 
  ['ADMIN', 'MANAGE_SERVER', 'MANAGE_CHANNELS', 'MANAGE_MUSIC ', 'BAN_MEMBERS'].includes(p)
) || false);
  const connectedServerId = servers.find(s => (s.channels || []).some(c => c.id === activeVoiceChannel))?.id;
  const connectedChannel = connectedServerId ? servers.find(s => s.id === connectedServerId)?.channels.find(c => c.id === activeVoiceChannel) : null;
  const isViewingVoiceChannel = voiceConnected && activeVoiceChannel && activeServerId === connectedServerId && activeChannelId === activeVoiceChannel;

 const isGroupCall = voiceConnected && activeVoiceChannel?.startsWith('call-');
const isViewingGroupCall = isGroupCall && activeServerId === 'home' && !activeGroupId && activeChannelId === activeVoiceChannel && !activeDmId;

  const handleKickMember = async (targetUserId: string) => {
  // 1. Temel Kontroller (Sunucu ve Kullanıcı verisi var mı?) 
  if (!activeServer || !currentUser) return;

  // 2. Hedef kullanıcının bilgilerini ve rütbesini bul [cite: 190, 254]
  const targetMember = activeServer.members?.find(m => m.id === targetUserId);
  if (!targetMember) return;

  // 3. Güvenlik: Sunucu sahibi hiçbir şekilde atılamaz! 
  if (targetUserId === activeServer?.ownerId) {
    alert("Sunucu sahibini mi atacaksın? Ayıp !");
    return;
  }

  // 4. Hiyerarşi Kontrolü: Eğer sunucu sahibi değilsen rütbe kontrolü yap 
  if (!isServerOwner) {
    const myMember = activeServer?.members?.find(m => m.id === currentUser?.id);
    
    // 🚀 TS MÜHRÜ: Değişkenleri açıkça 'number' olarak mühürlüyoruz ve varsayılan -1 veriyoruz.
    const myRoleIndex: number = activeServer?.roles?.findIndex(r => r.id === myMember?.roleId) ?? -1;
    const targetRoleIndex: number = activeServer?.roles?.findIndex(r => r.id === targetMember?.roleId) ?? -1;

    // 🛡️ Artık ikisi de garanti sayı olduğu için kıyaslama hata vermez.
    if (myRoleIndex === -1 || targetRoleIndex === -1 || myRoleIndex >= targetRoleIndex) {
      alert("Kendi rütbendeki veya senden üstteki bir operatörü sunucudan atamazsın nöral dostum!");
      return;
    }
  }
  // 5. Onay Al
  if (!window.confirm("Bu üyeyi sunucudan atmak istediğine emin misin nöral dostum?")) return;

  try {
  const response = await fetch(`${BACKEND_URL}/api/servers/${activeServerId}/members/${targetUserId}`, {
      method: 'DELETE',
      headers: { 'Content-Type': 'application/json' },
      // 🛡️ MÜHÜR: adminId: currentUser?.id satırını sildik!
      // Sadece varsa atılma sebebini gönderiyoruz.
      body: JSON.stringify({ reason: "Kural ihlali" }) 
    });

    if (response.ok) {
      alert("Operatör sunucudan uzaklaştırıldı.");
      // App.tsx içindeki diğer socket/state güncellemeleri zaten listeyi yenileyecek [cite: 208, 216]
    } else {
      const data = await response.json();
      alert(data.error);
    }
  } catch (error) {
    console.error("Kick hatası:", error);
  }
};

// 🛡️ SİNSİ HATA ÇÖZÜMÜ: Sayfa Kapanırken veya Yenilenirken Sesten Koparma
useEffect(() => {
    // 1. Tarayıcı kapanmadan hemen mili-saniyeler önce tetiklenen özel fonksiyon
    const handleBeforeUnload = () => {
        // socket yerine socketRef.current kullanıyoruz
        if (activeVoiceChannel && socketRef.current && currentUser) {
            // Backend'e sesten acil çıkış yaptığımızı zorla bildiriyoruz
            socketRef.current.emit('leave-voice-channel', { 
                channelId: activeVoiceChannel, 
                userId: currentUser?.id, 
                serverId: activeServerId 
            });
        }
        
        // Tarayıcı hafızasında "en son şu sesteydi" bilgisi kaldıysa imha ediyoruz
        localStorage.removeItem('activeVoiceChannel');
        sessionStorage.removeItem('activeVoiceChannel');
    };

    // Dinleyiciyi tarayıcıya takıyoruz (X'e basma veya F5 durumları için)
    window.addEventListener('beforeunload', handleBeforeUnload);

    // 2. Uygulama İLK YÜKLENDİĞİNDE (Yani sayfaya ilk girildiğinde) eski kalıntıları temizle
    localStorage.removeItem('activeVoiceChannel');
    sessionStorage.removeItem('activeVoiceChannel');

    return () => {
        // Component ölürse dinleyiciyi temizle
        window.removeEventListener('beforeunload', handleBeforeUnload);
    };
}, [activeVoiceChannel, currentUser, activeServerId]);

// 🚀 SİBER KALKAN: TARAYICI SES KİLİDİ AÇICI (AUTOPLAY FIX)
  useEffect(() => {
    const unlockAudio = () => {
      try {
        // Tarayıcının ses motorunu zorla uyandırıyoruz
        const AudioContext = window.AudioContext || (window as any).webkitAudioContext;
        if (AudioContext) {
          const audioCtx = new AudioContext();
          if (audioCtx.state === 'suspended') {
            audioCtx.resume();
          }
        }
        
        // 1 saniyelik tamamen sessiz bir ses dosyası çalarak tarayıcıyı kandırıyoruz
        const silentAudio = new Audio('data:audio/wav;base64,UklGRigAAABXQVZFZm10IBIAAAABAAEARKwAAIhYAQACABAAAABkYXRhAgAAAAEA');
        silentAudio.play().catch(() => {});

        console.log("✅ [SESGELIO] Tarayıcı ses kilidi başarıyla kırıldı!");

        // Kilit açıldıktan sonra dinleyicileri yok et ki sistemi yormasın
        document.removeEventListener('click', unlockAudio);
        document.removeEventListener('touchstart', unlockAudio);
        document.removeEventListener('keydown', unlockAudio);
      } catch (err) {
        console.error("Ses kilidi açılırken hata:", err);
      }
    };

    // Kullanıcının ilk hareketini bekliyoruz
    document.addEventListener('click', unlockAudio);
    document.addEventListener('touchstart', unlockAudio);
    document.addEventListener('keydown', unlockAudio);

    return () => {
      document.removeEventListener('click', unlockAudio);
      document.removeEventListener('touchstart', unlockAudio);
      document.removeEventListener('keydown', unlockAudio);
    };
  }, []);

useEffect(() => {
  if (currentUser?.selectedOutputId) {
    // Global muhafızın okuyacağı değişkeni mühürle
    window.SESGELIO_SELECTED_OUTPUT_ID = currentUser.selectedOutputId;
  }
}, [currentUser?.selectedOutputId]);

// 🚀 İLK GİRİŞ RADARI: Sunucuya tıklandığı an odalardaki herkesi bul!
  useEffect(() => {
      if (socketRef.current && activeServerId) {
          console.log(`[RADAR] ${activeServerId} sunucusuna girildi, odalar taranıyor...`);
          // Backend'e "Bana bu sunucudaki tüm dolu odaların listesini ver" diyoruz.
          socketRef.current.emit('request-all-occupancies', { serverId: activeServerId });
      }
  }, [activeServerId]); // Adam her sunucu değiştirdiğinde tetiklenir

  useEffect(() => {
    if (theme === 'dark') document.documentElement.classList.add('dark');
    else document.documentElement.classList.remove('dark');
  }, [theme]);

// ⚡ HIZLI GEÇİŞ (QUICK SWITCHER) GLOBAL DİNLEYİCİSİ (DİNAMİK KISAYOL)
const [activeKeybind, setActiveKeybind] = useState(() => localStorage.getItem('keybind_quickSwitcher') || 'Ctrl+K');
  // 🎙️ MİKROFON KISAYOLU STATE'İ
  const [activeMuteKeybind, setActiveMuteKeybind] = useState(() => localStorage.getItem('keybind_muteToggle') || 'M');

  // Kullanıcı ayarlardan değiştirince anında haberdar olmak için
  useEffect(() => {
      const handleKeybindUpdate = (e: any) => {
          if (e.detail.type === 'quickSwitcher') {
              setActiveKeybind(e.detail.key);
          }
          if (e.detail.type === 'muteToggle') {
              setActiveMuteKeybind(e.detail.key);
          }
      };
      window.addEventListener('keybind_updated', handleKeybindUpdate);
      return () => window.removeEventListener('keybind_updated', handleKeybindUpdate);
  }, []);

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      // 1. Şu an kullanıcının atadığı tuşu analiz edelim (Örn: "Ctrl+K" veya "Shift+Space" veya "F2")
      const reqCtrl = activeKeybind.includes('Ctrl');
      const reqShift = activeKeybind.includes('Shift');
      const reqAlt = activeKeybind.includes('Alt');
      const reqCmd = activeKeybind.includes('Cmd');
      
      const parts = activeKeybind.split('+');
      const mainKeyRaw = parts[parts.length - 1]; // "K" veya "Space" vs.
      const mainKey = mainKeyRaw === 'Space' ? ' ' : mainKeyRaw.toLowerCase();

      // 2. Basılan tuşlar istenen şarta uyuyor mu?
      const isMatch = 
          (reqCtrl ? e.ctrlKey : !e.ctrlKey) &&
          (reqShift ? e.shiftKey : !e.shiftKey) &&
          (reqAlt ? e.altKey : !e.altKey) &&
          (reqCmd ? e.metaKey : !e.metaKey) &&
          e.key.toLowerCase() === mainKey;

      if (isMatch) {
        e.preventDefault(); // Tarayıcının varsayılan hareketini engelle (örn: yer işareti ekleme)
        setShowQuickSwitcher(true);
        setQuickQuery('');
        setQuickSelectedIndex(0);
      }
      
      if (e.key === 'Escape' && showQuickSwitcher) {
        setShowQuickSwitcher(false);
      }
    };

document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [showQuickSwitcher, activeKeybind]);

// 🎙️ MİKROFON KISAYOLU DİNLEYİCİSİ (HİBRİT ZIRH: WEB + MASAÜSTÜ)
  useEffect(() => {
    const handleMuteToggle = (key: string, e: any) => {
      // 1. Yazı yazarken tetiklenmesin
      if (document.activeElement instanceof HTMLInputElement || document.activeElement instanceof HTMLTextAreaElement) return;
      
      // 2. Ses kanalında değilsek hiçbir şey yapma
      if (!voiceConnected) return;

      const reqCtrl = activeMuteKeybind.includes('Ctrl');
      const reqShift = activeMuteKeybind.includes('Shift');
      const reqAlt = activeMuteKeybind.includes('Alt');
      const reqCmd = activeMuteKeybind.includes('Cmd');
 
      const parts = activeMuteKeybind.split('+');
      const mainKeyRaw = parts[parts.length - 1];
      const mainKey = mainKeyRaw === 'Space' ? ' ' : mainKeyRaw.toLowerCase();

      const isMatch =
        (reqCtrl ? e.ctrlKey : !e.ctrlKey) &&
        (reqShift ? e.shiftKey : !e.shiftKey) &&
        (reqAlt ? e.altKey : !e.altKey) &&
        (reqCmd ? e.metaKey : !e.metaKey) &&
        key.toLowerCase() === mainKey;

if (isMatch) {
        if (e.preventDefault) e.preventDefault(); // Tarayıcının varsayılan kısayollarını ez!
        if (!hasSystemMic) return; // 🚀 SİBER MÜHÜR: Mikrofon yoksa kısayol çalışmasın!
        setIsMuted(prev => !prev);
      }
    };

    // 🚀 1. MASAÜSTÜ (ELECTRON) MOTORU
    let unsubscribe: any = null;
    if ((window as any).electronAPI) {
      unsubscribe = (window as any).electronAPI.onGlobalKeyDown((key: string, code: string, e: any) => {
         handleMuteToggle(key, e);
      });
    }

    // 🚀 2. WEB (TARAYICI) MOTORU
    const handleWebKeyDown = (e: KeyboardEvent) => {
      handleMuteToggle(e.key, e);
    };

    if (!(window as any).electronAPI) {
      document.addEventListener('keydown', handleWebKeyDown);
    }

    return () => {
      if (unsubscribe) unsubscribe();
      if (!(window as any).electronAPI) {
        document.removeEventListener('keydown', handleWebKeyDown);
      }
    };
  }, [voiceConnected, activeMuteKeybind, hasSystemMic]); // 🚀 DEPENDENCY EKLENDİ


  // ⚡ HIZLI ARAMA FİLTRESİ
  const quickSearchResults = React.useMemo(() => {
    if (!quickQuery.trim()) return [];
    
    const query = quickQuery.toLowerCase();
    const results: any[] = [];

    // 1. Kişiler (DM)
    friends.forEach(f => {
        if (f.username.toLowerCase().includes(query)) {
            results.push({ type: 'dm', id: f.id, title: `@${f.username}`, subtitle: 'Özel Mesaj', icon: <UserIcon size={18} className="text-gray-400" /> });
        }
    });

    // 2. Gruplar
    groups.forEach(g => {
        if (g.name?.toLowerCase().includes(query)) {
            results.push({ type: 'group', id: g.id, title: g.name, subtitle: 'Grup Sohbeti', icon: <Users size={18} className="text-blue-500" /> });
        }
    });

    // 3. Sunucular ve Kanallar
    servers.forEach(s => {
        if (s.name.toLowerCase().includes(query)) {
            results.push({ type: 'server', id: s.id, title: s.name, subtitle: 'Sunucu', icon: <ShieldCheck size={18} className="text-sesgelio" /> });
        }
        s.channels?.forEach(c => {
            if (c.name.toLowerCase().includes(query)) {
                results.push({ 
                    type: 'channel', id: c.id, serverId: s.id, 
                    title: `#${c.name}`, subtitle: `${s.name} Sunucusu`, 
                    icon: c.type === 'voice' ? <Volume2 size={18} className="text-green-500" /> : <Hash size={18} className="text-gray-400" /> 
                });
            }
        });
    });

    // 4. Sistem Kısayolları
const shortcuts = [
    { type: 'action', id: 'settings', title: 'Kullanıcı Ayarları', subtitle: 'Sistem', icon: <Settings size={18} className="text-gray-400" /> },
    { type: 'settings-tab', id: 'account', title: 'Hesabım', subtitle: 'Ayarlar', icon: <UserIcon size={18} className="text-gray-400" /> },
    { type: 'settings-tab', id: 'market', title: 'Mağaza', subtitle: 'Ayarlar', icon: <Sparkles size={18} className="text-yellow-500" /> },
    { type: 'settings-tab', id: 'voice', title: 'Ses ve Görüntü', subtitle: 'Ayarlar', icon: <Volume2 size={18} className="text-green-500" /> },
    { type: 'settings-tab', id: 'appearance', title: 'Görünüm', subtitle: 'Ayarlar', icon: <Settings2 size={18} className="text-blue-400" /> },
    { type: 'settings-tab', id: 'notifications', title: 'Bildirimler', subtitle: 'Ayarlar', icon: <Signal size={18} className="text-orange-400" /> },
    { type: 'settings-tab', id: 'privacy', title: 'Gizlilik ve Güvenlik', subtitle: 'Ayarlar', icon: <ShieldCheck size={18} className="text-purple-500" /> },
    { type: 'settings-tab', id: 'shortcuts', title: 'Kısayollar', subtitle: 'Ayarlar', icon: <Command size={18} className="text-gray-400" /> },
    { type: 'action', id: 'discovery', title: 'Keşfet', subtitle: 'Sistem', icon: <Compass size={18} className="text-blue-400" /> },
    { type: 'action', id: 'ai', title: 'Sesgelio AI', subtitle: 'Sistem', icon: <Brain size={18} className="text-purple-500" /> }
];
    shortcuts.forEach(sh => {
        if (sh.title.toLowerCase().includes(query)) results.push(sh);
    });

    return results.slice(0, 8); // Ekrana en fazla 8 sonuç bas, kasmasın
  }, [quickQuery, friends, groups, servers]);

// ⚡ IŞINLANMA EYLEMİ (Kullanıcı Enter'a bastığında veya tıkladığında)
  const executeQuickAction = (item: any) => {
      setShowQuickSwitcher(false);
      setQuickQuery('');

      // 🚀 ÇÖZÜM MÜHRÜ: Eğer ayarlara gitmiyorsak, açık olan ayarlar sayfasını şak diye kapat!
      if (item.type !== 'action' || item.id !== 'settings') {
          setShowSettings(false); 
      }

      if (item.type === 'dm') {
          setActiveServerId('home');
          setActiveGroupId(null);
          setActiveDmId(item.id);
      } else if (item.type === 'group') {
          setActiveServerId('home');
          setActiveDmId(null);
          setActiveGroupId(item.id);
      } else if (item.type === 'server') {
          handleServerClick(item.id);
      } else if (item.type === 'channel') {
          handleServerClick(item.serverId);
          setActiveChannelId(item.id);
} else if (item.type === 'settings-tab') {
    setSettingsInitialTab(item.id as any);
    setShowSettings(true);
} else if (item.type === 'action') {
    if (item.id === 'settings') { setSettingsInitialTab('account'); setShowSettings(true); }
    else if (item.id === 'discovery') setActiveServerId('discovery');
    else if (item.id === 'ai') setActiveServerId('gemini-ai');
}
  };

  useEffect(() => {
    const handleClickOutside = () => setIsServerMenuOpen(false);
    if (isServerMenuOpen) window.addEventListener('click', handleClickOutside);
    return () => window.removeEventListener('click', handleClickOutside);
  }, [isServerMenuOpen]);

  // 🎵 YENİ: KUSURSUZ TELEFON ÇALMA (ZİL SESİ) MOTORU
  useEffect(() => {
    let ringAudio: HTMLAudioElement | null = null;
    
    // Eğer bir çağrı geliyorsa müziği başlat
    if (incomingGroupCall) {
      // Discord benzeri şık bir zil sesi (Mixkit'ten telifsiz bir ses çektik)
      ringAudio = new Audio('https://assets.mixkit.co/active_storage/sfx/2870/2870-preview.mp3');
      ringAudio.loop = true; // Adam açana kadar çalsın
      ringAudio.volume = 0.5;
      
      // Tarayıcı otomatik sesi engellemezse çal
      ringAudio.play().catch(e => console.warn("Tarayıcı otomatik zil sesini engelledi:", e));
    }
    
    // Modal kapanırsa (Kabul edilir veya Reddedilirse) müziği sustur
    return () => {
      if (ringAudio) {
        ringAudio.pause();
        ringAudio.currentTime = 0;
      }
    };
  }, [incomingGroupCall]);

// 🚀 MASAÜSTÜ DEEP LINK YAKALAYICI (KUSURSUZ ZAMANLAMA MOTORU)
  useEffect(() => {
    const electronAPI = (window as any).electronAPI ?? null;
    if (!electronAPI?.onDeepLinkInvite) return;
    
    electronAPI.onDeepLinkInvite((code: string) => {
      console.log("🚀 MASAÜSTÜ PROTOKOLÜYLE DAVET GELDİ:", code);
      // Her ihtimale karşı kodu uygulamanın derin hafızasına (cebine) atıyoruz
      localStorage.setItem('pendingInvite', code); 
      
      if (currentUserRef.current) {
          // Adam ZATEN aktifse ve oturum açıksa, sayfayı hiç yormadan şak diye sunucuya al!
          handleJoinServer(code, currentUserRef.current);
          localStorage.removeItem('pendingInvite'); // Kodu kullandıktan sonra cebi boşalt
      }
      // Eğer o an sistem adamı algılayamamışsa (veya uygulama yeni açılıyorsa) HİÇBİR ŞEY YAPMA (F5 ATMA)!
      // Uygulama kendi normal yüklemesini bitirip handleConnect motorunu çalıştırdığında, 
      // cebindeki o kodu otomatik fark edip adamı içeri sokacak!
    });
  }, []);

useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');
    const page = params.get('page');
    
    if (page === 'reset-password' && token) {
        setResetToken(token);
        // 🚀 MÜHÜR: Giriş ekranında kalsın ki arkaplanda Dashboard gözüksün ve sistem çökmesin!
        setShowLanding(true); 
        // 🚀 URL'deki uzun token yazısını silip adresi tertemiz yapar
        window.history.replaceState({}, document.title, window.location.pathname);
    }
}, []);

  const handleRefreshFriends = async () => {
    if (!currentUser) return;
    try {
        const res = await fetch(`${BACKEND_URL}/api/friends/${currentUser?.id}`);
        if (res.ok) {
            const dbFriends = await res.json();
            // KRİTİK DÜZELTME: Yerel hafızadaki botları silinmekten kurtarıyoruz
            setFriends(prev => {
                const localBots = prev.filter(f => f.isBot || f.id.startsWith('b-') || f.id.includes('-'));
                const botIds = localBots.map(b => b.id);
                const cleanDbFriends = dbFriends.filter((f: any) => !botIds.includes(f.id));
                return [...cleanDbFriends, ...localBots];
            });
        }
    } catch (e) {
        console.error("Arkadaş listesi güncellenemedi:", e);
    }
};


// 2. ANA SOKET MERKEZİ: Tüm anlık olaylar burada dönecek (ZIRHLI VERSİYON)
  useEffect(() => {
      if (!currentUser) return;
      
      // 🚀 ZIRHLI MÜHÜR 1: Soket ZATEN bağlıysa ikinci kere bağlanmasını ve kopmasını ENGELLER!
      if (!socketRef.current) {
          socketRef.current = io(SOCKET_URL, { 
              reconnection: true,
              withCredentials: true
          });
      }
      
      const socket = socketRef.current;

      const handleConnect = () => {
          socket.emit('request-all-occupancies'); 
      };

      const handleForceLogout = ({ reason }: { reason: string }) => {
          alert(reason);
          handleLogout();
      };

      const handleSyncOccupancies = (data: Record<string, User[]>) => {
          setChannelOccupancy(data);
          socket.emit('request-all-media-states');

          const newMuted: Record<string, boolean> = {};
          const newDeafened: Record<string, boolean> = {};
          const newVideo: Record<string, boolean> = {};
          const newScreen: Record<string, boolean> = {};
          
          Object.values(data).flat().forEach(u => {
              if (u.isMuted) newMuted[u.id] = true;
              if (u.isDeafened) newDeafened[u.id] = true;
              if (u.isVideoOn) newVideo[u.id] = true;
              if (u.isScreenSharing) newScreen[u.id] = true;
          });

          if (typeof setGlobalMutedUsers === 'function') setGlobalMutedUsers(prev => ({ ...prev, ...newMuted }));
          if (typeof setGlobalDeafenedUsers === 'function') setGlobalDeafenedUsers(prev => ({ ...prev, ...newDeafened }));
          if (typeof setGlobalVideoUsers === 'function') setGlobalVideoUsers(prev => ({ ...prev, ...newVideo }));
          if (typeof setGlobalScreenUsers === 'function') setGlobalScreenUsers(prev => ({ ...prev, ...newScreen }));
      };

      const handleIncomingGroupCall = (data: any) => {
          if (!activeVoiceChannel) {
              setIncomingGroupCall(data); 
          }
      };

      const handleIceCandidate = (data: { candidate: any, senderId: string }) => {
          setGlobalIceCandidates(prev => [...prev, data]);
      };

      const handleGlobalMediaUpdate = (data: { userId: string, isVideoOn: boolean, isScreenSharing: boolean }) => {
          if (data.isVideoOn !== undefined) {
              setGlobalVideoUsers(prev => ({ ...prev, [data.userId]: data.isVideoOn }));
          }
          if (data.isScreenSharing !== undefined) {
              setGlobalScreenUsers(prev => ({ ...prev, [data.userId]: data.isScreenSharing }));
          }
          
          setChannelOccupancy(prev => {
              const next = { ...prev };
              Object.keys(next).forEach(cId => {
                  next[cId] = next[cId].map(u => 
                      u.id === data.userId 
                          ? { ...u, isVideoOn: data.isVideoOn, isScreenSharing: data.isScreenSharing } 
                          : u
                  );
              });
              return next;
          });
      };

      const handleSyncMediaStates = (mediaStates: Record<string, { isVideoOn: boolean, isScreenSharing: boolean }>) => {
          setChannelOccupancy(prev => {
              const newState = { ...prev };
              Object.keys(newState).forEach(roomId => {
                  newState[roomId] = newState[roomId].map(user => {
                      if (mediaStates[user.id]) {
                          return { 
                              ...user, 
                              isVideoOn: mediaStates[user.id].isVideoOn, 
                              isScreenSharing: mediaStates[user.id].isScreenSharing 
                          };
                      }
                      return user;
                  });
              });
              return newState;
          });
      };

      const handleSubscriptionExpired = () => {
          alert("Elite/Premium paket süren doldu. Sistem seni otomatik olarak Standart pakete geçirdi.");
          setCurrentUser(prev => prev ? { 
            ...prev, 
            plan: 'standard', 
            isPremium: false, 
            isElite: false,
            subscriptionDate: undefined
          } : null);

          const saved = localStorage.getItem('saved_user_profile');
          if (saved) {
            const parsed = JSON.parse(saved);
            parsed.plan = 'standard';
            parsed.isPremium = false;
            parsed.isElite = false;
            parsed.subscriptionDate = null;
            localStorage.setItem('saved_user_profile', JSON.stringify(parsed));
          }
      };

      const handleGroupKicked = ({ groupId }: { groupId: string }) => {
          setGroups(prev => prev.filter(g => g.id !== groupId));
          if (activeGroupIdRef.current === groupId) {
              setActiveGroupId(null);
              setActiveServerId('home');
              alert("Bir operatör seni gruptan çıkardı.");
          }
      };

      const handleMemberKicked = ({ userId, serverId }: { userId: string, serverId: string }) => {
          if (currentUser && currentUser?.id === userId) {
            setServers(prev => prev.filter(s => s.id !== serverId));
            if (activeServerId === serverId) {
              setActiveServerId('home');
              setActiveChannelId(null);
            }
          if (voiceConnected) {
            handleDisconnect(); 
          }
            alert("Bu sunucudan bir operatör tarafından uzaklaştırıldın.");
          }
      };

      const handleGroupUpdated = (updatedGroup: any) => {
          setGroups(prev => prev.map(g => 
              g.id === updatedGroup.id 
                  ? { ...g, name: updatedGroup.name, iconUrl: updatedGroup.iconUrl, wallpaperUrl: updatedGroup.wallpaperUrl, purchasedWallpapers: updatedGroup.purchasedWallpapers, wallpaperBrightness: updatedGroup.wallpaperBrightness } 
                  : g
          ));
      };

      const handleGroupMembersUpdated = ({ groupId, members }: { groupId: string, members: any }) => {
          setGroups(prev => prev.map(g => 
              g.id === groupId 
                  ? { ...g, members: members } 
                  : g
          ));
      };

      const handleGroupDeleted = ({ groupId }: { groupId: string }) => {
          setGroups(prev => prev.filter(g => g.id !== groupId));
          if (activeGroupIdRef.current === groupId) {
              setActiveGroupId(null);
              setActiveServerId('home');
              alert("Kurucu bu grubu kalıcı olarak kapattı. Herkes dağıldı.");
          }
      };

      const handleGroupAdded = (newGroup: any) => {
          setGroups(prev => {
              if (prev.some(g => g.id === newGroup.id)) return prev;
              return [{ ...newGroup, unreadCount: 0 }, ...prev];
          });
      };

      const handleStatusUpdate = (data: { userId: string, status: string }) => {
          setFriends(prev => prev.map(f => f.id === data.userId ? { ...f, status: data.status as any } : f));
          setServers(prev => prev.map(server => ({
            ...server,
            members: server.members?.map(m => m.id === data.userId ? { ...m, status: data.status as any } : m)
          })));
      };

      const handleChannelCreated = (data: { serverId: string, newChannel: any }) => {
          setServers(prev => prev.map(s => {
            if (s.id === data.serverId) {
              const exists = (s.channels || []).some(c => c.id === data.newChannel.id);
              if (!exists) {
                return { ...s, channels: [...(s.channels || []), data.newChannel] }; 
              }
            }
            return s;
          }));
      };

      const handleServerUpdated = async (data: { serverId: string }) => {
          try {
            const res = await fetch(`${BACKEND_URL}/api/servers/${data.serverId}`);
            if (res.ok) {
              const freshServer = await res.json();
              const readyServer = hydrateServerData(freshServer, FULL_BOT_SET);
              
              setServers(prev => {
                return prev.map(s => {
                  if (s.id === data.serverId) {
                      return { 
                        ...s, 
                        ...readyServer, 
                        members: s.members || readyServer.members || [], 
                        bots: readyServer.bots ? JSON.parse(JSON.stringify(readyServer.bots)) : []
                      };     
                  }
                  return s;
                });
              });
            }
          } catch (e) {
            console.error("Anlık sunucu senkronizasyon hatası:", e);
          }
      };

      const handleChannelUnreadNotif = (data: { channelId: string, serverId: string, mentionedUsers: string[], senderId: string }) => {
          if (activeServerIdRef.current === data.serverId && activeChannelIdRef.current === data.channelId) return;
          if (currentUser && data.senderId === currentUser.id) return;

          const isMentioned = data.mentionedUsers.includes(currentUserRef.current?.username.toLowerCase() || '');

          setUnreadChannels(prev => ({ ...prev, [data.channelId]: true }));
          
          if (isMentioned) {
              setChannelMentions(prev => ({ ...prev, [data.channelId]: (prev[data.channelId] || 0) + 1 }));
              const savedPrefs = localStorage.getItem('user_notifications');
              const shouldPlaySound = savedPrefs ? JSON.parse(savedPrefs).sounds : true;
              if (shouldPlaySound) {
                  new Audio("https://assets.mixkit.co/active_storage/sfx/2358/2358-preview.mp3").play().catch(() => {});
              }
          }
      };

const handleServerMemberListUpdated = async (data: { serverId: string }) => {
    try {
      const res = await fetch(`${BACKEND_URL}/api/servers/${data.serverId}/members`, {
          cache: 'no-store' // 🚀 MÜHÜR: Edge tarayıcısının eski veriyi (cache) getirmesini KESİN ENGELLER!
      });
      if (res.ok) {
              const updatedMembers = await res.json();
              setServers(prev => prev.map(s => 
                s.id === data.serverId ? { ...s, members: updatedMembers } : s
              ));
            }
          } catch (e) {
            console.error("Üye listesi güncellenemedi:", e);
          }
      };

      const handleIncomingCall = (data: { signal: any, callerId: string, callerName: string, callerAvatar: string }) => {
          let tamVeKusursuzAvatar = data.callerAvatar;
          if (tamVeKusursuzAvatar && tamVeKusursuzAvatar.startsWith('/')) {
              tamVeKusursuzAvatar = `${BACKEND_URL}${tamVeKusursuzAvatar}`;
          } 
          else if (!tamVeKusursuzAvatar || tamVeKusursuzAvatar.trim() === '') {
              tamVeKusursuzAvatar = `https://ui-avatars.com/api/?name=${data.callerName}&background=random`;
          }

          setIncomingCall({
              callerId: data.callerId,
              callerName: data.callerName,
              callerAvatar: tamVeKusursuzAvatar,
              signal: data.signal
          });
      };

      const handleBotDeployed = (data: { serverId: string, channelId: string, botUser: User }) => {
          setLocalBotPositions(prev => ({ ...prev, [data.botUser.id]: data.channelId }));
          setChannelOccupancy(prev => {
              const next = { ...prev };
              Object.keys(next).forEach(cId => {
                  next[cId] = next[cId].filter(u => u.id !== data.botUser.id);
              });
              next[data.channelId] = [...(next[data.channelId] || []), data.botUser];
              return next;
          });
      };

      const handleForceRemoveBot = (botId: string) => {
          setChannelOccupancy(prev => {
              const next = { ...prev };
              Object.keys(next).forEach(cId => {
                  next[cId] = next[cId].filter(u => u.id !== botId && !String(u.id).includes('ai'));
              });
              return next;
          });
          socket.emit('request-all-occupancies');
      };

      const handleChannelOccupancyUpdate = (data: { channelId: string, users: User[] }) => {
          setChannelOccupancy(prev => {
              const next = { ...prev };
              let updatedUsers = data.users;

              if (activeVoiceChannelRef.current === data.channelId && currentUser) {
                  if (!updatedUsers.some(u => u.id === currentUser.id)) {
                      updatedUsers = [...updatedUsers, currentUser];
                  }
              }

              next[data.channelId] = updatedUsers;
              return next;
          });
      };

      const handleUserSpeakingUpdate = (data: { userId: string, isSpeaking: boolean }) => {
          setGlobalSpeakingUsers(prev => ({ ...prev, [data.userId]: data.isSpeaking }));
          const avatar = document.getElementById(`sidebar-avatar-${data.userId}`);
          if (avatar) {
              if (data.isSpeaking) {
                  avatar.classList.remove('ring-transparent');
                  avatar.classList.add('ring-green-500', 'shadow-[0_0_12px_rgba(34,197,94,0.9)]', 'scale-110', 'z-10');
              } else {
                  avatar.classList.add('ring-transparent');
                  avatar.classList.remove('ring-green-500', 'shadow-[0_0_12px_rgba(34,197,94,0.9)]', 'scale-110', 'z-10');
              }
          }
      };

      const handleUserMuteUpdate = (data: { userId: string, isMuted: boolean }) => {
          setGlobalMutedUsers(prev => ({ ...prev, [data.userId]: data.isMuted }));
          if (data.isMuted) {
              const avatar = document.getElementById(`sidebar-avatar-${data.userId}`);
              if (avatar) {
                  avatar.classList.add('ring-transparent');
                  avatar.classList.remove('ring-green-500', 'shadow-[0_0_12px_rgba(34,197,94,0.9)]', 'scale-110', 'z-10');
              }
          }
          setChannelOccupancy(prev => {
              const next = { ...prev };
              Object.keys(next).forEach(cId => {
                  next[cId] = next[cId].map(u =>
                      u.id === data.userId ? { ...u, isMuted: data.isMuted } : u
                  );
              });
              return next;
          });
      };

      const handleUserDeafenUpdate = (data: { userId: string, isDeafened: boolean }) => {
          setGlobalDeafenedUsers(prev => ({ ...prev, [data.userId]: data.isDeafened }));
          if (data.isDeafened) {
              const avatar = document.getElementById(`sidebar-avatar-${data.userId}`);
              if (avatar) {
                  avatar.classList.add('ring-transparent');
                  avatar.classList.remove('ring-green-500', 'shadow-[0_0_12px_rgba(34,197,94,0.9)]', 'scale-110', 'z-10');
              }
          }
          setChannelOccupancy(prev => {
              const next = { ...prev };
              Object.keys(next).forEach(cId => {
                  next[cId] = next[cId].map(u =>
                      u.id === data.userId ? { ...u, isDeafened: data.isDeafened } : u
                  );
              });
              return next;
          });
      };

      const handleUserProfileUpdated = (data: { userId: string, updates: any }) => {
          setFriends(prev => prev.map(f => f.id === data.userId ? { ...f, ...data.updates } : f));
          setServers(prev => prev.map(server => ({
            ...server,
            members: server.members?.map(m => m.id === data.userId ? { ...m, ...data.updates } : m)
          })));
          setChannelOccupancy(prev => {
              const next = { ...prev };
              Object.keys(next).forEach(channelId => {
                  next[channelId] = next[channelId].map(u => 
                      u.id === data.userId ? { ...u, ...data.updates } : u
                  );
              });
              return next;
          });

          setCurrentUser(prev => {
              if (!prev) return prev;
              if (prev.id === data.userId) {
                  const updated = { ...prev, ...data.updates };
                  localStorage.setItem('saved_user_profile', JSON.stringify(updated));
                  return updated;
              }
              return prev;
          });
      };

      const handleReceivePrivateMessage = (data: any) => {
          if (data.senderId === 'b-mod') return;
          if (activeDmIdRef.current !== data.senderId) {
              const savedPrefs = localStorage.getItem('user_notifications');
              const shouldPlaySound = savedPrefs ? JSON.parse(savedPrefs).sounds : true;
              if (shouldPlaySound) { 
                  const soundUrl = "https://assets.mixkit.co/active_storage/sfx/2358/2358-preview.mp3";
                  const audio = new Audio(soundUrl);
                  const outputId = currentUserRef.current?.selectedOutputId;
                  if (outputId && outputId !== 'default' && (audio as any).setSinkId) {
                      (audio as any).setSinkId(outputId)
                          .then(() => audio.play().catch(() => {}))
                          .catch(() => audio.play().catch(() => {}));
                  } else {
                      audio.play().catch(() => {});
                  }
              }

if (currentUserRef.current?.desktopNotifications === true && Notification.permission === 'granted') {
                  new Notification(`Sesgelio: ${data.senderName}`, {
                      body: data.content,
                      icon: data.senderAvatar || '/logo192.png',
                      tag: 'sesgelio-dm',
                      silent: true 
                  });
              }

              setFriends((prev: any[]) => {
                  const exists = prev.find(f => f.id === data.senderId);
                  if (!exists) {
                      handleRefreshFriends();
                      return prev;
                  }
                  return prev.map(f => {
                      if (f.id === data.senderId) {
                          return { ...f, unreadCount: (f.unreadCount || 0) + 1, isDmOpen: true };
                      }
                      return f;
                  });
              });
          } else {
              fetch(`${BACKEND_URL}/api/friends/reset-unread`, {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({ userId: currentUser?.id, friendId: data.senderId }),
              }).catch(() => {});
          }
      };

      const handleGroupMessageNotif = (data: any) => {
          if (activeGroupIdRef.current !== data.groupId) {
              setGroups(prev => prev.map(g => {
                  if (g.id === data.groupId) {
                      return { ...g, unreadCount: (g.unreadCount || 0) + 1 };
                  }
                  return g;
              }));

              const isMentioned = data.mentionedUsers && data.mentionedUsers.includes(currentUserRef.current?.username.toLowerCase() || '');
              if (isMentioned) {
                  setChannelMentions(prev => ({ ...prev, [data.groupId]: (prev[data.groupId] || 0) + 1 }));
              }
              
              const savedPrefs = localStorage.getItem('user_notifications');
              const shouldPlaySound = savedPrefs ? JSON.parse(savedPrefs).sounds : true;
              if (shouldPlaySound) { 
                  new Audio("https://assets.mixkit.co/active_storage/sfx/2358/2358-preview.mp3").play().catch(() => {});
              }
          } else {
              fetch(`${BACKEND_URL}/api/groups/${data.groupId}/reset-unread`, {
                  method: 'POST',
              }).catch(() => {});
          }
      };

      const handleFriendRequestAccepted = () => handleRefreshFriends();
      const handleFriendRequestDeclined = () => handleRefreshFriends();
      const handleNewFriendRequest = () => handleRefreshFriends();
      const handleFriendshipUpdated = () => handleRefreshFriends();

      // Soket dinleyicilerini isimlendirilmiş şekilde bağlıyoruz
      socket.on('connect', handleConnect);
      socket.on(`force-logout-${currentUser?.id}`, handleForceLogout);
      socket.on('sync-all-occupancies', handleSyncOccupancies);
      socket.on(`incoming-group-call-${currentUser?.id}`, handleIncomingGroupCall);
      socket.on(`ice-candidate-${currentUser?.id}`, handleIceCandidate);
      socket.on('global-media-update', handleGlobalMediaUpdate);
      socket.on('sync-all-media-states', handleSyncMediaStates);
      socket.on(`subscription-expired-${currentUser?.id}`, handleSubscriptionExpired);
      socket.on(`group-kicked-${currentUser?.id}`, handleGroupKicked);
      socket.on('member-kicked', handleMemberKicked);
      socket.on('group-updated', handleGroupUpdated);
      socket.on('group-members-updated', handleGroupMembersUpdated);
      socket.on('group-deleted', handleGroupDeleted);
      socket.on(`group-added-${currentUser?.id}`, handleGroupAdded);
      socket.on('status-update', handleStatusUpdate);
      socket.on('channel-created', handleChannelCreated);
      socket.on('server-updated', handleServerUpdated);
      socket.on('channel-unread-notification', handleChannelUnreadNotif);
      socket.on('server-member-list-updated', handleServerMemberListUpdated);
      socket.on(`incoming-call-${currentUser?.id}`, handleIncomingCall);
      socket.on('bot-deployed', handleBotDeployed);
      socket.on('force-remove-bot', handleForceRemoveBot);
      socket.on('channel-occupancy-update', handleChannelOccupancyUpdate);
      socket.on('user-speaking-update', handleUserSpeakingUpdate);
      socket.on('user-mute-update', handleUserMuteUpdate);
      socket.on('user-deafen-update', handleUserDeafenUpdate);
      socket.on('user-profile-updated', handleUserProfileUpdated);
      socket.on(`receive-private-message-${currentUser?.id}`, handleReceivePrivateMessage);
      socket.on(`group-message-notification-${currentUser?.id}`, handleGroupMessageNotif);
      socket.on(`friend-request-accepted-${currentUser?.id}`, handleFriendRequestAccepted);
      socket.on(`friend-request-declined-${currentUser?.id}`, handleFriendRequestDeclined);
      socket.on(`new-friend-request-${currentUser?.id}`, handleNewFriendRequest);
      socket.on(`friendship-updated-${currentUser?.id}`, handleFriendshipUpdated);

      // Sadece çıkış yapıldığında (veya bileşen tamamen öldüğünde) dinleyicileri kaldırır.
      // Her `currentUser` değişikliğinde soketi kopartmaz!
      return () => {
          socket.off('connect', handleConnect);
          socket.off(`force-logout-${currentUser?.id}`, handleForceLogout);
          socket.off('sync-all-occupancies', handleSyncOccupancies);
          socket.off(`incoming-group-call-${currentUser?.id}`, handleIncomingGroupCall);
          socket.off(`ice-candidate-${currentUser?.id}`, handleIceCandidate);
          socket.off('global-media-update', handleGlobalMediaUpdate);
          socket.off('sync-all-media-states', handleSyncMediaStates);
          socket.off(`subscription-expired-${currentUser?.id}`, handleSubscriptionExpired);
          socket.off(`group-kicked-${currentUser?.id}`, handleGroupKicked);
          socket.off('member-kicked', handleMemberKicked);
          socket.off('group-updated', handleGroupUpdated);
          socket.off('group-members-updated', handleGroupMembersUpdated);
          socket.off('group-deleted', handleGroupDeleted);
          socket.off(`group-added-${currentUser?.id}`, handleGroupAdded);
          socket.off('status-update', handleStatusUpdate);
          socket.off('channel-created', handleChannelCreated);
          socket.off('server-updated', handleServerUpdated);
          socket.off('channel-unread-notification', handleChannelUnreadNotif);
          socket.off('server-member-list-updated', handleServerMemberListUpdated);
          socket.off(`incoming-call-${currentUser?.id}`, handleIncomingCall);
          socket.off('bot-deployed', handleBotDeployed);
          socket.off('force-remove-bot', handleForceRemoveBot);
          socket.off('channel-occupancy-update', handleChannelOccupancyUpdate);
          socket.off('user-speaking-update', handleUserSpeakingUpdate);
          socket.off('user-mute-update', handleUserMuteUpdate);
          socket.off('user-deafen-update', handleUserDeafenUpdate);
          socket.off('user-profile-updated', handleUserProfileUpdated);
          socket.off(`receive-private-message-${currentUser?.id}`, handleReceivePrivateMessage);
          socket.off(`group-message-notification-${currentUser?.id}`, handleGroupMessageNotif);
          socket.off(`friend-request-accepted-${currentUser?.id}`, handleFriendRequestAccepted);
          socket.off(`friend-request-declined-${currentUser?.id}`, handleFriendRequestDeclined);
          socket.off(`new-friend-request-${currentUser?.id}`, handleNewFriendRequest);
          socket.off(`friendship-updated-${currentUser?.id}`, handleFriendshipUpdated);
          socket.disconnect();
      };
  }, [currentUser?.id]); // Kullanıcı giriş yaptığında dinleyicileri kurar; socket zaten bağlıysa yeniden oluşturmaz.


const hydrateBotData = (serversFromDB: any[]) => {
  return serversFromDB.map(server => ({
    ...server,
    bots: server.bots?.map((dbBot: any) => {
      // Veritabanındaki botId'yi (örn: 'b-music') FULL_BOT_SET'de bul 
      const meta = FULL_BOT_SET.find(b => b.id === (dbBot.botId || dbBot.id));
      return {
        ...dbBot,
        name: meta?.name || 'Bilinmeyen Bot',
        avatarUrl: meta?.avatarUrl || '',
        description: meta?.description || '',
        bannerUrl: meta?.bannerUrl || '',
        active: dbBot.active ?? true
      };
    })
  }));
};

const handleConnect = async () => {
    let savedProfile: Partial<User> = {};
    try {
      const savedData = localStorage.getItem('saved_user_profile');
      if (savedData) savedProfile = JSON.parse(savedData);
    } catch (e) {
      console.error("Yerel profil okunurken hata:", e);
    }

    if (!savedProfile.id) return;

    try {
      // 1. Sunucuları çekiyoruz (Artık backend'den üyelerle birlikte tam paket geliyor)
      const serverRes = await fetch(`${BACKEND_URL}/api/users/${savedProfile.id}/servers`);
      
      if (serverRes.ok) {
        const dbServers = await serverRes.json();

        // 2. VERİ GİYDİRME: Backend'den gelen her şeyi koruyarak botları ve rolleri düzeltiyoruz
        const hydratedServers = dbServers.map((server: any) => ({
          ...server, // Üye listesi (members) ve rol listesi burada içeri giriyor
          
          // Rollerin izinlerini diziye çeviriyoruz (Yetki kontrolü için bu şart!)
          roles: server.roles?.map((role: any) => ({
            ...role,
            permissions: typeof role.permissions === 'string' 
              ? (role.permissions.startsWith('[') ? JSON.parse(role.permissions) : role.permissions.split(','))
              : (Array.isArray(role.permissions) ? role.permissions : [])
          })),

          // Botları giydirip numaralandırıyoruz
          bots: server.bots?.map((dbBot: any) => {
            const botId = dbBot.botId || dbBot.id;
            const meta = FULL_BOT_SET.find(b => b.id === botId);
            const sameTypeBots = server.bots.filter((b: any) => (b.botId || b.id) === botId);
            const instanceIndex = sameTypeBots.findIndex((b: any) => b.id === dbBot.id) + 1;

            return {
              ...dbBot,
              instanceId: dbBot.id,
              name: sameTypeBots.length > 1 ? `${meta?.name || 'Bot'} #${instanceIndex}` : (meta?.name || 'Bot'),
              avatarUrl: meta?.avatarUrl || '',
              description: meta?.description || 'Sesgelio Yardımcı Bot',
              bannerUrl: meta?.bannerUrl || '',
              active: dbBot.active ?? true
            };
          })
        }));

        setServers(hydratedServers);
      }

      // 3. Arkadaş listesini çekelim
      const friendRes = await fetch(`${BACKEND_URL}/api/friends/${savedProfile.id}`);
      if (friendRes.ok) {
        const dbFriends = await friendRes.json();
        setFriends(dbFriends);
      }

    // 3.5. 🚀 Grupları çekelim
      try {
        const groupRes = await fetch(`${BACKEND_URL}/api/groups/${savedProfile.id}`, {
          
        });
        if (groupRes.ok) {
          const dbGroups = await groupRes.json();
          // 🚀 GRUP SAYACINI ANA OBJEYE ÇIKAR (Kırmızı balon için)
          const formattedGroups = dbGroups.map((g: any) => {
             const myMember = g.members.find((m: any) => m.userId === savedProfile.id);
             return { ...g, unreadCount: myMember?.unreadCount || 0 };
          });
          setGroups(formattedGroups);
        }
      } catch (err) { console.error("Gruplar çekilemedi:", err); }

      // 🚀 KALICI BİLDİRİMLERİ (UNREAD/MENTION) ÇEK VE HAFIZAYA YAZ
      try {
          const notifRes = await fetch(`${BACKEND_URL}/api/users/${savedProfile.id}/notifications`);
          if (notifRes.ok) {
              const dbNotifs = await notifRes.json();
              const unreads: Record<string, boolean> = {};
              const mentions: Record<string, number> = {};
              dbNotifs.forEach((n: any) => {
                  if (n.type === 'UNREAD') unreads[n.channelId] = true;
                  if (n.type === 'MENTION') mentions[n.channelId] = n.count;
              });
              setUnreadChannels(unreads);
              setChannelMentions(mentions);
          }
      } catch (err) { console.error("Kalıcı Bildirimler çekilemedi:", err); }

     // 🚀 KLASÖRLERİ VERİTABANINDAN ÇEK (ZIRHLI YÜKLEME)
  try {
    const folderRes = await fetch(`${BACKEND_URL}/api/folders`);
     if (folderRes.ok) {
       const dbFolders = await folderRes.json();
      setServerFolders(dbFolders);
     } else {
       // Veritabanı boşsa yerel hafızadan kurtarmayı dene
     const saved = localStorage.getItem('sesgelio_folders');
      if (saved) setServerFolders(JSON.parse(saved));
     }
   } catch (err) { 
     const saved = localStorage.getItem('sesgelio_folders');
     if (saved) setServerFolders(JSON.parse(saved));
   } finally {
     setIsFoldersLoaded(true); // Veriler yüklendi, artık kaydetme motoru çalışabilir
   }

    // 4. GERÇEK VE GÜVENLİ PROFİLİ ÇEK (MÜHÜR BURADA)
      try {
        const profileRes = await fetch(`${BACKEND_URL}/api/users/${savedProfile.id}/profile`);
        if (profileRes.ok) {
          const freshUser = await profileRes.json();
          savedProfile = freshUser; // F12'den değiştirilen sahte veriyi, veritabanındaki gerçek veriyle eziyoruz!
          localStorage.setItem('saved_user_profile', JSON.stringify(freshUser)); // Hafızayı da doğrusuyla güncelliyoruz.
        }
      } catch (err) {
        console.warn("Profil doğrulanırken hata oluştu, yerel veriyle devam ediliyor.");
      }

// 5. Giriş başarılı, ana sayfaya yönlendir (Tema ayarların korundu)
      setCurrentUser(savedProfile as User);
      if ((savedProfile as any).theme) {
        setTheme((savedProfile as any).theme as 'dark' | 'light');
      }
      setShowLanding(false);
      setActiveServerId('home');
      setPulseActivities(DEFAULT_PULSE_ACTIVITIES);

      // 🚀 IŞINLANMA MOTORU 3 (FİNAL): Her şey yüklendi! Cebimizde davet kodu var mı bakıyoruz!
      const pendingInvite = localStorage.getItem('pendingInvite');
      if (pendingInvite) {
          // Kodu hafızadan sil ki sürekli aynı sunucuya girmesin
          localStorage.removeItem('pendingInvite');
          console.log("🚀 IŞINLANMA AKTİF: Davet koduyla sunucuya giriliyor!");
          // Motoru ateşle!
          await handleJoinServer(pendingInvite, savedProfile as User);
      }

      // 🚀 IŞINLANMA MOTORU 4 (ÖDEME DÖNÜŞÜ): Eğer tam ekranda ödeme yapıp döndüyse kutlamayı başlat!
      const pendingSuccess = localStorage.getItem('pending_success_product');
      if (pendingSuccess) {
          setSettingsInitialTab('market'); // Market sekmesini hazırla
          setShowSettings(true); // Ayarlar penceresini şak diye aç!
          
          // Pencere açıldıktan yarım saniye sonra kutlama animasyonunu ateşle!
          setTimeout(() => {
              window.dispatchEvent(new CustomEvent('trigger-success-overlay', { 
                  detail: { 
                      id: pendingSuccess, 
                      serverId: localStorage.getItem('pending_success_server') 
                  } 
              }));
              localStorage.removeItem('pending_success_product');
              localStorage.removeItem('pending_success_server');
          }, 800); 
      }

if (localStorage.getItem('pending_failed_payment')) {
                  setSettingsInitialTab('billing');
                  setShowSettings(true);
                  setTimeout(() => {
                      alert("Banka işlemi reddetti veya ödeme tamamlanamadı. Lütfen kart bilgilerinizi kontrol edin.");
                      localStorage.removeItem('pending_failed_payment');
                  }, 500);
              }

              // 🚀 ZOMBİ İMHA MÜHRÜ: F5 atılmışsa eski ses bağlantısından temiz ve güvenli bir şekilde koparıldığımızı garanti edelim
              setTimeout(() => {
                  if (savedProfile && socketRef.current) {
                      socketRef.current.emit('request-all-occupancies');
                  }
              }, 1000);

          } catch (error) {
              console.error("Sunucuya ulaşılamıyor. Güvenlik gereği oturum açılmadı.");
              // Sahte verilerle uygulamaya girilmesini kesin olarak engelle:
              localStorage.removeItem('saved_user_profile');
      setCurrentUser(null);
      setShowLanding(true); // Kesinlikle giriş ekranında tut!
    }
  };
  
 const handleAcceptCall = (withVideo: boolean) => {
      if (!incomingCall) return;
      
      const callerId = incomingCall.callerId;
      const signal = incomingCall.signal;

      // 1. Arama ekranını (modalı) anında kapat
      setIncomingCall(null);

      // 2. Kişiyi listeye ekle veya DMsini aç
      const existingFriend = friends.find(f => f.id === callerId);
      if (!existingFriend) { 
          const newFriend: Friend = { id: callerId, username: incomingCall.callerName, avatarUrl: incomingCall.callerAvatar, status: 'online', relationship: 'none', isDmOpen: true };
          setFriends(prev => [...prev, newFriend]); 
      } else { 
          setFriends(prev => prev.map(f => f.id === callerId ? { ...f, isDmOpen: true } : f));
      }
      
      // 3. Sinyali pakete sar ve DM ekranına geçiş yap!
      setActiveCallSignal({ callerId, signal });
      setActiveServerId('home'); 
      setActiveDmId(callerId); 
  };

const handleDeclineCall = () => {
      // 🚀 ARAYANA "MEŞGULE ATILDI/REDDEDİLDİ" SİNYALİNİ GÖNDER!
      if (incomingCall && socketRef.current && currentUser) {
          socketRef.current.emit('end-call', { 
              to: incomingCall.callerId, 
              senderId: currentUser?.id 
          });
      }
      setIncomingCall(null); // Kendi ekranından modalı sil
  };

  // =================================================================
  // 👑 GOD MODE (KURUCU BASKINI) DİNLEYİCİSİ VE IŞINLAYICISI
  // =================================================================
  useEffect(() => {
    const handleGodMode = async (event: any) => {
      const targetServerId = event.detail;
      if (!currentUser) return;

      // 🛡️ SİBER MÜHÜR: Konsoldan tetiklemelere karşı ekstra kilit!
      if ((currentUser as any).role !== 'FOUNDER' && (currentUser as any).role !== 'ADMIN') {
          console.warn("🚨 Siber Kalkan: God Mode için yetkiniz yok!");
          return;
      }

      try {
        // 1. Sunucunun en güncel (ve senin admin olduğun) halini backend'den zorla çekiyoruz
        const res = await fetch(`${BACKEND_URL}/api/servers/${targetServerId}`, {
          
        });
        
        if (res.ok) {
          const freshServer = await res.json();
          // Botları ve rolleri formata sok (Giydir)
          const readyServer = hydrateServerData(freshServer, FULL_BOT_SET);

          // 2. Sunucuyu sol menü (servers state) içine zorla ekle
          setServers(prev => {
            const exists = prev.find(s => s.id === targetServerId);
            if (!exists) return [...prev, readyServer]; // Daha önce yoksan listeye ekle
            return prev.map(s => s.id === targetServerId ? readyServer : s); // Varsan güncelle
          });

          // 3. ŞİMŞEK GİBİ IŞINLANMA EFEKTİ
          setActiveServerId(targetServerId);
          setActiveGroupId(null);
          setActiveDmId(null);
          
          // İlk metin kanalını bul ve oraya odaklan
          if (readyServer.channels && readyServer.channels.length > 0) {
            const firstText = readyServer.channels.find((c: any) => c.type === 'text');
            setActiveChannelId(firstText ? firstText.id : readyServer.channels[0].id);
          }

          // 4. Socket'e "Patron İçeri Girdi" sinyalini yolla
          if (socketRef.current) {
            socketRef.current.emit('join-room', { roomId: `server-${targetServerId}`, user: currentUser });
            socketRef.current.emit('request-all-occupancies');
          }
        }
      } catch (err) {
        console.error("God Mode ışınlanma hatası:", err);
      }
    };

    // Dinleyiciyi React'e monte et
    window.addEventListener('god-mode-activated', handleGodMode);
    
    // Component silinirse dinleyiciyi temizle
    return () => window.removeEventListener('god-mode-activated', handleGodMode);
  }, [currentUser]);

const handleLogin = async (arg1?: any, arg2?: string) => {

if (arg1 && arg1.mfaRequired) {
        setTempUserId(arg1.userId);
        setShow2FALogin(true);
        return; // Normal giriş işlemlerini durdur, kodu beklemeye geç
    }

    let email = "";
    let password = "";
    let isGoogleAuth = false; // 🚀 YENİ MÜHÜR: Bu bir Google girişi mi?

    // 1. Veri Formatını Kontrol Et
    if (typeof arg1 === 'object' && arg1 !== null) {
        // Eğer arg1 içinde access_token varsa, bu adam Google ile gelmiştir!
        if (arg1.access_token) {
            isGoogleAuth = true;
        } else {
            email = arg1.email;
            password = arg1.password;
        }
    } else if (typeof arg1 === 'string') {
        email = arg1;
        password = arg2 || "";
    }

    // 2. GOOGLE İLE GİRİŞ ROTASI
    if (isGoogleAuth) {
        try {
            const res = await fetch(`${BACKEND_URL}/api/auth/google`, {
                method: 'POST',
                // Interceptor'umuz zaten Content-Type'ı ve credentials'i ekliyor
                body: JSON.stringify({ access_token: arg1.access_token })
            });

            const data = await res.json();

            if (!res.ok) {
                alert(data.error || "Google ile giriş başarısız oldu .");
                return;
            }

            if (data.user) {
                // Giriş başarılı, Backend çerezi tarayıcıya mühürledi
                setCurrentUser(data.user);
                localStorage.setItem('saved_user_profile', JSON.stringify(data.user));
                setShowLanding(false);
                handleConnect();
            }
        } catch (e) {
            console.error("Google Köprü Hatası:", e);
            alert("Google sunucularına ulaşılamadı nöral dostum.");
        }
        return; // İşlem bitti, aşağı inme.
    }

    // 3. NORMAL (E-POSTA/ŞİFRE) GİRİŞ ROTASI
    if (email && password) {
      try {
        const res = await fetch(`${BACKEND_URL}/api/login`, {
          method: 'POST',
          body: JSON.stringify({ email, password })
        });
        
        const data = await res.json();

        // 🚀 1. SİBER KİLİT: BACKEND "MÜHÜR YOK" DİYORSA HATAYI FIRLAT!
        if (data.requiresVerification || res.status === 403) {
            throw { message: data.error, requiresVerification: true };
        }

        if (data.mfaRequired) {
          // --- 🛡️ 2FA (MÜHÜR) GEREKLİ ---
          setTempUserId(data.userId); 
          setShow2FALogin(true);      
          return; 
        } else if (data.user) { // 🚀 ÇELİK ZIRH
          // Normal giriş başarılı
          setCurrentUser(data.user);
          localStorage.setItem('saved_user_profile', JSON.stringify(data.user));
          setShowLanding(false);
          handleConnect(); 
          return;
        } else {
          alert(data.error || "Giriş mührü tutmadı nöral dostum!");
          return;
        }
      } catch (e: any) {
        if (e.requiresVerification) {
            throw e; 
        }
        alert("Sesgelio sunucusuna ulaşılamıyor .");
        return;
      }
    }

    // 4. Bilgiler Yoksa (Sadece Sayfa Yenilenmişse) -> Otomatik Giriş
    handleConnect(); 
};
const handleUpdateUser = async (updatedData: Partial<User>) => { 
    if (currentUser) {
      const safeData = { ...updatedData };
        delete (safeData as any).isElite;
        delete (safeData as any).isPremium;
        delete (safeData as any).plan;
        
        try {
            // 1. Backend'e fırlat (MySQL'e yazılması için)
            const response = await fetch(`${BACKEND_URL}/api/users/${currentUser?.id}`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(safeData)
            });

            // 🛡️ 1. MÜHÜR: BACKEND ONAYLADI MI? (HATA FIRLATICISI BURADA)
            if (!response.ok) {
                const errorData = await response.json();
                // Eğer backend (server.js) bu işlemi yasakladıysa (örn: hileli çerçeve seçimi),
                // anında bir HATA (Error) oluşturup onu aşağı fırlatıyoruz!
                throw new Error(errorData.error || "Backend bu işleme izin vermedi nöral dostum!");
            }

            // 2. BACKEND ONAYLADIYSA: State'i ve Yerel Hafızayı (LocalStorage) güncelle
            const savedUserFromDB = await response.json();
            const newUser = { ...currentUser, ...savedUserFromDB };
            setCurrentUser(newUser); 
            
            // Sunuculardaki üye listelerinde de görselini anlık güncelle
            setServers(prev => prev.map(server => ({ 
                ...server, 
                members: server.members?.map(member => 
                    member.id === newUser.id ? { ...member, ...updatedData } : member
                ) 
            })));

            // 🚀 Kendi ekranımdaki ses odasında avatarımı ve çerçeveni anında değiştir
            setChannelOccupancy(prev => {
                const next = { ...prev };
                Object.keys(next).forEach(channelId => {
                    next[channelId] = next[channelId].map(u => 
                        u.id === newUser.id ? { ...u, ...updatedData } : u
                    );
                });
                return next;
            });

            localStorage.setItem('saved_user_profile', JSON.stringify(newUser));

            // 3. Socket üzerinden diğer operatörlere "profilim değişti" sinyali gönder
            socketRef.current?.emit('user-profile-updated', { userId: newUser.id, updates: updatedData });
            
        } catch (error: any) {
            // 🛡️ 2. MÜHÜR: HATA BURAYA DÜŞTÜ!
            console.error("Profil senkronizasyon hatası:", error);
            
            // Kullanıcıya sessiz kalmayıp, backend'den gelen o sert uyarıyı (veya genel hatayı) gösteriyoruz.
            alert(error.message || "Backend bağlantısında bir sorun oluştu nöral dostum!");
            
            // 🚀 3. MÜHÜR: Hatayı (bombayı) UserSettings.tsx'in içine geri fırlat!
            // Böylece UserSettings, "İşlem başarılı" sanıp ekrana yanlış bilgi basmaz.
            throw error; 
        }
    }
};
// 🚀 GÜVENLİ VE LOGLU ÇIKIŞ YAPMA MOTORU
const handleLogout = async () => {
    // 1. BACKEND'E SİNYAL GÖNDER (Çerezi temizlemek için)
    try {
        await fetch(`${BACKEND_URL}/api/logout`, {
            method: 'POST'
        });
    } catch (error) {
        console.error("Çıkış loglanırken hata:", error);
    } 

    // 2. SOKET VE SES BAĞLANTILARINI KOPAR
    if (currentUser) {
        socketRef.current?.emit('logout');
        socketRef.current?.disconnect();
    }
    if (activeVoiceChannel && typeof handleDisconnect === 'function') {
        handleDisconnect();
    }
    
    // 3. YEREL HAFIZAYI TEMİZLE (KUSURSUZ TEMİZLİK)
    sessionStorage.clear(); 
    localStorage.removeItem('saved_user_profile'); 
    
    // 4. KAPI DIŞARI ET (Hard Reload)
    window.location.href = "/"; 
};
  const handleOpenMarket = (botId?: string) => { setShowServerSettingsModal(false); setShowLeaderboardModal(false); setSettingsInitialTab('market'); setShowSettings(true); };

  const handleServerClick = async (serverId: string) => {
    setIsMobileDrawerOpen(false);
    setActiveServerId(serverId);
    setIsServerMenuOpen(false);
    setActiveGroupId(null);

    if (serverId === 'home') {
        setActiveChannelId(null);
    }

   if (serverId !== 'home' && serverId !== 'discovery' && serverId !== 'gemini-ai') {
       // setActiveDmId(null); // 🚀 MÜHÜR 1: Sayfa değişince hafızadan silinmesin diye yoruma alındı
       
      // 1. Backend'e odaya girdiğini bildir (Canlı yayın hattı)
       if (socketRef.current && currentUser) { 
           socketRef.current.emit('join-room', { roomId: `server-${serverId}`, user: currentUser }); 
           // 🚀 HAYALET KASABA FİXİ: Adam sunucuya girdiği milisaniyede, odaların anlık listesini çek!
           socketRef.current.emit('request-all-occupancies');
       }
       // 2. KRİTİK: Sağ barı ve mesajları besleyen üye listesini MySQL'den çek
       try {
           const res = await fetch(`${BACKEND_URL}/api/servers/${serverId}/members`);
           if (res.ok) {
               const dbMembers = await res.json();
               
               // 🚀 FİX: Sağ barda (kendi profilimizde) "çevrimdışı" kalma sorununu çözüyoruz.
               // Kendi profilimiz gelirse anında 'online' yapıyoruz.
               const updatedMembers = dbMembers.map((m: any) => 
                   (currentUser && m.id === currentUser?.id) ? { ...m, status: 'online' } : m
               );

               // Servers state'ini güncelle ki sağ bar anında dolsun
               setServers(prev => hydrateBotData(prev.map(s =>
                   s.id === serverId ? { ...s, members: updatedMembers } : s
              )));
           }
       } catch (e) {
           console.error("Üye listesi senkronize edilemedi:", e);
       }

     // 3. İlk kanala otomatik odaklan
       const targetServer = (servers || []).find(s => s.id === serverId);
    if (targetServer?.channels && targetServer.channels.length > 0) { // ?. ve kontrol ekledik
       const firstText = targetServer.channels.find(c => c.type === 'text');
       const autoChannelId = firstText ? firstText.id : targetServer.channels[0].id;
       setActiveChannelId(autoChannelId); 

       // 🚀 GİZLİ BEYAZ NOKTA İMHA MÜHRÜ:
       // Sunucuya tıklandığında otomatik açılan o ilk kanalın bildirimlerini de şak diye siliyoruz!
       setUnreadChannels(prev => {
         const next = { ...prev };
         delete next[autoChannelId];
         return next;
       });

       setChannelMentions(prev => {
         const next = { ...prev };
         delete next[autoChannelId];
         return next;
       });

       if (currentUser) {
           fetch(`${BACKEND_URL}/api/channels/${autoChannelId}/read`, { 
               method: 'POST' 
           }).catch(() => {});
       }
    }
  }
};
  const handleLeaveServer = (serverId: string) => { const targetServer = servers.find(s => s.id === serverId); if (targetServer) { setServerToLeave({ id: serverId, name: targetServer.name }); } };
  const confirmLeaveServer = async () => {
  if (serverToLeave && currentUser) {
    try {
      const response = await fetch(`${BACKEND_URL}/api/servers/leave`, {
        method: 'DELETE',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ userId: currentUser?.id, serverId: serverToLeave.id }),
      });

      if (response.ok) {
        // Ekrandan sil
        setServers(prev => prev.filter(s => s.id !== serverToLeave.id));
        // Eğer o sunucudaysan evine dön
        if (activeServerId === serverToLeave.id) setActiveServerId('home');
        setServerToLeave(null);
      }
    } catch (e) { console.error("Ayrılma hatası:", e); }
  }
};
  const handlePulseJoin = async (serverId: string) => {
  if (!currentUser) return;

  // 1. Kullanıcı zaten üye mi kontrol et
  const alreadyMember = servers.find(s => s.id === serverId);
  if (alreadyMember) {
    handleServerClick(serverId);
    return;
  }

  try {
    // 2. Backend'e "beni bu sunucuya ekle ve verileri ver" de
    const response = await fetch(`${BACKEND_URL}/api/servers/join`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ userId: currentUser?.id, serverId: serverId }),
    });

    if (response.ok) {
      const serverDataFromDB = await response.json(); // Backend'den gelen tam paket

      // 3. State'i güncelle: Sunucuyu listeye ekle
      setServers(prev => {
        // Eğer listede zaten yoksa ekle (güvenlik önlemi)
        if (!prev.find(s => s.id === serverDataFromDB.id)) {
          return [...prev, serverDataFromDB];
        }
        return prev;
      });
      
      // 4. Sunucuya anlık geçiş yap
      handleServerClick(serverDataFromDB.id);
    } else {
      alert("Sunucuya katılamadın .");
    }
  } catch (error) {
    console.error("Sunucuya katılırken hata oluştu:", error);
  }
};

const handleBanMember = async (targetUserId: string) => {
  const reason = window.prompt("Yasaklanma sebebi nedir ?");
  if (reason === null) return false;
  const res = await fetch(`${BACKEND_URL}/api/servers/${activeServerId}/bans/${targetUserId}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ reason }) // Sadece nedeni yolla, kim olduğunu Backend Token'dan bulacak!
  });
  return res.ok;
};

const handleBotPurchase = async (serverId: string, botData: any) => {
  // Çoklu alınabilen botların ID listesi
  const MULTI_INSTANCE_BOTS = ['b-ai', 'b-music'];
  
  const targetServer = servers.find(s => s.id === serverId);
  if (!targetServer) return;

  // 1. Tekil bot kontrolü (Eğer AI veya Müzik botu değilse sunucuda 1 tane olabilir)
  if (!MULTI_INSTANCE_BOTS.includes(botData.id)) {
    const alreadyHasBot = targetServer.bots?.some(b => (b.botId || b.id) === botData.id);
    if (alreadyHasBot) {
      alert("Bu operatör zaten bu sunucuda görev başında !");
      return;
    }
  }

  try {
   const res = await fetch(`${BACKEND_URL}/api/servers/${serverId}/bots/add`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      // 🚀 MÜHÜR: Kiralama mı sınırsız mı bilgisini Backend'e fırlatıyoruz!
      body: JSON.stringify({ 
          botId: botData.id, 
          isRentalPurchase: botData.isRentalPurchase 
      }),
    });

    if (res.ok) {
      // 2. Sunucunun güncel halini çek
      const updatedServerRes = await fetch(`${BACKEND_URL}/api/servers/${serverId}`);
      if (updatedServerRes.ok) {
        const freshServer = await updatedServerRes.json();

        // 3. Giydirme ve Numaralandırma Mantığı
        const hydratedBots = freshServer.bots?.map((dbBot: any) => {
          const botId = dbBot.botId || dbBot.id;
          const meta = FULL_BOT_SET.find(b => b.id === botId);
          
          // Aynı tipteki tüm botları bul (Sıralama yapmak için)
          const sameTypeBots = freshServer.bots.filter((b: any) => (b.botId || b.id) === botId);
          
          // Bu botun aynı tipler arasındaki sırasını bul (+1 ile 1'den başlasın)
          const instanceIndex = sameTypeBots.findIndex((b: any) => b.id === dbBot.id) + 1;

          return {
            ...dbBot,
            instanceId: dbBot.id, // Veritabanındaki benzersiz CUID
            // Eğer aynı bottan birden fazla varsa numara ekle, yoksa düz isim kalsın
            name: sameTypeBots.length > 1 
              ? `${meta?.name || botId} #${instanceIndex}` 
              : (meta?.name || botId),
            avatarUrl: meta?.avatarUrl || '',
            description: meta?.description || 'Sesgelio Yardımcı Bot',
            bannerUrl: meta?.bannerUrl || '',
            active: dbBot.active ?? true
          };
        });

        // 4. Rolleri de güvenli hale getiriyoruz (Hata almamak için)
        const completeServer = { 
          ...freshServer, 
          bots: hydratedBots,
          roles: freshServer.roles?.map((r: any) => ({
            ...r,
            permissions: typeof r.permissions === 'string' ? r.permissions.split(',') : (Array.isArray(r.permissions) ? r.permissions : [])
          }))
        };

        // 5. State'i güncelle
        setServers(prev => prev.map(s => s.id === serverId ? completeServer : s));
      }
      
      alert(`${botData.name} başarıyla mühürlendi !`);
    } else {
      const errorData = await res.json();
      alert(errorData.error || "Bot eklenemedi.");
    }
  } catch (error) {
    console.error("Bot ekleme hatası:", error);
  }
};
 const playJoinSound = () => {
    try {
      const saved = localStorage.getItem('user_notifications');
      const shouldPlay = saved ? JSON.parse(saved).sounds : true;
      if (shouldPlay) { 
          // 🚀 Eski internet linkini çöpe attık, kendi klasörümüzdeki sesi çekiyoruz
          const audio = new Audio('/sounds/join.mp3'); 
          audio.volume = 0.4;
          audio.loop = false; 
          audio.play().catch(e => console.warn('Ses çalma engellendi:', e)); 
      }
    } catch (e) { 
        console.error(e);
    }
};

// 🚀 YENİ MÜHÜR: MİKROFON İZNİ KONTROLCÜSÜ (KAPI GÖREVLİSİ)
  const ensureMicrophonePermission = async (onSuccess: () => void) => {
      try {
          const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
          stream.getTracks().forEach(track => track.stop());
          setHasSystemMic(true); // 🚀 Mikrofon var, sorun yok
          onSuccess();
      } catch (err) {
          console.warn("Mikrofon izni reddedildi:", err);
          setHasSystemMic(false); // 🚀 Mikrofon yok!
          setIsMuted(true); // 🚀 SİBER MÜHÜR: Mikrofon olmadığı için sistemi direkt "Susturulmuş" moduna kilitle!
          onSuccess();
      }
  };

const handleChannelClick = (channel: Channel) => {
  setIsMobileDrawerOpen(false);
  
  if (channel.type === 'voice') {
    const canConnect = isServerOwner ||
        (memberRole?.permissions.some(p => ['ADMIN', 'CONNECT'].includes(p)) || false);
    
    if (!canConnect) {
      alert("Bu ses kanalına girmek için 'Kayıtlı Üye' rütbesine sahip olman gerekiyor !");
      return;
    }

    if (activeVoiceChannel === channel.id && voiceConnected) { 
      setActiveChannelId(channel.id);
      return; 
    } 

 // 🚀 ZIRHLI ANTI-SPAM: Art arda tıklamaları engelle
    if (isConnectingToVoiceRef.current) {
        return;
    }

   const executeConnection = () => {
      isConnectingToVoiceRef.current = true;
      if (connectionActionTimeoutRef.current) clearTimeout(connectionActionTimeoutRef.current);

      if (voiceConnected && activeVoiceChannel) {
          handleDisconnect();
          window.dispatchEvent(new CustomEvent('force-end-dm-call'));
          
          connectionActionTimeoutRef.current = setTimeout(() => {
              playJoinSound(); 
              setVoiceConnectionStatus(ConnectionState.CONNECTING);
              setActiveVoiceChannel(channel.id); 
              setActiveChannelId(channel.id); 
              setVoiceSessionId(Date.now()); 
              setVoiceConnected(true);    

              if (currentUser) {
                  setChannelOccupancy(prev => {
                      const currentUsers = prev[channel.id] || [];
                      if (currentUsers.some(u => u.id === currentUser.id)) return prev;
                      return { ...prev, [channel.id]: [...currentUsers, currentUser] };
                  });
              }
              
              if (connectionTimeoutRef.current) clearTimeout(connectionTimeoutRef.current);
              connectionTimeoutRef.current = setTimeout(() => { 
                  setVoiceConnectionStatus((prevStatus) => { 
                      return prevStatus !== ConnectionState.CONNECTED ? ConnectionState.ERROR : prevStatus; 
                  }); 
                  isConnectingToVoiceRef.current = false;
              }, 5000); 
              
              if (socketRef.current) {
                  socketRef.current.emit('sync-music', channel.id);
              }
              
              setTimeout(() => { isConnectingToVoiceRef.current = false; }, 800);
          }, 400); 

      } else {
          window.dispatchEvent(new CustomEvent('force-end-dm-call'));
          playJoinSound(); 
          setVoiceConnectionStatus(ConnectionState.CONNECTING);
          setActiveVoiceChannel(channel.id); 
          setActiveChannelId(channel.id); 
          setVoiceSessionId(Date.now()); 
          setVoiceConnected(true);    

          if (currentUser) {
              setChannelOccupancy(prev => {
                  const currentUsers = prev[channel.id] || [];
                  if (currentUsers.some(u => u.id === currentUser.id)) return prev;
                  return { ...prev, [channel.id]: [...currentUsers, currentUser] };
              });
          }
          
          if (connectionTimeoutRef.current) clearTimeout(connectionTimeoutRef.current);
          connectionTimeoutRef.current = setTimeout(() => { 
              setVoiceConnectionStatus((prevStatus) => { 
                  return prevStatus !== ConnectionState.CONNECTED ? ConnectionState.ERROR : prevStatus; 
              }); 
              isConnectingToVoiceRef.current = false;
          }, 5000);

          if (socketRef.current) {
              socketRef.current.emit('sync-music', channel.id);
          }
          
          setTimeout(() => { isConnectingToVoiceRef.current = false; }, 800);
      }
    };

    ensureMicrophonePermission(executeConnection);
  } else {
    
    // 💬 METİN KANALI İŞLEMLERİ
    setActiveChannelId(channel.id); 

    // 🚀 KANALA TIKLANDIĞI AN BİLDİRİMLERİ SIFIRLA VE VERİTABANINDAN SİL!
    // 1. Arayüzden anında sil ki kullanıcı tıkladığını hissetsin
    setUnreadChannels(prev => {
      const next = { ...prev };
      delete next[channel.id];
      return next;
    });

    setChannelMentions(prev => {
      const next = { ...prev };
      delete next[channel.id];
      return next;
    });

    // 2. Backend'e "Ben bunu okudum, veritabanındaki mühürü sil" diye bildir.
    if (currentUser) {
        fetch(`${BACKEND_URL}/api/channels/${channel.id}/read`, { 
            method: 'POST'
        }).catch(() => {});
    }
  }
};

const handleDisconnect = () => {
  // 🚀 ZORUNLU MÜHÜR: Sesten çıkıldığında havada asılı kalan tooltip'leri zorla yok et!
  setHoverTooltip({ show: false, text: '', top: 0, left: 0 });

  if (currentUser?.soundNotifications !== false) {
          const leaveAudio = new Audio('/sounds/leave.mp3');
          leaveAudio.volume = 0.4;
          leaveAudio.play().catch(e => console.log("Çıkış sesi çalınamadı:", e));
      }
      if (connectionTimeoutRef.current) clearTimeout(connectionTimeoutRef.current);
      if (activeVoiceChannel && currentUser) {
          // 🚀 YENİ: Backend'e çıkış yaptığımızı kesin olarak bildir
          socketRef.current?.emit('leave-voice', { channelId: activeVoiceChannel });

          setChannelOccupancy(prev => {
              const prevUsers = prev[activeVoiceChannel] || [];
              return { ...prev, [activeVoiceChannel]: prevUsers.filter(u => u.id !== currentUser?.id) };
          });
      }
      
      // 🚀 YENİ: Ayrıl butonuna basınca müziği de sustur!
      setMusicState({ isPlaying: false, trackTitle: '', videoId: '', volume: 0.5, startedAt: null });

      setVoiceConnected(false); 
      setVoiceConnectionStatus(ConnectionState.DISCONNECTED); 
      setActiveVoiceChannel(null);
      
      if (currentChannels.length > 0) { 
          const textChannel = currentChannels.find(c => c.type === 'text');
          setActiveChannelId(textChannel ? textChannel.id : currentChannels[0].id); 
      }
  };

const handleMoveBot = (botInstanceId: string, channelId: string) => {
    // 🚀 HİYERARŞİ MÜHRÜ: Sunucu Yönetimi ve Kanal Yönetimi yetkileri eklendi!
    const canMoveBot = isServerOwner || 
                       memberRole?.permissions.includes('ADMIN') || 
                       memberRole?.permissions.includes('MANAGE_MUSIC') ||
                       memberRole?.permissions.includes('MANAGE_SERVER') ||
                       memberRole?.permissions.includes('MANAGE_CHANNELS');
                       
    if (!canMoveBot) return; // Yetkisi yoksa işlemi iptal et

    const botData = activeServer?.bots?.find(b => (b.instanceId || b.id) === botInstanceId);
    if (!botData || !botData.active) return; 

    // 🛡️ 1. KLON KORUMASI (FRONTEND): Bu odada zaten aynı tipten bot var mı?
    const baseBotId = botData.botId || botData.id; // Gerçek türü (b-ai veya b-music)
    const usersInTargetChannel = channelOccupancy[channelId] || [];
    
    const isDuplicate = usersInTargetChannel.some(u => {
        if (u.id === botInstanceId) return false; // Kendisiyse sorun yok (Aynı odaya tekrar çekiyordur)
        
        // Odadaki adamın bot olup olmadığını bul
        const otherBotData = activeServer?.bots?.find(b => (b.instanceId || b.id) === u.id);
        if (otherBotData) {
            const otherBaseBotId = otherBotData.botId || otherBotData.id;
            return otherBaseBotId === baseBotId; // Tipleri aynı mı? (İkisi de AI mi veya Müzik mi?)
        }
        
        // DB'den bulamazsak isminden yakala (Güvenlik sigortası)
        if (baseBotId.includes('ai') && (u.id.includes('ai') || u.username?.includes('AI'))) return true;
        if (baseBotId.includes('music') && (u.id.includes('music') || u.username?.includes('Sesgelio AudioLink'))) return true;
        
        return false;
    });

    if (isDuplicate) {
        alert(`⚠️ HATA: Bu odada zaten bir ${baseBotId.includes('ai') ? 'Yapay Zeka' : 'Müzik Botu'} var! Klonların aynı odada bulunması sistemde anomali yaratır nöral dostum.`);
        return; // İşlemi anında kes!
    }

    // Her şey temizse Backend'e emri yolla
    if (socketRef.current) {
        const botUser: User = { 
            id: botInstanceId, 
            username: botData.name, 
            discriminator: 'BOT', 
            avatarUrl: botData.avatarUrl, 
            status: 'online', 
            isBot: true
        };

        socketRef.current.emit('deploy-bot', { 
            serverId: activeServerId, 
            channelId: channelId, 
            botUser: botUser, 
            adminId: currentUser?.id
        });
    }
  };
  
  const hydrateServerData = (server: any, fullBotSet: any[]) => {
  if (!server) return server;
  
  // Botları isimlendirmek için bir sayaç
  const botTypeCounter: Record<string, number> = {};

  return {
    ...server,
    // 1. Rollerin izinlerini diziye çevir (Hata almamak için)
    roles: server.roles?.map((role: any) => ({
      ...role,
      permissions: typeof role.permissions === 'string' 
        ? role.permissions.split(',') 
        : (Array.isArray(role.permissions) ? role.permissions : [])
    })),
    // 2. Botlara logolarını ve numaralarını giydir
    bots: server.bots?.map((dbBot: any) => {
      const botId = dbBot.botId || dbBot.id;
      const meta = fullBotSet.find(b => b.id === botId);
      
      // Aynı tipten kaç tane var?
      const sameTypeBots = server.bots.filter((b: any) => (b.botId || b.id) === botId);
      
      // Bu botun sırası ne?
      const instanceIndex = sameTypeBots.findIndex((b: any) => b.id === dbBot.id) + 1;
      
      return {
        ...dbBot,
        instanceId: dbBot.id,
        // Birden fazlaysa numara ekle
        name: sameTypeBots.length > 1 
          ? `${meta?.name || botId} #${instanceIndex}` 
          : (meta?.name || botId),
        avatarUrl: meta?.avatarUrl || '',
        description: meta?.description || 'Sesgelio Yardımcı Bot',
        active: dbBot.active ?? true
      };
    })
  };
};

  useEffect(() => {
  // Eğer şu an bir sunucudaysak (Ana sayfa, Keşfet veya AI değilsek)
  const specialPages = ['home', 'discovery', 'gemini-ai'];
  
  if (activeServerId && !specialPages.includes(activeServerId)) {
    // Mevcut aktif sunucum hala sunucular listemde var mı?
    const stillExists = servers.some(s => s.id === activeServerId);
    
    // Eğer sunucu artık listede yoksa (çünkü atıldık veya banlandık)
    if (!stillExists) {
      setActiveServerId('home');
      setActiveChannelId(null);
      setActiveDmId(null);
    }
  }
}, [servers, activeServerId]); // Listemiz veya aktif sunucumuz değiştiğinde tetiklenir

  // --- NEW: HANDLE BOT ACTIVITY TOGGLE AND VOICE DISCONNECT ---
 const handleToggleBotActivity = async (targetServerId: string, instanceId: string, newActiveState: boolean) => {
  try {
    // 1. Backend'e bot durumunu bildir
    const response = await fetch(`${BACKEND_URL}/api/servers/${targetServerId}/bots/toggle`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ 
        instanceId: instanceId, 
        active: newActiveState 
      }),
    });

    if (response.ok) {
      // 2. Frontend State Güncellemesi: Merkezi giydirme fonksiyonunu kullanarak güncelliyoruz
      setServers(prev => prev.map(s => {
        if (s.id === targetServerId) {
          // Önce botun durumunu değiştiriyoruz
          const updatedServerRaw = {
            ...s,
            bots: s.bots?.map(b => 
              (b.id === instanceId || b.instanceId === instanceId) 
                ? { ...b, active: newActiveState } 
                : b
            )
          };
          // Sonra merkezi fonksiyonla her şeyi (logolar, isimler) tekrar mühürlüyoruz
          return hydrateServerData(updatedServerRaw, FULL_BOT_SET);
        }
        return s;
      }));

      // 3. KRİTİK: Eğer bot kapatıldıysa ses kanalından düşür
      if (!newActiveState) {
        setChannelOccupancy(prev => {
          const next = { ...prev };
          Object.keys(next).forEach(channelId => {
            next[channelId] = next[channelId].filter(u => u.id !== instanceId);
          });
          return next;
        });
      }      
      // 4. Diğer üyelere haber ver (Bu sinyal az önce düzelttiğimiz socket dinleyicisini tetikler)
      if (socketRef.current) {
        socketRef.current.emit('server-updated', { serverId: targetServerId });
      }

    } else {
      const errorData = await response.json();
      alert(errorData.error || "Bot durumu güncellenemedi .");
    }
  } catch (error) {
    console.error("Bot senkronizasyon hatası:", error);
    alert("Backend bağlantısında sorun var nöral dostum!");
  }
};
const handleBotCommand = (command: string, targetBotId?: string) => {
    let targetChannelId = null;

    // 🛡️ 1. DEDEKTİF MÜHRÜ: Eğer komut DM'den özel bir bota atıldıysa, o botun odasını bul!
    if (targetBotId) {
        // channelOccupancy (radarda) bu botu arıyoruz
        const botRoom = Object.keys(channelOccupancy).find(cId => 
            channelOccupancy[cId].some(u => u.id === targetBotId)
        );
        
        if (botRoom) {
            targetChannelId = botRoom; // Botun olduğu odayı kilitledik!
        } else {
            return "⚠️ nöral dostum bu müzik botu şu an hiçbir ses kanalında değil. Önce onu sağ menüden bir odaya taşımalısın!";
        }
    } 
    // 2. Eğer genel bir komutsa (DM'den değil de bir şekilde başka yerden geldiyse) kullanıcının odasına bak
    else {
        if (!activeVoiceChannel) {
            return "⚠️ Sesgelio AudioLink'e komut vermek için önce bir ses kanalına bağlanmalısın.";
        }
        targetChannelId = activeVoiceChannel;
    }

    // 3. Komutu ve şarkı adını ayır (Örn: "/play" ve "Müslüm Gürses")
    const [cmd, ...args] = command.split(' ');
    const arg = args.join(' ');

    // 4. Backend'e NOKTA ATIŞI emri yolla
    if (socketRef.current && currentUser) {
        socketRef.current.emit('music-command', {
            command: cmd,
            arg: arg,
            channelId: targetChannelId, // 🚀 HEDEF KİLİTLENDİ! Sadece botun olduğu oda etkilenecek.
            user: currentUser
        });
    }

    // 5. Ekrana geçici bir bekleme mesajı bas
    return "⏳ Sesgelio AudioLink kasetleri ayarlıyor...";
};
 const handleServerBotCommand = async (channelId: string, command: string, args: string) => {
    const server = servers.find(s => s.id === activeServerId);
    if (!server || !currentUser) return;

    // --- 1. LEVELUP BOT MANTIĞI (/rank ve /top) ---
    if (command === '/rank' || command === '/top') {
        const hasLevelBot = server.bots?.some(b => (b.botId === 'b-level' || b.id === 'b-level') && b.active);
        if (!hasLevelBot) return "⚠️ StatMatrix botu bu sunucuda aktif değil .";

        let botMessage = '';
        
        if (command === '/rank') {
            // Kullanıcının sırasını bul
            const member = server.members?.find(m => m.id === currentUser?.id);
            const sorted = [...(server.members || [])].sort((a, b) => ((b as any).xp || 0) - ((a as any).xp || 0));
            const rank = sorted.findIndex(m => m.id === currentUser?.id) + 1;
            
            botMessage = `📊 ${currentUser.username}, Mevcut Seviyen: ${(member as any)?.level || 1} (${(member as any)?.xp || 0} XP) | Sunucu Sıralaman: #${rank}`;
        } 
        else if (command === '/top') {
            // İlk 10 kişiyi listele
            const sorted = [...(server.members || [])].sort((a, b) => ((b as any).xp || 0) - ((a as any).xp || 0)).slice(0, 10);
            botMessage = `🏆 SUNUCU LİDERLİK TABLOSU (İLK 10) 🏆\n`;
            sorted.forEach((m, i) => {
                botMessage += `\n#${i + 1}** ${m.username} - Seviye ${(m as any).level || 1} (${(m as any).xp || 0} XP)`;
            });
        }

        // DB'ye kaydetmeden HERKESE fırlatmak için Hayalet Sinyali (Socket)
        if (socketRef.current) {
            socketRef.current.emit('send-temp-bot-message', {
                channelId,
                serverId: activeServerId,
                content: botMessage,
                botId: 'b-level',
                botName: 'StatMatrix'
            });
        }
        return; // ChatArea kendi lokalinde bir şey basmasın diye boş dönüyoruz.
    }

    // --- 2. TICKET BOT MANTIĞI (/ticket ve /close) ---
    if (command === '/ticket' || command === '/close') {
        const hasTicketBot = server.bots?.some(b => (b.botId === 'b-tool' || b.id === 'b-tool') && b.active);
        if (!hasTicketBot) return "⚠️ TicketPro botu bu sunucuda aktif değil.";

        if (command === '/ticket') {
            const cleanUsername = currentUser.username.toLowerCase().replace(/[^a-z0-9]/g, '');
            const ticketName = `ticket-${cleanUsername}`;

            try {
                const response = await fetch(`${BACKEND_URL}/api/tickets/open`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ userId: currentUser?.id, serverId: activeServerId, ticketName })
                });

                if (response.ok) {
                    return `✅ **Destek Talebi Oluşturuldu**\nKanal: #${ticketName}\nLütfen ilgili kanala giderek sorununuzu iletin.`;
                } else {
                    const errData = await response.json();
                    return `❌ Hata: ${errData.error}`;
                }
            } catch (e) {
                return "❌ Backend bağlantı hatası!";
            }
        }

        if (command === '/close') {
            const currentChannel = server.channels.find(c => c.id === channelId);
            if (currentChannel && currentChannel.name.startsWith('ticket-')) {
                // MySQL'den sil
                handleDeleteChannel(activeServerId, channelId, currentChannel.name);
                return;
            } else {
                return "❌ Bu komut sadece bir ticket kanalında kullanılabilir.";
            }
        }
    }
};
 const handleUpdateMemberRole = async (memberId: string, roleId: string) => {
  if (!activeServerId) return;

  try {
    // 1. Backend'e "Bu kullanıcının rolünü MySQL'de güncelle" diyoruz
    const response = await fetch(`${BACKEND_URL}/api/servers/${activeServerId}/members/${memberId}/role`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ roleId }),
    });

    if (response.ok) {
      // 2. Ekranda anlık güncelle
      setServers(prev => prev.map(s => {
        if (s.id === activeServerId) {
          return {
            ...s,
            members: s.members?.map(m => m.id === memberId ? { ...m, roleId } : m)
          };
        }
        return s;
      }));
    } else {
      const errData = await response.json();
      alert(errData.error || "Rol güncellenemedi nöral dostum.");
    }
  } catch (error) {
    console.error("Rol güncellenirken hata:", error);
    alert("Sunucu ile bağlantı kurulamadı.");
  }
};

  const handleAddFriend = async () => {
  // Arkadaş eklendikten sonra listeyi veritabanından taze çek
  // Böylece giden istek (outgoing) anında "Bekleyenler" sekmesine düşer.
  try {
    const friendRes = await fetch(`${BACKEND_URL}/api/friends/${currentUser?.id}`);
    const userFriends = await friendRes.json();
    setFriends(userFriends);
  } catch (error) {
    console.error("Arkadaş listesi güncellenemedi:", error);
  }
};
  const handleAcceptFriend = async (friendId: string) => {
  if (!currentUser) return;
  try {
    const response = await fetch(`${BACKEND_URL}/api/accept-request`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ 
        senderId: friendId,      // Sana isteği atan kişi
        receiverId: currentUser?.id // Sen (isteği kabul eden)
      }),
    });

    if (response.ok) {
      // Başarılıysa arayüzü güncelle
      setFriends(prev => prev.map(f => 
        f.id === friendId ? { ...f, relationship: 'friend', } : f
      ));
      console.log("Arkadaşlık isteği kabul edildi.");
    } else {
      const errorData = await response.json();
      alert(errorData.error || "Kabul edilirken bir hata oluştu.");
    }
  } catch (error) {
    console.error("Bağlantı hatası:", error);
  }
};
  const handleDeclineFriend = async (friendId: string) => {
  if (!currentUser) return;
  try {
    // Backend'e reddetme isteği gönder
    const response = await fetch(`${BACKEND_URL}/api/decline-request`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ 
        senderId: friendId, 
        receiverId: currentUser?.id 
      }),
    });

    if (response.ok) {
      // Başarılıysa bu kişiyi listeden (state) tamamen kaldır
      setFriends(prev => prev.filter(f => f.id !== friendId));
    }
  } catch (error) {
    console.error("Reddetme hatası:", error);
  }
};
  const handleAddFriendFromDm = (friendId: string) => { setFriends(prev => prev.map(f => f.id === friendId ? { ...f, relationship: 'outgoing', isDmOpen: true } : f)); };

const activeServerIdRef = useRef(activeServerId);

// activeServerId her değiştiğinde Ref'i güncel tutalım
useEffect(() => {
  activeServerIdRef.current = activeServerId;
}, [activeServerId]);

// 🚀 YENİ EKLENEN MUHAFIZ (DM Kopmasını Engeller)
const activeDmIdRef = useRef(activeDmId);
useEffect(() => {
  activeDmIdRef.current = activeDmId;
}, [activeDmId]);

// 🚀 YENİ: GRUP SOHBETİ KOPMASINI ENGELLER
const activeGroupIdRef = useRef(activeGroupId);
useEffect(() => {
  activeGroupIdRef.current = activeGroupId;
}, [activeGroupId]);

// 🚀 YENİ: Ses kanalı titremesini engeller
const activeVoiceChannelRef = useRef(activeVoiceChannel);
useEffect(() => {
  activeVoiceChannelRef.current = activeVoiceChannel;
}, [activeVoiceChannel]);

// 🚀 SİNYAL KOPUKLUĞU GİDERİLDİ: Mikrofon ve Sağırlaştırma artık temiz iki ayrı paket!
useEffect(() => {
    if (socketRef.current && currentUser && activeVoiceChannel) {
        // Sadece mikrofon durumunu fırlat
        socketRef.current.emit('user-mute', { 
            channelId: activeVoiceChannel, 
            isMuted: isMuted 
        });
        // Sadece sağırlaştırma durumunu fırlat
        socketRef.current.emit('user-deafen', { 
            channelId: activeVoiceChannel, 
            isDeafened: isDeafened 
        });
    }
}, [isMuted, isDeafened, activeVoiceChannel]);

// 🚀 GLOBAL RADAR (TÜM SUNUCULARI AYNI ANDA DİNLEME MÜHRÜ)
// Kullanıcı sisteme girdiğinde üye olduğu TÜM sunucuların soket odalarına (gizlice) bağlanır.
// Böylece başka bir sunucudayken bile arkadaki sunuculardan bildirim sinyallerini duyabilir!
useEffect(() => {
    if (socketRef.current && currentUser && servers.length > 0) {
        servers.forEach(server => {
            socketRef.current?.emit('join-room', { roomId: `server-${server.id}`, user: currentUser });
        });
    }
}, [servers.length, currentUser]); // Sadece sunucu sayısı değişirse veya adam yeni girerse tetiklenir

// 🚀 KANAL OKUNMADI VE ETİKET (MENTION) HAFIZALARI
const activeChannelIdRef = useRef(activeChannelId);
useEffect(() => {
  activeChannelIdRef.current = activeChannelId;
}, [activeChannelId]);

const [unreadChannels, setUnreadChannels] = useState<Record<string, boolean>>({});
const [channelMentions, setChannelMentions] = useState<Record<string, number>>({});

// Sürüklenen sunucunun sırasını takip etmek için
const dragItem = useRef<number | null>(null);
const dragOverItem = useRef<number | null>(null);

const handleSort = () => {
  if (dragItem.current === null || dragOverItem.current === null) return;
  const _servers = [...servers];
  const draggedItemContent = _servers.splice(dragItem.current, 1)[0];
  _servers.splice(dragOverItem.current, 0, draggedItemContent);
  dragItem.current = null;
  dragOverItem.current = null;
  setServers(_servers);
};

// 🚀 AKTİVİTE PANELİ MÜHRÜ: Ses odası değişince Electron'a bildir
useEffect(() => {
  const electronAPI = (window as any).electronAPI ?? null;
  if (!electronAPI?.sendActivityUpdate) return;

  // Ayar değişince Electron'a toggle sinyali gönder
  electronAPI.sendActivityToggle(currentUser?.showActivityPanel ?? true);

  // 🛡️ KAPANMA MÜHRÜ: Bağlantı yoksa veya kanal yoksa paneli ZORLA kapat
  if (!voiceConnected || !activeVoiceChannel) {
    electronAPI.sendActivityUpdate(null); // null = paneli gizle
    return;
  }

  const occupants = channelOccupancy[activeVoiceChannel] || [];

  // 🛡️ BOŞ ODA MÜHRÜ: Odada kimse kalmadıysa da gizle
  if (occupants.length === 0) {
    electronAPI.sendActivityUpdate(null);
    return;
  }

  const payload = {
    channelName: connectedChannel?.name || 'Ses Odası',
    members: occupants.map((u: User) => ({
      id: u.id,
      username: u.username,
      avatarUrl: u.avatarUrl,
      isMuted: u.id === currentUser?.id
        ? isMuted
        : (globalMutedUsers[u.id] ?? (u as any).isMuted ?? false),
      isDeafened: u.id === currentUser?.id
        ? isDeafened
        : (globalDeafenedUsers[u.id] ?? (u as any).isDeafened ?? false),
    })),
  };
  electronAPI.sendActivityUpdate(payload);

  // 🚀 TEMİZLİK (CLEANUP) MÜHRÜ: Odadan çıkıldığında veya useEffect yeniden tetiklenmeden önce
  // anında "null" sinyalini zorla fırlatarak arka planda eski odanın hafızada asılı kalmasını engeller.
  return () => {
    electronAPI.sendActivityUpdate(null);
  };

}, [voiceConnected, activeVoiceChannel, channelOccupancy, currentUser?.showActivityPanel, isMuted, isDeafened, globalMutedUsers, globalDeafenedUsers, connectedChannel?.name]);


// 🚀 YENİ: currentUser'ın en güncel halini socket dinleyicilerine taşır (stale closure önler)
const currentUserRef = useRef(currentUser);
useEffect(() => {
  currentUserRef.current = currentUser;
}, [currentUser]);


// 🚀 YENİ: ZENGİN SUNUCU BİLGİSİ (Kamera ve Ekran Paylaşımı Büyütüldü)
const renderServerTooltip = (server: Server) => {
    const voiceChannels = server.channels?.filter(c => c.type === 'voice') || [];
    const activeVoiceUsers: { channelName: string, users: User[] }[] = [];
    
    voiceChannels.forEach(channel => {
        const users = channelOccupancy[channel.id] || [];
        if (users.length > 0) {
            activeVoiceUsers.push({ channelName: channel.name, users });
        }
    });

    if (activeVoiceUsers.length === 0) {
        return <span className="font-bold">{server.name}</span>;
    }

    return (
        <div className="flex flex-col gap-2 min-w-[180px] pointer-events-none">
            <span className="font-black text-sesgelio border-b border-white/10 pb-1.5 mb-1">{server.name}</span>
            {activeVoiceUsers.map((vc, idx) => (
                <div key={idx} className="flex flex-col gap-1.5 mb-1.5">
                    <span className="text-[11px] text-gray-400 uppercase tracking-widest font-bold flex items-center gap-1.5">
                        <Volume2 size={12} className="text-green-500" /> {vc.channelName}
                    </span>
{vc.users.map(u => {
                        // SİHİRLİ RADAR
                        const isCameraOn = globalVideoUsers[u.id] || (u as any).isVideoOn;
                        const isScreenOn = globalScreenUsers[u.id] || (u as any).isScreenSharing;
                        
                        // 🚀 MUTE VE DEAFEN RADARI
                        const isMicMuted = u.id === currentUser?.id 
                            ? isMuted 
                            : (globalMutedUsers[u.id] ?? (u as any).isMuted ?? false);
                            
                        const isAudioDeafened = u.id === currentUser?.id 
                            ? isDeafened 
                            : (globalDeafenedUsers[u.id] ?? (u as any).isDeafened ?? false);

                        return (
                            <div key={u.id} className="flex items-center justify-between gap-3 bg-black/30 rounded-lg px-2 py-1.5 border border-white/5">
                                <div className="flex items-center gap-2">
                                    <img 
  src={getSafeAvatar(u.avatarUrl)} 
  className="w-5 h-5 rounded-full object-cover border border-white/10 shadow-sm"
  style={{ 
    filter: (u.plan === 'premium' || u.isPremium || u.plan === 'elite' || u.isElite || u.isBot || u.id?.startsWith('b-')) 
      ? 'none' 
      : 'grayscale(100%) opacity(0.5)' 
  }}
/>
                                    <span className="text-xs font-bold text-gray-100">{u.username}</span>
                                </div>
                                <div className="flex items-center gap-1.5">
                                    {/* 🚀 İKONLAR (Mute, Deafen, Kamera, Yayın) */}
                                    {isAudioDeafened && (
                                        <PhoneOff size={14} className="text-red-500 drop-shadow-[0_0_5px_rgba(239,68,68,0.8)]" strokeWidth={2.5} />
                                    )}
                                    {isMicMuted && (
                                        <MicOff size={14} className="text-red-500 drop-shadow-[0_0_5px_rgba(239,68,68,0.8)]" strokeWidth={2.5} />
                                    )}
                                    {isCameraOn && (
                                        <Video size={14} className="text-blue-400 drop-shadow-[0_0_5px_rgba(96,165,250,0.8)] animate-pulse" strokeWidth={2.5} />
                                    )}
                                    {isScreenOn && (
                                        <MonitorUp size={14} className="text-emerald-400 drop-shadow-[0_0_5px_rgba(52,211,153,0.8)] animate-pulse" strokeWidth={2.5} />
                                    )}
                                </div>
                            </div>
                        );
                    })}
                </div>
            ))}
        </div>
    );
};

const renderServerItem = (server: Server, insideFolder: boolean = false) => {
  const serverChannels = server.channels || [];
  const hasUnread = serverChannels.some(c => unreadChannels[c.id]);
  const mentionCount = serverChannels.reduce((acc, c) => acc + (channelMentions[c.id] || 0), 0);

  return (
    <div 
      key={server.id} 
      draggable={!insideFolder}
      onDragStart={(e) => !insideFolder && handleDragStart(e, server.id)}
      onDragOver={handleDragOver}
      onDrop={(e) => !insideFolder && handleDrop(e, server.id)}
      onDragEnd={handleDragEnd}
      className={`relative group w-full flex justify-center mb-2 transition-all duration-200 ${!insideFolder ? 'cursor-grab active:cursor-grabbing' : 'cursor-pointer'} ${draggedServerId === server.id ? 'opacity-40 scale-95' : 'opacity-100'}`}
    >
      {hasUnread && activeServerId !== server.id && (
  <div 
    onMouseEnter={(e) => {
             const rect = e.currentTarget.getBoundingClientRect(); 
             setHoverTooltip({show: true, text: 'Kaçırdığın mesajlar', top: rect.top + rect.height / 2, left: rect.right + 12, position: 'right'}); 
          }}
          onMouseLeave={() => setHoverTooltip(prev => ({...prev, show: false}))}
          className="absolute left-0 top-1/2 -translate-y-1/2 w-1.5 h-4 bg-white rounded-r-full animate-fade-in z-[100] shadow-[0_0_10px_rgba(255,255,255,0.8)] cursor-help pointer-events-auto"
        ></div>
      )}

      <div 
        onMouseEnter={(e) => { const rect = e.currentTarget.getBoundingClientRect(); setHoverTooltip({show: true, text: server.name, top: rect.top + rect.height / 2, left: rect.right + 16}); }}
        onMouseLeave={() => setHoverTooltip(prev => ({...prev, show: false}))}
        className={`relative ${insideFolder ? 'w-12 h-12' : 'w-14 h-14'}`}
      > 
        <div onClick={() => handleServerClick(server.id)} className={`w-full h-full rounded-[28px] hover:rounded-[20px] transition-all duration-300 cursor-pointer overflow-hidden border-2 ${activeServerId === server.id ? 'rounded-[20px] border-[#ff2b5e]/50 shadow-[0_0_25px_rgba(255,43,94,0.4)] ring-2 ring-[#ff2b5e]/30' : 'border-transparent bg-white/5 dark:bg-white/5 hover:shadow-xl dark:hover:shadow-[#ff2b5e]/30'}`}>
          {server.iconUrl ? (
             <img src={server.iconUrl.startsWith('http') ? server.iconUrl : `${BACKEND_URL}${server.iconUrl}`} alt={server.name} className="w-full h-full object-cover bg-gray-200 dark:bg-[#1e1f22]" />
          ) : (
             <div className="w-full h-full flex items-center justify-center bg-gray-200 dark:bg-[#1e1f22] text-gray-900 dark:text-white font-black text-xl uppercase">
                {server.name.charAt(0)}
             </div>
          )}
        </div>
        
        {!insideFolder && <button onClick={(e) => { e.stopPropagation(); handleLeaveServer(server.id); }} className="absolute -top-1 -right-1 w-6 h-6 bg-red-500 text-white rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity cursor-pointer z-[120] shadow-md border border-white/20 transform hover:scale-110"><X size={14} strokeWidth={3} /></button>}
        
        {mentionCount > 0 && (
          <div 
            onMouseEnter={(e) => {
               e.stopPropagation();
               const rect = e.currentTarget.getBoundingClientRect();
               setHoverTooltip({show: true, text: 'Etiketlendin', top: rect.top + rect.height / 2, left: rect.right + 12, position: 'right'});
            }}
            onMouseLeave={(e) => {
               e.stopPropagation();
               setHoverTooltip(prev => ({...prev, show: false}));
            }}
            className={`absolute -bottom-1 -right-1 bg-red-500 text-white text-[11px] font-black min-w-[22px] h-[22px] px-1 flex items-center justify-center rounded-full z-[100] ring-4 ring-white dark:ring-[#0a0a0c] shadow-[0_0_15px_rgba(239,68,68,0.8)] animate-bounce-short cursor-help pointer-events-auto ${insideFolder ? 'scale-[0.8] translate-x-1 translate-y-1' : ''}`}
          >
            {mentionCount > 99 ? '99+' : mentionCount}
          </div>
        )}

        {voiceConnected && connectedServerId === server.id && mentionCount === 0 && (
          <div className={`absolute -bottom-1 -right-1 w-5 h-5 bg-[#050505] rounded-full flex items-center justify-center z-[90] ${insideFolder ? 'scale-[0.8] translate-x-1 translate-y-1' : ''}`}>
            <div className="w-4 h-4 bg-green-500 rounded-full flex items-center justify-center shadow-[0_0_10px_rgba(34,197,94,0.6)]">
               <Volume2 size={10} className="text-[#050505] animate-pulse" fill="currentColor" />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

  const handleOpenDmFromProfile = (member: any) => {
    setIsMobileDrawerOpen(false);
    const existingFriend = friends.find(f => f.id === member.id);
    const isBotUser = member.isBot || member.id.startsWith('b-'); // Bot mührü

    if (!existingFriend) {
        const newFriend: Friend = { 
            id: member.id, 
            username: member.username, 
            avatarUrl: member.avatarUrl, 
            status: member.status, 
            relationship: 'none', 
            isDmOpen: true,
            isBot: isBotUser // Bot işaretini ekliyoruz
        };
        setFriends([...friends, newFriend]);
    } else {
        setFriends(prev => prev.map(f => f.id === member.id ? { ...f, isDmOpen: true, isBot: isBotUser } : f));
    }
    setActiveServerId('home'); 
    setActiveDmId(member.id); 
};

const handleDmClick = async (dmId: string) => {
  setIsMobileDrawerOpen(false);
    setActiveServerId('home');  
    setActiveDmId(dmId);
    setActiveGroupId(null);
 if (!voiceConnected || activeVoiceChannel?.startsWith('call-')) {
        setIsDmMinimized(false);
    }

    setFriends(prev => prev.map(f =>
        f.id === dmId ? { ...f, isDmOpen: true, unreadCount: 0 } : f
    ));

    // EĞER TIKLANAN KİŞİ BOT İSE, MYSQL'E SİNYAL GÖNDERME
    const targetFriend = friends.find(f => f.id === dmId);
    if (targetFriend?.isBot || dmId.startsWith('b-')) return; 

    try {
        await fetch(`${BACKEND_URL}/api/friends/dm-status`, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ userId: currentUser?.id, friendId: dmId, isOpen: true }),
        });
        await fetch(`${BACKEND_URL}/api/friends/reset-unread`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ userId: currentUser?.id, friendId: dmId }),
        });
        handleRefreshFriends();
    } catch (err) {
        console.error("DM Açma Hatası:", err);
    }
};

const handleCloseDm = async (friendId: string) => {
    if (activeDmId === friendId) setActiveDmId(null);

    const targetFriend = friends.find(f => f.id === friendId);
    if (targetFriend?.isBot || friendId.startsWith('b-')) {
        // Bot DM'i kapatılırsa anında yerel hafızadan uçur
        setFriends(prev => prev.filter(f => f.id !== friendId));
        return;
    }

    try {
        await fetch(`${BACKEND_URL}/api/friends/dm-status`, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ userId: currentUser?.id, friendId, isOpen: false }),
        });
        setFriends(prev => {
            const friend = prev.find(f => f.id === friendId);
            if (!friend) return prev;
            if (friend.relationship === 'none') return prev.filter(f => f.id !== friendId);
            return prev.map(f => f.id === friendId ? { ...f, isDmOpen: false } : f);
        });
    } catch (error) {
        console.error("DM kapatılamadı:", error);
    }
};
  const handleDragStart = (e: React.DragEvent<HTMLDivElement>, serverId: string) => { setDraggedServerId(serverId); e.dataTransfer.effectAllowed = 'move'; e.dataTransfer.setData('text/plain', serverId); };
  const handleDragOver = (e: React.DragEvent<HTMLDivElement>) => { e.preventDefault(); e.dataTransfer.dropEffect = 'move'; };
  const handleDrop = async (e: React.DragEvent<HTMLDivElement>, targetServerId: string) => {
  e.preventDefault();
  if (!draggedServerId || draggedServerId === targetServerId) return;

  const sourceIndex = servers.findIndex(s => s.id === draggedServerId);
  const targetIndex = servers.findIndex(s => s.id === targetServerId);

  if (sourceIndex !== -1 && targetIndex !== -1) {
    const updatedServers = [...servers];
    const [movedServer] = updatedServers.splice(sourceIndex, 1);
    updatedServers.splice(targetIndex, 0, movedServer);
    setServers(updatedServers);

    // Backend'e yeni sıralamayı gönder
    const orderData = updatedServers.map((s, index) => ({ serverId: s.id, orderIndex: index }));
fetch(`${BACKEND_URL}/api/users/${currentUser?.id}/servers/order`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ serverOrders: orderData }),
});
  }
  setDraggedServerId(null);
};
  const handleDragEnd = () => { setDraggedServerId(null); };
  
  const handleCreateServer = async (name: string, icon: string | null) => {
  if (!currentUser) return;

  try {
    // 1. Backend'e sunucu oluşturma isteği gönder [cite: 4, 449]
    const response = await fetch(`${BACKEND_URL}/api/servers`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        name: name,
        iconUrl: icon,
        ownerId: currentUser?.id 
      }),
    });

    if (response.ok) {
      const newServerFromDB = await response.json();
      
      // 2. State'i güncelle ve yeni sunucuya geçiş yap
      setServers(prev => [...prev, newServerFromDB]);
      setActiveServerId(newServerFromDB.id);
      handleServerClick(newServerFromDB.id);
      
      // 3. İlk kanalı aktif et (Çökmeyi önlemek için kontrol ekliyoruz)
      if (newServerFromDB.channels && newServerFromDB.channels.length > 0) {
        setActiveChannelId(newServerFromDB.channels[0].id);
      }
      
      // 4. Modalı kapat
      setShowCreateServerModal(false);
      // 🚀 YENİ: Adam sunucuyu kurdu! Eğer daha önce bu turu görmediyse şovu başlat!
      const hasSeenServerTour = localStorage.getItem('sesgelio_server_tour_completed');
      if (!hasSeenServerTour) {
        setShowServerTour(true);
      }
    } else {
      const errorData = await response.json();
      alert(`Hata: ${errorData.error}`);
    }
  } catch (error) {
    console.error("Sunucu oluşturma hatası:", error);
    alert("Backend sunucusuna ulaşılamadı. Sunucunun açık olduğundan emin ol .");
  }
};

// 🚀 KLASÖR SÜRÜKLE-BIRAK HAFIZASI VE MOTORU
  const [draggedFolderId, setDraggedFolderId] = useState<string | null>(null);

  const handleFolderDragStart = (e: React.DragEvent<HTMLDivElement>, folderId: string) => { 
      setDraggedFolderId(folderId); 
      e.dataTransfer.effectAllowed = 'move'; 
      // 🛡️ KRİTİK MÜHÜR: Bu olmadan tarayıcı sürüklemeye izin vermez!
      e.dataTransfer.setData('text/plain', folderId); 
  };

  const handleFolderDrop = (e: React.DragEvent<HTMLDivElement>, targetFolderId: string) => {
      e.preventDefault();
      e.stopPropagation(); // Sunucuların drag&drop sistemiyle çakışmasını engeller

      if (!draggedFolderId || draggedFolderId === targetFolderId) return;

      const sourceIndex = serverFolders.findIndex(f => f.id === draggedFolderId);
      const targetIndex = serverFolders.findIndex(f => f.id === targetFolderId);

      if (sourceIndex !== -1 && targetIndex !== -1) {
          const updatedFolders = [...serverFolders];
          const [movedFolder] = updatedFolders.splice(sourceIndex, 1);
          updatedFolders.splice(targetIndex, 0, movedFolder);
          
          setServerFolders(updatedFolders);
      }
      setDraggedFolderId(null);
  };

  const handleFolderDragEnd = () => { 
      setDraggedFolderId(null); 
  };

// 🚀 IŞINLANMA MOTORU 2: Davet fonksiyonu artık beklemeden çalışacak
 const handleJoinServer = async (inputCode: string, overrideUser?: User) => {
  // Eğer ışınlanma motorundan acil bir kullanıcı geldiyse onu kullan, yoksa normal state'i bekle
  const activeUser = overrideUser || currentUser;
  
  if (!activeUser) return;
  const code = inputCode.split('/').pop()?.trim().toUpperCase(); 
  if (!code) return;

  try {
    const response = await fetch(`${BACKEND_URL}/api/servers/join-by-code`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ userId: activeUser.id, inviteCode: code }),
    });

    if (response.ok) {
      const joinedServer = await response.json();
      
      // 1. Sunucuyu listeye ekle veya varsa güncelle
      setServers(prev => {
        const exists = prev.find(s => s.id === joinedServer.id);
        if (!exists) return [...prev, joinedServer];
        return prev.map(s => s.id === joinedServer.id ? joinedServer : s);
      });

      // 2. Sunucuya anlık geçiş yap
      handleServerClick(joinedServer.id);

      // 3. Socket odasına (Room) dahil ol ki mesajları ve üyeleri anlık gör
      if (socketRef.current) {
        socketRef.current.emit('join-room', { roomId: `server-${joinedServer.id}`, user: currentUser });
      }
      
      setShowCreateServerModal(false);
    } else {
      const errorData = await response.json();
      alert(errorData.error || "Sunucuya katılamadım nöral dostum.");
    }
  } catch (error) {
    console.error("Katılma hatası:", error);
    alert("Bağlantı hatası, backend açık mı?");
  }
};

// 🚀 DAVET KODUYLA GRUBA KATILMA MOTORU
  const handleJoinGroup = async () => {
      if (!groupInviteCode.trim()) return;
      
      try {
          const res = await fetch(`${BACKEND_URL}/api/groups/join-by-code`, {
              method: 'POST',
              headers: {
                  'Content-Type': 'application/json',
                 
              },
              body: JSON.stringify({ inviteCode: groupInviteCode })
          });

          if (res.ok) {
              const joinedGroup = await res.json();
              
              // Grubu sol menüye (state) ekle
              setGroups(prev => {
                  const exists = prev.find(g => g.id === joinedGroup.id);
                  if (exists) return prev;
                  return [joinedGroup, ...prev];
              });

              // Modalı kapat, kodu temizle ve şak diye gruba geçiş yap!
              setShowCreateGroupModal(false);
              setGroupInviteCode("");
              setActiveDmId(null);
              setActiveGroupId(joinedGroup.id);
          } else {
              const err = await res.json();
              alert(err.error || "Gruba katılamadın .");
          }
      } catch (err) {
          console.error(err);
          alert("Bağlantı hatası, kod mühürlenemedi.");
      }
  };
const handleAddChannel = async (name: string, type: 'text' | 'voice', voiceMode: 'standard' | 'ai' = 'standard') => {
    if (!canManageServer || !activeServerId) return; 

    try {
      // 1. Backend'e "Bu kanalı kaydet" diyoruz
      const response = await fetch(`${BACKEND_URL}/api/channels`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          name,
          type,
          serverId: activeServerId,
          voiceMode,
          folderId: createChannelTargetFolderId // 🚀 EKSİK PARÇA: Backend'e klasör ID'sini de gönderiyoruz!
        }),
      });

      if (response.ok) {   
        setShowCreateChannelModal(false); 
        setCreateChannelTargetFolderId(null); // İşlem bitince hafızayı sıfırla
      }
  } catch (error) {
    console.error("Kanal eklenirken hata oluştu:", error);
    alert("Kanal oluşturulamadı, bağlantıyı kontrol et .");
  }
}; 

const handleDeleteChannel = async (targetServerId: string, channelId: string, channelName: string) => {
  if (!canManageServer) return;
  if (!window.confirm(`'${channelName}' kanalını kalıcı olarak silmek istediğine emin misin?`)) return;

  try {
    // Backend'e "Bunu MySQL'den sil" diyoruz
    await fetch(`${BACKEND_URL}/api/channels/${channelId}`, { method: 'DELETE' });
    
    // Ekranda güncelle
    setServers(prevServers => prevServers.map(server => {
      if (server.id === targetServerId) {
        return { ...server, channels: server.channels.filter(c => c.id !== channelId) };
      }
      return server;
    }));
  } catch (e) { alert("Silemedim nöral dostum, backend'i kontrol et."); }
};  

 const handleUpdateServer = async (updatedServer: Server) => {
  // 1. Yetki Kontrolü: Sadece yönetme yetkisi olanlar bu kapıdan geçer
  if (!canManageServer) return;

  try {
    // 2. Backend'e Güncelleme Paketini Gönderiyoruz
 const response = await fetch(`${BACKEND_URL}/api/servers/${updatedServer.id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          name: updatedServer.name,
          iconUrl: updatedServer.iconUrl,
          wallpaperUrl: (updatedServer as any).wallpaperUrl,               // 🚀 YENİ EKLENDİ
          purchasedWallpapers: (updatedServer as any).purchasedWallpapers, // 🚀 YENİ EKLENDİ
          wallpaperBrightness: (updatedServer as any).wallpaperBrightness, // 🚀 PARLAKLIK EKLENDİ
          channels: updatedServer.channels,
          roles: updatedServer.roles,
          bots: updatedServer.bots,
          channelFolders: (updatedServer as any).channelFolders,
        }),
      });

    if (response.ok) {
      // 3. Backend'den Gelen Taze (Mühürlenmiş) Veriyi Alıyoruz
      const freshServerFromDB = await response.json(); 
      
      // 4. Ekranda Görünen Sunucu Listesini Güncelliyoruz
setServers(prev => prev.map(s => {
  if (s.id === updatedServer.id) {
    const readyServer = hydrateServerData(freshServerFromDB, FULL_BOT_SET);

    return { 
      ...s, 
      ...readyServer, 
      members: s.members || readyServer.members || [], 
      bots: readyServer.bots ? JSON.parse(JSON.stringify(readyServer.bots)) : [],
      channelFolders: updatedServer.channelFolders || readyServer.channelFolders || []
    };
  }
  return s;
}));

      // 5. İşlem Başarılı: Ayarlar penceresini kapat ve verileri anlık tazele
      setShowServerSettingsModal(false);
      
      // Sağ barın ve kanalların boşalmaması için sunucu bilgilerini tekrar tetikliyoruz
      handleServerClick(updatedServer.id); 
    } else {
       console.error("Sunucu ayarları kaydedilemedi, backend hata kodu döndü.");
    }
  } catch (error) {
    console.error("Güncelleme sırasında kritik bir hata oluştu:", error);
  }
};
  const handleDeleteServer = () => { if (!canManageServer) return; const remaining = servers.filter(s => s.id !== activeServerId); setServers(remaining); setActiveServerId('home'); setShowServerSettingsModal(false); };

  const activeFriend = activeDmId ? friends.find(d => d.id === activeDmId) : null;
const friendForChat = activeFriend ? {
    id: activeFriend.id,
    name: activeFriend.username,
    avatar: activeFriend.avatarUrl,
    status: activeFriend.status,
    wallpaperUrl: (activeFriend as any).wallpaperUrl || null,
    wallpaperBrightness: (activeFriend as any).wallpaperBrightness ?? 40,
    purchasedWallpapers: (activeFriend as any).purchasedWallpapers || null,
    relationship: activeFriend.relationship,
    isDmOpen: activeFriend.isDmOpen,
    isBot: (activeFriend as any).isBot || false,
    plan: (activeFriend as any).plan || 'standard',
    isPremium: (activeFriend as any).isPremium || false,
    isElite: (activeFriend as any).isElite || false,
  } : { id: '0', name: 'Unknown', avatar: '', status: 'offline', wallpaperUrl: undefined, wallpaperBrightness: 40, purchasedWallpapers: undefined, relationship: 'none' as any, isDmOpen: false, isBot: false, plan: 'standard', isPremium: false, isElite: false };  
  
  // 🚀 ÖLÜMSÜZ DM İÇİN ÖZEL GİYDİRİCİ
  const ongoingFriendRaw = ongoingDmCall ? friends.find(f => f.id === ongoingDmCall.id) : null;
  const ongoingFriendForChat = ongoingFriendRaw ? {
    id: ongoingFriendRaw.id,
    name: ongoingFriendRaw.username,
    avatar: ongoingFriendRaw.avatarUrl,
    status: ongoingFriendRaw.status,
    wallpaperUrl: (ongoingFriendRaw as any).wallpaperUrl || null,
    wallpaperBrightness: (ongoingFriendRaw as any).wallpaperBrightness ?? 40,
    purchasedWallpapers: (ongoingFriendRaw as any).purchasedWallpapers || null,
    relationship: ongoingFriendRaw.relationship,
    isDmOpen: ongoingFriendRaw.isDmOpen,
    isBot: (ongoingFriendRaw as any).isBot || false
  } : friendForChat;
  
  const visibleDms = friends.filter(f => f.isDmOpen);
  const ownedServers = currentUser ? servers.filter(s => s.ownerId === currentUser?.id) : [];

 

  const renderSidebarProfileAvatar = () => {
    if (!currentUser) return null;
    
    let frameType: 'none' | 'premium' | 'elite' | 'legendary' | 'showcase' = 'none';
    const selected = currentUser.selectedFrame;
    
if (selected === 'legendary' && currentUser.isLegendary) frameType = 'legendary';
    else if (selected === 'elite' && (currentUser.isLegendary || currentUser.plan === 'elite' || currentUser.isElite)) frameType = 'elite';
    else if (selected === 'premium' && (currentUser.isLegendary || currentUser.plan === 'elite' || currentUser.isElite || currentUser.plan === 'premium' || currentUser.isPremium)) frameType = 'premium';
    else if (selected === 'showcase' && currentUser.isShowcase) frameType = 'showcase';
    else if (selected === 'standard') frameType = 'none';
    else {
        if (currentUser.isLegendary) frameType = 'legendary';
        else if (currentUser.plan === 'elite' || currentUser.isElite) frameType = 'elite';
        else if (currentUser.plan === 'premium' || currentUser.isPremium) frameType = 'premium';
        else if (currentUser.isShowcase) frameType = 'showcase';
    }
    if (frameType === 'showcase') {
        return (
            <div className="absolute inset-0">
               <div className="absolute -top-1.5 left-1/2 -translate-x-1/2 z-20 text-white drop-shadow-[0_0_5px_rgba(255,255,255,0.8)] animate-pulse">
                  <Crown size={12} fill="currentColor" />
               </div>
               <div className="absolute inset-[-2px] rounded-full bg-gradient-to-tr from-emerald-500 via-green-400 to-emerald-600 p-[1.5px] shadow-sm">
                  <div className="w-full h-full rounded-full overflow-hidden border border-black bg-black">
                      <img src={currentUser.avatarUrl} className="w-full h-full object-cover" />
                  </div>
               </div>
            </div>
        );
    }

    if (frameType === 'legendary') {
        return (
            <div className="absolute inset-0">
               <div className="absolute -top-1.5 left-1/2 -translate-x-1/2 z-20 text-yellow-400 drop-shadow-[0_0_5px_rgba(255,215,0,0.8)] animate-bounce-slow">
                  <Crown size={12} fill="currentColor" />
               </div>
               <div className="absolute inset-[-3px] rounded-full bg-gradient-to-tr from-sesgelio via-purple-600 to-yellow-400 p-[1.5px] animate-spin-slow opacity-80"></div>
               <div className="absolute inset-0 rounded-full bg-gradient-to-tr from-sesgelio via-purple-600 to-yellow-400 p-[1.5px] shadow-lg">
                  <div className="w-full h-full rounded-full overflow-hidden border border-black bg-black">
                      <img src={currentUser.avatarUrl} className="w-full h-full object-cover" />
                  </div>
               </div>
            </div>
        );
    }

    if (frameType === 'elite') {
        return (
            <div className="absolute inset-0">
                <div className="absolute -top-1.5 left-1/2 -translate-x-1/2 z-20 text-yellow-500 drop-shadow-sm animate-pulse">
                    <Crown size={11} fill="currentColor" />
                </div>
                <div className="absolute inset-[-2.5px] rounded-full bg-gradient-to-tr from-yellow-400 via-black to-amber-600 p-[1.5px] animate-pulse">
                    <div className="w-full h-full rounded-full overflow-hidden border border-black bg-black">
                        <img src={currentUser.avatarUrl} className="w-full h-full object-cover" />
                    </div>
                </div>
            </div>
        );
    }

    if (frameType === 'premium') {
        return (
            <div className="absolute inset-0">
                <div className="absolute -top-1 left-1/2 -translate-x-1/2 z-20 text-red-500 drop-shadow-sm">
                    <Crown size={10} fill="currentColor" />
                </div>
                <div className="absolute inset-[-2px] rounded-full bg-gradient-to-tr from-red-600 via-black to-red-800 p-[1.5px] shadow-sm">
                    <div className="w-full h-full rounded-full overflow-hidden border border-black">
                        <img src={currentUser.avatarUrl} className="w-full h-full object-cover" />
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="w-full h-full rounded-full bg-gray-300 dark:bg-gray-700 overflow-hidden ring-2 ring-transparent group-hover:ring-sesgelio transition-all">
            <img src={currentUser.avatarUrl} className="w-full h-full object-cover grayscale opacity-50" />
        </div>
    );
  };

const renderChannelAvatar = (user: User) => {
    let frameType: 'none' | 'premium' | 'elite' | 'legendary' | 'showcase' | 'bot' = 'none';
    const selected = user.selectedFrame;

    // 🚀 YEŞİL IŞIK VE PARLAMA EFEKTİ (Adam konuşuyorsa devreye girer)
    const isTalking = globalSpeakingUsers[user.id] || false;
    const talkingClass = isTalking ? 'ring-2 ring-green-500 shadow-[0_0_12px_rgba(34,197,94,0.9)] scale-110 z-10' : 'ring-2 ring-transparent';

    // 1. MÜHÜR: Önce Seçimlere Bak
    if (user.isBot || user.id.startsWith('b-') || user.username?.includes('AI') || user.username?.includes('Sesgelio AudioLink')) {
        frameType = 'bot';
    } else if (selected === 'standard') {
        frameType = 'none'; 
    } else if (selected === 'showcase') {
        frameType = 'showcase'; 
    } else if (selected === 'legendary' && user.isLegendary) {
        frameType = 'legendary';
    } else if (selected === 'elite' && (user.isLegendary || user.plan === 'elite' || user.isElite)) {
        frameType = 'elite';
    } else if (selected === 'premium' && (user.isLegendary || user.plan === 'elite' || user.plan === 'premium' || user.isPremium)) {
        frameType = 'premium';
    } 
    // 2. MÜHÜR: Rütbeye Bak
    else if (frameType === 'none') {
        if (user.isLegendary) frameType = 'legendary';
        else if (user.plan === 'elite' || user.isElite) frameType = 'elite';
        else if (user.plan === 'premium' || user.isPremium) frameType = 'premium';
        else if (user.isShowcase) frameType = 'showcase';
    }

    const baseClass = "w-5 h-5 rounded-full object-cover shrink-0 transition-all duration-200";

    if (frameType === 'legendary') {
        return (
            <div className={`relative w-5 h-5 mr-2 shrink-0 transition-all duration-200 ${talkingClass} rounded-full`}>
                <div className="absolute inset-[-2px] rounded-full bg-gradient-to-tr from-sesgelio via-purple-600 to-yellow-400 p-[1px] animate-spin-slow"></div>
                <div className="absolute inset-0 rounded-full overflow-hidden border border-black bg-black">
                    <img src={user.avatarUrl} className="w-full h-full object-cover" />
                </div>
            </div>
        );
    }
    
    if (frameType === 'elite') {
        return (
            <div className={`relative w-5 h-5 mr-2 shrink-0 transition-all duration-200 ${talkingClass} rounded-full`}>
                <div className="absolute inset-[-1px] rounded-full bg-gradient-to-tr from-yellow-400 to-amber-600 p-[1px] animate-pulse"></div>
                <div className="absolute inset-0 rounded-full overflow-hidden border border-black">
                    <img src={user.avatarUrl} className="w-full h-full object-cover" />
                </div>
            </div>
        );
    }

    if (frameType === 'premium') {
        return (
            <div className={`relative w-5 h-5 mr-2 shrink-0 transition-all duration-200 ${talkingClass} rounded-full`}>
                <div className="absolute inset-[-1px] rounded-full bg-gradient-to-tr from-red-600 via-black to-red-800 p-[1px]"></div>
                <div className="absolute inset-0 rounded-full overflow-hidden border border-black">
                    <img src={user.avatarUrl} className="w-full h-full object-cover" />
                </div>
            </div>
        );
    }

    if (frameType === 'showcase') {
        return (
            <div className={`relative w-5 h-5 mr-2 shrink-0 transition-all duration-200 ${talkingClass} rounded-full`}>
                <div className="absolute inset-[-1.5px] rounded-full bg-gradient-to-tr from-emerald-500 via-green-400 to-emerald-600 p-[1px] shadow-[0_0_5px_rgba(16,185,129,0.4)]"></div>
                <div className="absolute inset-0 rounded-full overflow-hidden border border-black bg-black">
                    <img src={user.avatarUrl} className="w-full h-full object-cover" />
                </div>
            </div>
        );
    }

    if (frameType === 'bot') {
        return (
            <div className={`relative w-5 h-5 mr-2 shrink-0 transition-all duration-200 ${talkingClass} rounded-full`}>
                <div className="absolute inset-[-1.5px] rounded-full bg-gradient-to-tr from-blue-500 to-sesgelio p-[1px]"></div>
                <div className="absolute inset-0 rounded-full overflow-hidden border border-black">
                    <img src={user.avatarUrl} className="w-full h-full object-cover" />
                </div>
            </div>
        );
    }

    return (
        <img src={user.avatarUrl} className={`${baseClass} mr-2 border ${user.id === currentUser?.id ? 'border-sesgelio' : 'border-gray-200 dark:border-gray-700'} grayscale opacity-50 ${talkingClass}`} />
    );
  };
 // --- 🚀 YÖNETİCİ MÜHÜRLERİ: ZORLA TAŞIMA VE ODADAN ATMA DİNLEYİCİSİ ---
  useEffect(() => {
      if (!socketRef.current || !currentUser) return;

      const handleForceMove = (newChannelId: string) => {
          let targetChannel: Channel | null = null;
          let targetServerId: string | null = null;
          
          // 1. Hedef kanalı tüm sunucular içinde ara
          for (const server of servers) {
              const found = server.channels?.find(c => c.id === newChannelId);
              if (found) {
                  targetChannel = found;
                  targetServerId = server.id;
                  break;
              }
          }

          if (targetChannel && targetServerId) {
              // 2. Eğer farklı bir sunucuya çekiliyorsa arayüzü o sunucuya kaydır
              if (activeServerId !== targetServerId) {
                  setActiveServerId(targetServerId);
              }
              // 3. Odaya bağlanma fonksiyonunu sanki adam kendi tıklamış gibi tetikle
              handleChannelClick(targetChannel);
          }
      };

      const handleForceLeave = () => {
          // Direkt olarak bağlantıyı koparır ve sesi keser
          handleDisconnect();
      };

      // Dinleyicileri sokete bağla
      socketRef.current.on(`force-move-voice-${currentUser?.id}`, handleForceMove);
      socketRef.current.on(`force-leave-voice-${currentUser?.id}`, handleForceLeave);

      return () => {
          // Component güncellenirken eski dinleyicileri temizle
          socketRef.current?.off(`force-move-voice-${currentUser?.id}`, handleForceMove);
          socketRef.current?.off(`force-leave-voice-${currentUser?.id}`, handleForceLeave);
      };
  }, [currentUser, servers, activeServerId]);

 if (show2FALogin) {
    return (
      <div className="h-screen w-full bg-[#0a0a0c] flex items-center justify-center p-4 z-[9999] fixed inset-0">
        <div className="bg-[#1e1f22] p-10 rounded-[2.5rem] border border-white/10 w-full max-w-md shadow-2xl animate-fade-in-up text-center relative overflow-hidden">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-32 h-32 bg-green-500/10 blur-[80px]"></div>
          
          <div className="w-20 h-20 bg-green-500/10 rounded-3xl flex items-center justify-center text-green-500 mx-auto mb-8 border border-green-500/20 rotate-3">
            <ShieldCheck size={44} />
          </div>
          
          <h2 className="text-3xl font-black text-white uppercase tracking-tighter mb-2 italic text-sesgelio">GÜVENLİK MÜHÜRÜ</h2>
          <p className="text-gray-400 text-sm mb-10 px-4 leading-relaxed">
            Sesgelio hesabın mühürlü . <br/> 
            <strong className="text-white font-black">Gmail</strong> adresine gelen 6 haneli kodu gir.
          </p>

          <input 
            type="text" 
            maxLength={6}
            placeholder="000000"
            value={twoFALoginCode}
            onChange={(e) => setTwoFALoginCode(e.target.value.replace(/\D/g, ''))}
            className="w-full bg-black/40 border border-white/10 p-6 rounded-2xl text-white text-center text-4xl font-mono tracking-[0.5em] mb-8 outline-none focus:border-green-500 transition-all shadow-inner"
            autoFocus
          />

          <div className="space-y-4">
            <button 
              onClick={async () => {
                const res = await fetch(`${BACKEND_URL}/api/login/verify-2fa`, {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({ userId: tempUserId, code: twoFALoginCode })
                });
             const data = await res.json();
if (data.user) {
  setCurrentUser(data.user);
  localStorage.setItem('saved_user_profile', JSON.stringify(data.user));
                  setShow2FALogin(false);
                  setShowLanding(false); 
                  handleConnect();
                } else {
                  alert("Mühür kodu hatalı nöral dostum!");
                } 
              }}
              className="w-full bg-green-600 hover:bg-green-500 text-white font-black py-5 rounded-2xl shadow-xl shadow-green-600/20 transition-all transform active:scale-95 uppercase tracking-widest"
            >
              Mührü Doğrula ve Bağlan
            </button>
            <button 
              onClick={() => { setShow2FALogin(false); setShowLanding(true); }}
              className="text-gray-500 font-bold hover:text-white transition-colors text-xs uppercase tracking-widest"
            >
              Geri Dön
            </button>
          </div>
        </div>
      </div>
    );
  }

// 🛡️ KUSURSUZ AVATAR MOTORU (App.tsx İçin)
  const getSafeAvatar = (url?: string) => {
      if (!url) return 'https://ui-avatars.com/api/?name=User';
if (url.startsWith('http') || url.startsWith('data:')) return url;
      const cleanBase = BACKEND_URL.endsWith('/') ? BACKEND_URL.slice(0, -1) : BACKEND_URL;
      const cleanUrl = url.startsWith('/') ?
url : `/${url}`;
      return `${cleanBase}${cleanUrl}`;
  };

  // 🚀 KURUCU TOPLULUKLAR SAYFASI YÖNLENDİRİCİSİ (URL KONTROLÜ)
  const isKurucuTopluluklarPage = window.location.pathname === '/kurucu-topluluklar';

  if (isKurucuTopluluklarPage) {
    return <KurucuTopluluklar />;
  }

  // 🏢 OMNIO & B2B GÖMÜLÜ PANEL YÖNLENDİRİCİSİ
if (
  window.location.pathname === '/embed' ||
  window.location.pathname.startsWith('/embed/') ||
  window.location.pathname.startsWith('/b2b')
) {
  return <B2BEmbedPortal />;
}

// 👑 SESGELİO STUDIOS MASTER DASHBOARD (SADECE PATRON TAKİP PANELİ)
if (window.location.pathname === '/studios') {
  return <SesgelioStudiosDashboard />;
}
  
if (showLanding || !currentUser) {
  return (
   <GoogleOAuthProvider clientId="447009817928-oipblt9s3ubui0dktlkaas18bu301qk0.apps.googleusercontent.com">
    <Dashboard user={currentUser || { id: '', username: '', discriminator: '0000', avatarUrl: '', status: 'offline' }} onConnect={handleLogin} />

{/* 🚀 DEVRİMSEL: UYGULAMA SEÇİM MODALI (AKILLI KONTROL) */}
        {inviteChoiceCode && !showDownloadPrompt && (
          <div className="fixed inset-0 z-[99999] bg-black/80 backdrop-blur-md flex items-center justify-center p-4 animate-fade-in">
            <div className="bg-[#111214] border border-sesgelio/50 rounded-3xl p-8 max-w-sm w-full shadow-[0_0_100px_rgba(255,43,94,0.2)] flex flex-col items-center text-center animate-scale-in relative overflow-hidden">
              <div className="w-20 h-20 bg-sesgelio/20 rounded-2xl flex items-center justify-center text-sesgelio mb-6 border border-sesgelio/30 shadow-inner rotate-3">
                <Compass size={40} />
              </div>
              <h2 className="text-2xl font-black text-white mb-2 uppercase tracking-tight">Sunucuya Katıl</h2>
              <p className="text-sm font-medium text-gray-400 mb-8">Daveti nerede açmak istiyorsun nöral dostum?</p>

              <div className="flex flex-col gap-3 w-full relative z-10">
                <button 
                  onClick={() => {
                    // 1. Masaüstü uygulamasını tetikle!
                    window.location.href = `sesgelio://davet/${inviteChoiceCode}`;
                    
                    // 🚀 2. AKILLI KRONOMETRE: 2.5 Saniye sonra adam hala ekrandaysa uygulama yok demektir!
                    setTimeout(() => {
                       if (!document.hidden) {
                           setShowDownloadPrompt(true); // İndirme ekranını çıkart!
                       } else {
                           setInviteChoiceCode(null); // Uygulama açıldıysa modalı temizle
                       }
                    }, 2500);
                  }}
                  className="w-full py-4 rounded-xl bg-sesgelio hover:bg-[#ff4b72] text-white font-black uppercase tracking-wider transition-all shadow-[0_0_20px_rgba(255,43,94,0.4)] active:scale-95 flex items-center justify-center gap-2"
                >
                  <MonitorUp size={18} /> Uygulamada Aç
                </button>
                
                <button 
                  onClick={() => {
                    if (currentUser) {
                      handleJoinServer(inviteChoiceCode, currentUser);
                    } else {
                      localStorage.setItem('pendingInvite', inviteChoiceCode);
                    }
                    setInviteChoiceCode(null);
                  }}
                  className="w-full py-4 rounded-xl bg-white/5 hover:bg-white/10 text-gray-300 hover:text-white border border-white/10 font-bold uppercase tracking-wider transition-all active:scale-95 flex items-center justify-center gap-2"
                >
                  Tarayıcıda Devam Et
                </button>
              </div>
            </div>
          </div>
        )}

     {/* 🚀 YENİ: UYGULAMA BULUNAMADI / İNDİR MODALI (PREMIUM TASARIM) */}
        {showDownloadPrompt && inviteChoiceCode && (
          <div className="fixed inset-0 z-[99999] bg-black/80 backdrop-blur-md flex items-center justify-center p-4 animate-fade-in">
            {/* 🚀 ÇÖZÜM: Tooltip'lerin kesilmemesi için overflow-hidden kaldırıldı! */}
            <div className="bg-[#0a0a0c] border border-gray-800 rounded-3xl p-6 max-w-sm w-full shadow-[0_0_100px_rgba(255,255,255,0.03)] flex flex-col items-center text-center animate-scale-in relative">
              
              <div className="w-16 h-16 bg-gray-800/30 rounded-2xl flex items-center justify-center text-gray-400 mb-4 border border-gray-700/50 shadow-inner">
                <Monitor size={32} className="text-sesgelio" />
              </div>
              <h2 className="text-xl font-black text-white mb-1 uppercase tracking-tight">Uygulama Yok</h2>
              <p className="text-xs font-medium text-gray-400 mb-6 px-2">Sesgelio cihazında yüklü değil. Hemen işletim sistemine uygun sürümü indir!</p>

              {/* 🚀 SENİN EFSANE MENÜ TASARIMIN (MODAL İÇİNE UYARLANDI) */}
              <div className="flex flex-col gap-2 w-full relative z-10 mb-6 text-left">
                
                {/* Windows */}
                <a href="/downloads/Sesgelio%20Setup%201.0.0.exe" download className="group relative flex items-center gap-3 px-3 py-3 rounded-xl bg-white/5 border border-white/5 hover:bg-white/10 hover:border-blue-500/30 transition-all cursor-pointer">
                  <div className="relative z-10 w-10 h-10 bg-[#111214] border border-blue-500/20 rounded-xl flex items-center justify-center shrink-0 shadow-[0_0_15px_rgba(59,130,246,0.15)] group-hover:scale-110 transition-all duration-300 text-blue-400">
                    <svg viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5 group-hover:brightness-125 transition-all">
                      <path d="M0 0h11.4v11.4H0zm12.6 0H24v11.4H12.6zM0 12.6h11.4V24H0zm12.6 0H24V24H12.6z"/>
                    </svg>
                  </div>
                  <div className="flex flex-col relative z-10 flex-1">
                    <span className="text-white text-sm font-bold group-hover:text-blue-400 transition-colors duration-300">Windows</span>
                    <span className="text-gray-500 text-[10px] font-medium">Setup 1.0.0 · 64-bit</span>
                  </div>
                  <span className="relative z-10 text-[10px] font-black text-white bg-blue-600 hover:bg-blue-500 px-3 py-1.5 rounded-lg uppercase tracking-wider shadow-[0_0_15px_rgba(37,99,235,0.4)] transition-all active:scale-95">
                    İNDİR
                  </span>
                </a>

                {/* macOS */}
                <a href="/downloads/Sesgelio-1.0.0-arm64.dmg" download className="group relative flex items-center gap-3 px-3 py-3 rounded-xl bg-white/5 border border-white/5 hover:bg-white/10 hover:border-gray-500/30 transition-all cursor-pointer">
                  <div className="relative z-10 w-10 h-10 bg-[#111214] border border-gray-500/20 rounded-xl flex items-center justify-center shrink-0 shadow-[0_0_15px_rgba(156,163,175,0.15)] group-hover:scale-110 transition-all duration-300">
                    <img src="https://cdn.simpleicons.org/apple/9ca3af" alt="macOS" className="w-5 h-5 group-hover:brightness-125 transition-all" />
                  </div>
                  <div className="flex flex-col relative z-10 flex-1">
                    <div className="flex items-center gap-1.5 relative group/tooltip">
                      <span className="text-white text-sm font-bold group-hover:text-gray-300 transition-colors duration-300">macOS</span>
                      <div onClick={(e) => { e.preventDefault(); e.stopPropagation(); }} className="text-gray-400 hover:text-white transition-colors p-1 bg-white/5 hover:bg-white/10 rounded-md cursor-help">
                        <Info size={13} />
                      </div>
                      <div className="absolute left-1/2 bottom-full mb-2 -translate-x-1/2 w-48 p-3 bg-[#0a0a0c]/95 backdrop-blur-3xl border border-gray-700 rounded-xl shadow-[0_20px_50px_rgba(0,0,0,0.9)] opacity-0 invisible group-hover/tooltip:opacity-100 group-hover/tooltip:visible transition-all duration-300 z-[99999] pointer-events-none transform translate-y-2 group-hover/tooltip:translate-y-0 text-left">
                        <div className="absolute bottom-[-5px] left-1/2 -translate-x-1/2 w-2.5 h-2.5 bg-[#0a0a0c] border-b border-r border-gray-700 transform rotate-45"></div>
                        <h4 className="font-black text-white text-[9px] uppercase tracking-widest mb-1.5 flex items-center gap-1.5">
                          <ShieldAlert size={10} className="text-sesgelio" /> Kurulum Uyarısı
                        </h4>
                        <ol className="list-decimal pl-3 space-y-0.5 text-[8px] text-gray-300 font-medium">
                          <li>İndirdiğiniz dosyaya <strong className="text-white">Sağ Tıklayın</strong></li>
                          <li>Menüden <strong className="text-white">"Aç"</strong>a tıklayın</li>
                          <li>Uyarıdaki <strong className="text-white bg-white/10 px-1 rounded">Aç</strong> butonuna basın.</li>
                        </ol>
                      </div>
                    </div>
                    <span className="text-gray-500 text-[10px] font-medium">Apple Silicon (M Serisi)</span>
                  </div>
                  <span className="relative z-10 text-[10px] font-black text-white bg-gray-700 hover:bg-gray-600 px-3 py-1.5 rounded-lg uppercase tracking-wider shadow-[0_0_15px_rgba(75,85,99,0.4)] transition-all active:scale-95">
                    İNDİR
                  </span>
                </a>

                {/* Linux */}
                <a href="/downloads/Sesgelio-1.0.0.AppImage" download className="group relative flex items-center gap-3 px-3 py-3 rounded-xl bg-white/5 border border-white/5 hover:bg-white/10 hover:border-orange-500/30 transition-all cursor-pointer">
                  <div className="relative z-10 w-10 h-10 bg-[#111214] border border-orange-500/20 rounded-xl flex items-center justify-center shrink-0 shadow-[0_0_15px_rgba(249,115,22,0.15)] group-hover:scale-110 transition-all duration-300">
                    <img src="https://cdn.simpleicons.org/ubuntu/f97316" alt="Linux" className="w-5 h-5 group-hover:brightness-125 transition-all" />
                  </div>
                  <div className="flex flex-col relative z-10 flex-1">
                    <span className="text-white text-sm font-bold group-hover:text-orange-400 transition-colors duration-300">Linux</span>
                    <span className="text-gray-500 text-[10px] font-medium">AppImage · x64</span>
                  </div>
                  <span className="relative z-10 text-[10px] font-black text-white bg-orange-600 hover:bg-orange-500 px-3 py-1.5 rounded-lg uppercase tracking-wider shadow-[0_0_15px_rgba(234,88,12,0.4)] transition-all active:scale-95">
                    İNDİR
                  </span>
                </a>
                
              </div>

              {/* Alt Buton: Tarayıcıda Devam Et */}
              <button 
                onClick={() => {
                  if (currentUser) {
                    handleJoinServer(inviteChoiceCode, currentUser);
                  } else {
                    localStorage.setItem('pendingInvite', inviteChoiceCode);
                  }
                  setInviteChoiceCode(null);
                  setShowDownloadPrompt(false);
                }}
                className="w-full py-3.5 rounded-xl bg-transparent hover:bg-white/5 text-gray-400 hover:text-white border border-gray-800 hover:border-gray-600 font-bold uppercase tracking-wider transition-all active:scale-95 text-xs flex items-center justify-center gap-2"
              >
                Şimdilik Tarayıcıda Devam Et
              </button>

            </div>
          </div>
        )}
        
        {/* 🚀 ŞİFRE SIFIRLAMA MODALI BURAYA EKLENDİ */}
        {resetToken && (
            <div className="fixed inset-0 z-[99999] bg-black/90 backdrop-blur-md flex items-center justify-center p-4 animate-fade-in">
                <div className="bg-[#111214] border border-sesgelio/30 rounded-[2rem] w-full max-w-md shadow-[0_0_50px_rgba(255,43,94,0.15)] flex flex-col items-center p-10 relative overflow-hidden animate-scale-in">
                    <div className="absolute top-0 left-1/2 -translate-x-1/2 w-32 h-32 bg-sesgelio/20 blur-[60px] pointer-events-none"></div>
                    <div className="w-20 h-20 bg-sesgelio/10 rounded-3xl flex items-center justify-center text-sesgelio mb-6 border border-sesgelio/20 shadow-inner rotate-3">
                        <Key size={40} />
                    </div>
                    <h2 className="text-2xl font-black text-white mb-2 uppercase tracking-tight italic relative z-10">ŞİFRENİ YENİLE</h2>
                    <p className="text-gray-400 text-sm text-center mb-8 relative z-10">
                        Evrene geri dönmek için yeni şifreni belirle . Güçlü bir şifre seçmeyi unutma!
                    </p>
                    <input 
                        type="password" placeholder="Yeni Şifre" value={newPasswordInput} onChange={(e) => setNewPasswordInput(e.target.value)}
                        className="w-full bg-black/50 border border-gray-800 rounded-xl px-5 py-4 text-white text-sm focus:border-sesgelio outline-none transition-all mb-4 relative z-10"
                    />
                    <input 
                        type="password" placeholder="Yeni Şifre (Tekrar)" value={confirmNewPasswordInput} onChange={(e) => setConfirmNewPasswordInput(e.target.value)}
                        className="w-full bg-black/50 border border-gray-800 rounded-xl px-5 py-4 text-white text-sm focus:border-sesgelio outline-none transition-all mb-8 relative z-10"
                    />
                    <div className="flex gap-3 w-full relative z-10">
                        <button 
                            onClick={() => { setResetToken(null); setNewPasswordInput(''); setConfirmNewPasswordInput(''); window.location.href = "/"; }} 
                            className="px-5 py-3.5 rounded-xl font-bold text-gray-400 hover:text-white bg-gray-800 hover:bg-gray-700 transition-colors text-sm"
                        >
                            İptal
                        </button>
                        <button 
                            disabled={isResettingPassword || !newPasswordInput || newPasswordInput !== confirmNewPasswordInput}
                            onClick={async () => {
                                setIsResettingPassword(true);
                                try {
                                    const res = await fetch(`${BACKEND_URL}/api/reset-password`, { 
                                        method: 'POST', headers: { 'Content-Type': 'application/json' },
                                        body: JSON.stringify({ token: resetToken, newPassword: newPasswordInput })
                                    });
                                    const data = await res.json();
                                    if (res.ok) {
                                        alert("Şifren başarıyla sıfırlandı nöral dostum! Şimdi yeni şifrenle giriş yapabilirsin.");
                                        setResetToken(null);
                                        localStorage.removeItem('saved_user_profile');
                                        sessionStorage.clear();
                                        window.location.href = "/";
                                    } else {
                                        alert(data.error || "Şifre sıfırlanırken bir hata oluştu.");
                                    }
                                } catch (err) { alert("Bağlantı hatası! Sunucuya ulaşılamıyor."); }
                                setIsResettingPassword(false);
                            }}
                            className="flex-1 bg-sesgelio hover:bg-sesgelio-dark text-white px-5 py-3.5 rounded-xl font-black uppercase tracking-wider shadow-[0_0_20px_rgba(255,43,94,0.3)] transition-all text-sm disabled:opacity-50 disabled:cursor-not-allowed flex justify-center items-center gap-2 active:scale-95"
                        >
                            {isResettingPassword ? <Loader2 size={18} className="animate-spin"/> : 'SIFIRLA'}
                        </button>
                    </div>
                </div>
            </div>
        )}
      </GoogleOAuthProvider>
    ); 
  }
return (
    <Suspense fallback={
      <div className="h-[100dvh] w-full flex items-center justify-center bg-[#030303]">
        <div className="w-10 h-10 border-4 border-sesgelio border-t-transparent rounded-full animate-spin"></div>
      </div>
    }>
    <div className="h-[100dvh] w-full flex bg-gray-50 dark:bg-[#030303] font-sans overflow-hidden transition-colors duration-300">

<SesgelioTour />
{showServerTour && <ServerTour onClose={() => setShowServerTour(false)} />}

{/* 👇 MOBİL ÇEKMECE BUTONU VE BAŞLANGICI BURADAN EKLENDİ 👇 */}
{!showSettings && (
  <button 
    onClick={() => setIsMobileDrawerOpen(!isMobileDrawerOpen)}
    className={`md:hidden fixed z-[200] p-2.5 backdrop-blur-xl rounded-2xl border shadow-[0_0_30px_rgba(0,0,0,0.5)] transition-all duration-500 ease-in-out flex items-center justify-center ${
      isMobileDrawerOpen 
        ? 'right-4 rotate-90 bg-red-500/20 text-red-400 border-red-500/30' 
        : 'left-3 rotate-0 bg-black/80 text-white border-white/10'
    }`}
    style={{ top: 'max(24px, env(safe-area-inset-top))' }}
  >
    {isMobileDrawerOpen ? <X size={26} /> : <Menu size={26} />}
  </button>
)}

<div className={`fixed inset-y-0 left-0 z-[150] flex h-full transform transition-transform duration-300 ease-in-out md:relative md:transform-none ${isMobileDrawerOpen ? 'translate-x-0' : '-translate-x-full'}`}>
{/* 👆 MOBİL ÇEKMECE BAŞLANGICI 👆 */}

  {/* ⚡ HIZLI GEÇİŞ (QUICK SWITCHER) MODALI */}
      {showQuickSwitcher && (
        <div className="fixed inset-0 z-[9999] bg-black/60 backdrop-blur-sm flex items-start justify-center pt-[10vh] p-4 animate-fade-in" onClick={() => setShowQuickSwitcher(false)}>
          <div className="bg-white dark:bg-[#111214] w-full max-w-2xl rounded-2xl shadow-[0_20px_60px_rgba(0,0,0,0.4)] border border-gray-200 dark:border-white/10 overflow-hidden flex flex-col animate-scale-in" onClick={e => e.stopPropagation()}>
            
            {/* Arama Çubuğu */}
            <div className="p-4 border-b border-gray-200 dark:border-white/10 flex items-center gap-3 bg-gray-50 dark:bg-black/20">
              <Search size={24} className="text-gray-400" />
              <input
                type="text"
                autoFocus
                placeholder="Nereye ışınlanmak istiyorsun? (Kişi, Kanal, Sunucu...)"
                value={quickQuery}
                onChange={(e) => { setQuickQuery(e.target.value); setQuickSelectedIndex(0); }}
                onKeyDown={(e) => {
                    if (e.key === 'ArrowDown') {
                        e.preventDefault();
                        setQuickSelectedIndex(prev => (prev < quickSearchResults.length - 1 ? prev + 1 : prev));
                    } else if (e.key === 'ArrowUp') {
                        e.preventDefault();
                        setQuickSelectedIndex(prev => (prev > 0 ? prev - 1 : 0));
                    } else if (e.key === 'Enter' && quickSearchResults[quickSelectedIndex]) {
                        e.preventDefault();
                        executeQuickAction(quickSearchResults[quickSelectedIndex]);
                    }
                }}
                className="flex-1 bg-transparent border-none outline-none text-lg font-medium text-gray-900 dark:text-white placeholder-gray-400"
              />
              <div className="flex gap-1">
                <kbd className="bg-white dark:bg-[#1e1f22] border border-gray-200 dark:border-white/10 text-gray-400 text-xs px-2 py-1 rounded-md font-bold shadow-sm">ESC</kbd>
              </div>
            </div>

            {/* Sonuçlar */}
            <div className="max-h-[50vh] overflow-y-auto custom-scrollbar p-2">
              {quickSearchResults.length > 0 ? (
                quickSearchResults.map((item, index) => (
                  <div 
                    key={`${item.type}-${item.id}`}
                    onMouseEnter={() => setQuickSelectedIndex(index)}
                    onClick={() => executeQuickAction(item)}
                    className={`flex items-center justify-between p-3 rounded-xl cursor-pointer transition-colors ${index === quickSelectedIndex ? 'bg-sesgelio/10 border border-sesgelio/30' : 'hover:bg-gray-100 dark:hover:bg-white/5 border border-transparent'}`}
                  >
                    <div className="flex items-center gap-3">
                      <div className={`p-2 rounded-lg ${index === quickSelectedIndex ? 'bg-sesgelio/20' : 'bg-gray-100 dark:bg-white/5'}`}>
                          {item.icon}
                      </div>
                      <div className="flex flex-col">
                        <span className={`text-sm font-bold ${index === quickSelectedIndex ? 'text-sesgelio' : 'text-gray-900 dark:text-white'}`}>{item.title}</span>
                        <span className="text-[10px] uppercase tracking-widest text-gray-500 font-bold">{item.subtitle}</span>
                      </div>
                    </div>
                    {index === quickSelectedIndex && <span className="text-[10px] font-black text-sesgelio uppercase tracking-widest mr-2 animate-pulse">ENTER ↵</span>}
                  </div>
                ))
              ) : quickQuery.trim() ? (
                <div className="p-8 flex flex-col items-center justify-center text-center">
                    <Ghost size={48} className="text-gray-300 dark:text-gray-600 mb-4" />
                    <span className="text-gray-500 font-bold">Hiçbir sonuç bulamadım nöral dostum.</span>
                </div>
              ) : (
                <div className="p-6 flex flex-col items-center justify-center text-center opacity-50">
                    <Command size={48} className="text-gray-400 mb-4" />
                    <span className="text-xs text-gray-500 font-bold uppercase tracking-widest mb-2">HIZLI KOMUT MERKEZİ</span>
                    <span className="text-sm text-gray-400">Sunucular, kanallar ve arkadaşların arasında ışık hızında gezin.</span>
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {/* 🚀 MÜHÜR EKLENDİ: callerAvatar artık getSafeAvatar içinden geçiyor! */}
     {incomingCall && <IncomingCallModal callerName={incomingCall.callerName} callerAvatar={getAbsoluteAvatar(incomingCall.callerAvatar)} onAccept={handleAcceptCall} onDecline={handleDeclineCall} />}      {activeGeminiSession && (
        <GlobalGeminiSession 
          currentUser={currentUser} 
          mode={activeGeminiSession} 
          onClose={() => setActiveGeminiSession(null)} 
        />
      )}
      {showSettings && currentUser && ( <UserSettings 
  user={currentUser} 
  currentTheme={theme} 
  /* Tema değiştiğinde hem ekranda göster hem de veritabanına kaydet */
  onThemeChange={(newTheme) => {
    setTheme(newTheme);
    handleUpdateUser({ theme: newTheme });
  }} 
  onClose={() => setShowSettings(false)} 
  onLogout={handleLogout} 
  onUpdateUser={handleUpdateUser} 
  ownedServers={ownedServers} 
  onBotPurchase={handleBotPurchase} 
  initialTab={settingsInitialTab} 
  onNavigateToServer={(serverId) => handleServerClick(serverId)} 
/> )}
      
      {showCreateChannelModal && <CreateChannelModal defaultType={createChannelDefaultType} onClose={() => { setShowCreateChannelModal(false); setCreateChannelDefaultType(null); setCreateChannelTargetFolderId(null); }} onCreate={handleAddChannel} />}
      {showServerSettingsModal && activeServer && ( <ServerSettingsModal server={activeServer} onClose={() => setShowServerSettingsModal(false)} onSave={handleUpdateServer} onDelete={canManageServer ? handleDeleteServer : undefined} onDeleteChannel={handleDeleteChannel}  onAddChannel={handleAddChannel} onOpenMarket={handleOpenMarket} onToggleBot={(id, val) => handleToggleBotActivity(activeServer.id, id, val)} currentUser={currentUser} socket={socketRef.current} userPermissions={memberRole?.permissions || []} isOwner={isServerOwner}  /> )}
      {showLeaderboardModal && activeServer && currentUser && ( <LeaderboardModal server={activeServer} currentUser={currentUser} onClose={() => setShowLeaderboardModal(false)} onOpenMarket={handleOpenMarket} socket={socketRef.current as any} /> )}
    
    {showFolderModal && folderTargetServerId && (
        <div className="fixed inset-0 z-[600] bg-black/80 backdrop-blur-md flex items-center justify-center p-4 animate-fade-in" onClick={() => setShowFolderModal(false)}>
            <div className="bg-[#111214] border border-indigo-500/30 rounded-3xl w-full max-w-sm shadow-[0_0_50px_rgba(99,102,241,0.15)] p-6 flex flex-col animate-scale-in relative overflow-hidden" onClick={e => e.stopPropagation()}>
                <div className="absolute top-0 left-1/2 -translate-x-1/2 w-32 h-32 bg-indigo-500/20 blur-[60px] pointer-events-none"></div>
                
                <div className="flex justify-between items-center mb-6 relative z-10">
                    <h3 className="text-lg font-black text-white uppercase tracking-tight flex items-center gap-2">
                        <FolderPlus className="text-indigo-500"/> Klasöre Ekle
                    </h3>
                    <button onClick={() => setShowFolderModal(false)} className="text-gray-500 hover:text-white transition-colors"><X size={20}/></button>
                </div>

                {serverFolders.length > 0 && (
                    <div className="mb-6 relative z-10">
                        <label className="block text-xs font-bold text-gray-500 uppercase tracking-widest mb-3">Mevcut Klasörler</label>
                        <div className="space-y-2 max-h-40 overflow-y-auto custom-scrollbar pr-2">
                        {serverFolders.map(folder => {
 const isInside = folder.serverIds.includes(folderTargetServerId);
 return (
<div key={folder.id} className={`w-full flex items-center justify-between p-3 rounded-xl border transition-all ${isInside ? 'bg-indigo-500/10 border-indigo-500/50' : 'bg-white/5 border-white/10'}`}>
 <div className="flex items-center gap-3">
 <div className="w-4 h-4 rounded-full border border-black shadow-sm" style={{ backgroundColor: folder.color }}></div>
 <span className={`font-bold text-sm ${isInside ? 'text-indigo-400' : 'text-gray-300'}`}>{folder.name}</span>
 </div>
{isInside ? (
<button onClick={() => {
setServerFolders(prev => prev.map(f => {
 if (f.id === folder.id) return { ...f, serverIds: f.serverIds.filter(id => id !== folderTargetServerId) };
return f;
}).filter(f => f.serverIds.length > 0));
 setShowFolderModal(false);
}} className="bg-red-500/10 hover:bg-red-500 text-red-500 hover:text-white px-3 py-1.5 rounded-lg text-xs font-bold uppercase tracking-wider transition-colors active:scale-95">
 Çıkar
</button>
) : (
<button onClick={() => {
 setServerFolders(prev => prev.map(f => {
if (f.id === folder.id) return { ...f, serverIds: [...f.serverIds, folderTargetServerId] };
 return { ...f, serverIds: f.serverIds.filter(id => id !== folderTargetServerId) };
 }).filter(f => f.serverIds.length > 0));
 setShowFolderModal(false);
 }} className="bg-white/10 hover:bg-indigo-500 text-gray-300 hover:text-white px-3 py-1.5 rounded-lg text-xs font-bold uppercase tracking-wider transition-colors active:scale-95">
 Ekle
           </button>
                    )}
         </div>
 )
              })}
                        </div>
                        <div className="w-full h-px bg-white/10 my-4"></div>
                    </div>
                )}

                <label className="block text-xs font-bold text-gray-500 uppercase tracking-widest mb-3 relative z-10">Yeni Klasör Oluştur</label>
                <input type="text" placeholder="Klasör Adı (Örn: Oyunlar)" value={newFolderName} onChange={e => setNewFolderName(e.target.value)} className="w-full bg-black/40 border border-gray-800 rounded-xl px-4 py-3 text-white text-sm focus:border-indigo-500 outline-none mb-4 relative z-10 shadow-inner"/>
                
                <div className="flex items-center justify-between mb-6 relative z-10">
                    {['#3b82f6', '#ef4444', '#10b981', '#f59e0b', '#8b5cf6', '#ec4899'].map(color => (
                        <button key={color} onClick={() => setNewFolderColor(color)} className={`w-8 h-8 rounded-full border-2 transition-transform shadow-md ${newFolderColor === color ? 'scale-125 border-white ring-2 ring-black' : 'border-transparent hover:scale-110'}`} style={{ backgroundColor: color }}></button>
                    ))}
                </div>

                <button disabled={!newFolderName.trim()} onClick={() => {
                    if(!newFolderName.trim()) return;
                    const cleanFolders = serverFolders.map(f => ({ ...f, serverIds: f.serverIds.filter(id => id !== folderTargetServerId) })).filter(f => f.serverIds.length > 0);
                    setServerFolders([...cleanFolders, { id: `folder-${Date.now()}`, name: newFolderName, color: newFolderColor, serverIds: [folderTargetServerId] }]);
                    setShowFolderModal(false);
                    setNewFolderName('');
                }} className="w-full bg-indigo-600 hover:bg-indigo-500 disabled:bg-gray-800 disabled:text-gray-600 text-white font-black py-3.5 rounded-xl transition-all shadow-[0_0_15px_rgba(99,102,241,0.4)] active:scale-95 uppercase tracking-wider relative z-10">
                    Oluştur ve Taşı
                </button>
            </div>
        </div>
      )}
    
     {serverToLeave && (
        <div className="fixed inset-0 z-[300] bg-black/80 backdrop-blur-md flex items-center justify-center p-4 animate-fade-in">
          <div className="bg-white dark:bg-[#0a0a0c] w-full max-w-md rounded-[24px] shadow-[0_0_50px_rgba(239,68,68,0.15)] border border-gray-200 dark:border-red-500/30 overflow-hidden animate-scale-in relative">
            
            {/* Arka plandaki hafif kırmızı tehlike aurası */}
            <div className="absolute top-0 left-1/2 -translate-x-1/2 w-32 h-32 bg-red-500/20 blur-[60px] pointer-events-none"></div>

            <div className="p-8 flex flex-col items-center text-center relative z-10">
              
              <div className="w-16 h-16 bg-red-500/10 rounded-2xl flex items-center justify-center text-red-500 mb-6 border border-red-500/20 shadow-inner rotate-3">
                <AlertCircle size={40} />
              </div>
              
              <h2 className="text-2xl font-black text-gray-900 dark:text-white mb-2 uppercase tracking-tight">Sunucudan Ayrıl</h2>
              
              <p className="text-gray-500 dark:text-gray-400 leading-relaxed mb-8">
                <strong className="text-gray-900 dark:text-white font-black">{serverToLeave.name}</strong> sunucusundan ayrılmak istediğine emin misin?
              </p>
              
              <div className="grid grid-cols-2 gap-4 w-full">
                <button 
                  onClick={() => setServerToLeave(null)} 
                  className="bg-transparent border border-gray-300 dark:border-white/10 hover:bg-gray-100 dark:hover:bg-white/5 text-gray-700 dark:text-gray-300 font-bold py-3.5 rounded-xl transition-all"
                >
                  Vazgeç
                </button>
                <button 
                  onClick={confirmLeaveServer} 
                  className="bg-red-600 hover:bg-red-500 text-white font-black py-3.5 rounded-xl shadow-[0_0_15px_rgba(239,68,68,0.4)] transition-all active:scale-95 uppercase tracking-wider"
                >
                  Evet, Ayrıl
                </button>
              </div>

            </div>
          </div>
        </div>
      )}  
      
      {showBadgePreview && activeServer && (
  <div 
    className="fixed inset-0 z-[9999] bg-black/85 backdrop-blur-md flex items-center justify-center p-4 animate-fade-in cursor-pointer"
    onClick={() => setShowBadgePreview(false)}
  >
    <div className="relative flex flex-col items-center animate-scale-in" onClick={(e) => e.stopPropagation()}>
      <button 
        onClick={() => setShowBadgePreview(false)}
        className="absolute -top-12 right-0 text-white/70 hover:text-white transition-colors"
      >
        <X size={32} />
      </button>
      <img 
        src={(activeServer as any).badgeImage.startsWith('http') 
          ? (activeServer as any).badgeImage 
          : `/${(activeServer as any).badgeImage}`} 
        alt="Topluluk Rozeti Önizleme"
        className="w-64 h-64 object-contain drop-shadow-[0_0_40px_rgba(255,255,255,0.25)]"
      />
      <span className="mt-4 text-white/80 font-bold text-sm uppercase tracking-widest">Onaylı Topluluk Rozeti</span>
    </div>
  </div>
)}

        <nav id="tour-sidebar" className="w-[88px] m-4 h-[calc(100dvh-32px)] rounded-[32px] bg-white/80 dark:bg-[#0a0a0c]/60 backdrop-blur-2xl flex flex-col items-center py-6 gap-4 overflow-y-auto overflow-x-hidden hidden-scrollbar z-50 flex-shrink-0 transition-colors border border-gray-200/50 dark:border-white/10 shadow-2xl shadow-black/20">
        <div className="relative group w-full flex justify-center">
<div 
            onClick={() => handleServerClick('home')} 
            onMouseEnter={(e) => { const rect = e.currentTarget.getBoundingClientRect(); setHoverTooltip({show: true, text: 'Ana Sayfa', top: rect.top + rect.height / 2, left: rect.right + 16}); }}
            onMouseLeave={() => setHoverTooltip(prev => ({...prev, show: false}))}
            className={`w-14 h-14 transition-all duration-300 flex items-center justify-center cursor-pointer mb-2 overflow-hidden ${activeServerId === 'home' ? 'bg-[#111214] shadow-lg shadow-sesgelio/20 border-2 border-sesgelio rounded-[20px] transform -translate-y-0.5' : 'bg-[#111214] rounded-[28px] hover:rounded-[20px] hover:shadow-lg hover:shadow-black/50 hover:-translate-y-0.5 border-2 border-transparent hover:border-gray-800'}`}
          >
            <img 
              src="/ana_sayfa_logo.png" 
              alt="Sesgelio" 
              className={`w-full h-full object-cover scale-110 transition-all duration-300 ${activeServerId === 'home' ? 'opacity-100' : 'opacity-85 group-hover:opacity-100'}`} 
            />
          </div>
        </div>
        <div className="w-10 h-[2px] bg-gray-200 dark:bg-white/10 rounded-full mb-1 transition-colors"></div>      
{(() => {
    const serversInFolders = serverFolders.flatMap(f => f.serverIds);
    const standaloneServers = servers.filter(s => !serversInFolders.includes(s.id));

    return (
        <>
           {/* 1. TEKİL SUNUCULAR */}
            {standaloneServers.map(server => {
                const serverChannels = server.channels || [];
                const hasUnread = serverChannels.some(c => unreadChannels[c.id]);
                const mentionCount = serverChannels.reduce((acc, c) => acc + (channelMentions[c.id] || 0), 0);

                // 🚀 YENİ RADAR: Tekil sunucuda yayın/kamera var mı?
                let serverHasVideo = false;
                let serverHasScreen = false;
                const voiceChannels = serverChannels.filter(c => c.type === 'voice');
                voiceChannels.forEach(channel => {
                    const users = channelOccupancy[channel.id] || [];
                    users.forEach(u => {
                        if (globalVideoUsers[u.id] || (u as any).isVideoOn) serverHasVideo = true;
                        if (globalScreenUsers[u.id] || (u as any).isScreenSharing) serverHasScreen = true;
                    });
                });

                return (
                    <div 
                      key={server.id} 
                      draggable
                      onDragStart={(e) => handleDragStart(e, server.id)}
                      onDragOver={handleDragOver}
                      onDrop={(e) => handleDrop(e, server.id)}
                      onDragEnd={handleDragEnd}
                      className={`relative group w-full flex justify-center mb-2 transition-all duration-200 cursor-grab active:cursor-grabbing ${draggedServerId === server.id ? 'opacity-40 scale-95' : 'opacity-100'}`}
                    >
                  {/* ⚪ BEYAZ OKUNMAMIŞ NOKTASI */}
{hasUnread && activeServerId !== server.id && (
  <div 
    onMouseEnter={(e) => { 
       const rect = e.currentTarget.getBoundingClientRect();
                             setHoverTooltip({show: true, text: 'Kaçırdığın mesajlar', top: rect.top + rect.height / 2, left: rect.right + 12, position: 'right'}); 
                          }}
                          onMouseLeave={() => setHoverTooltip(prev => ({...prev, show: false}))}
                          className="absolute left-0 top-1/2 -translate-y-1/2 w-1.5 h-4 bg-white rounded-r-full animate-fade-in z-[100] shadow-[0_0_10px_rgba(255,255,255,0.8)] cursor-help pointer-events-auto"
                        ></div>
                      )}

                      <div 
                        onMouseEnter={(e) => { 
                            const rect = e.currentTarget.getBoundingClientRect();
                            setHoverTooltip({show: true, text: renderServerTooltip(server), top: rect.top + rect.height / 2, left: rect.right + 16});
                        }}
                        onMouseLeave={() => setHoverTooltip(prev => ({...prev, show: false}))}
                        className="relative w-14 h-14"
                      >
                        {/* 🚀 MEDYA İKONLARI (TEKİL SUNUCU KAPAK ÜSTÜ - ZİRVE KALİTE) */}
                        {(serverHasVideo || serverHasScreen) && (
                            <div className="absolute -top-1.5 -left-1.5 flex items-center gap-1 bg-black/85 backdrop-blur-xl rounded-full px-1.5 py-1 z-[150] shadow-[0_0_10px_rgba(0,0,0,0.8)] border border-white/10 pointer-events-none ring-2 ring-[#030303] dark:ring-[#111214]">
                                {serverHasVideo && <Video size={14} className="text-blue-400 drop-shadow-[0_0_5px_rgba(96,165,250,0.8)] animate-pulse" />}
                                {serverHasScreen && <MonitorUp size={14} className="text-emerald-400 drop-shadow-[0_0_5px_rgba(52,211,153,0.8)] animate-pulse" />}
                            </div>
                        )}

                        <div onClick={() => handleServerClick(server.id)} className={`w-14 h-14 rounded-[28px] hover:rounded-[20px] transition-all duration-300 cursor-pointer overflow-hidden border-2 z-10 relative ${activeServerId === server.id ? 'rounded-[20px] border-[#ff2b5e]/50 shadow-[0_0_25px_rgba(255,43,94,0.4)] ring-2 ring-[#ff2b5e]/30' : 'border-transparent bg-white/5 dark:bg-white/5 hover:shadow-xl dark:hover:shadow-[#ff2b5e]/30'}`}>
                          {server.iconUrl ? (
                             <img src={server.iconUrl.startsWith('http') ? server.iconUrl : `${BACKEND_URL}${server.iconUrl}`} alt={server.name} className="w-full h-full object-cover bg-gray-200 dark:bg-[#1e1f22]" />
                          ) : (
                             <div className="w-full h-full flex items-center justify-center bg-gray-200 dark:bg-[#1e1f22] text-gray-900 dark:text-white font-black text-xl uppercase">
                                {server.name.charAt(0)}
                             </div>
                          )}
                        </div>
                        
                        <button onClick={(e) => { e.stopPropagation(); handleLeaveServer(server.id); }} className="absolute -top-1 -right-1 w-6 h-6 bg-red-500 text-white rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity cursor-pointer z-[160] shadow-md border border-white/20 transform hover:scale-110"><X size={14} strokeWidth={3} /></button>
                        
                        {/* 🔴 KIRMIZI MENTION (ETİKET) ROZETİ */}
                        {mentionCount > 0 && (
                          <div 
                            onMouseEnter={(e) => {
                               e.stopPropagation();
                               const rect = e.currentTarget.getBoundingClientRect();
                               setHoverTooltip({show: true, text: 'Etiketlendin', top: rect.top + rect.height / 2, left: rect.right + 12, position: 'right'});
                            }}
                            onMouseLeave={(e) => {
                               e.stopPropagation();
                               setHoverTooltip(prev => ({...prev, show: false}));
                            }}
                            className="absolute -bottom-1 -right-1 bg-red-500 text-white text-[11px] font-black min-w-[22px] h-[22px] px-1 flex items-center justify-center rounded-full z-[160] ring-4 ring-white dark:ring-[#0a0a0c] shadow-[0_0_15px_rgba(239,68,68,0.8)] animate-bounce-short cursor-help pointer-events-auto"
                          >
                            {mentionCount > 99 ? '99+' : mentionCount}
                          </div>
                        )}

                        {/* 🚀 AKTİF SES BAĞLANTISI MÜHRÜ */}
                        {voiceConnected && connectedServerId === server.id && mentionCount === 0 && (
                          <div className="absolute -bottom-1 -right-1 w-5 h-5 bg-[#050505] rounded-full flex items-center justify-center z-[140]">
                            <div className="w-4 h-4 bg-green-500 rounded-full flex items-center justify-center shadow-[0_0_10px_rgba(34,197,94,0.6)]">
                               <Volume2 size={10} className="text-[#050505] animate-pulse" fill="currentColor" />
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                );
            })}

         {/* 2. KLASÖRLENMİŞ SUNUCULAR */}
            {serverFolders.map(folder => {
                const folderServers = folder.serverIds.map(id => servers.find(s => s.id === id)).filter(Boolean) as Server[];
                if (folderServers.length === 0) return null;

                const isExpanded = expandedFolders.includes(folder.id);
                const hasUnread = folderServers.some(s => (s.channels || []).some(c => unreadChannels[c.id]));

                // 🚀 ÇÖZÜM MÜHRÜ 1: Klasörün içindeki tüm sunuculardaki etiketlenme (mention) sayısını topla!
                const folderMentionCount = folderServers.reduce((total, s) => {
                    return total + (s.channels || []).reduce((acc, c) => acc + (channelMentions[c.id] || 0), 0);
                }, 0);

                // 🚀 YENİ RADAR: Klasörün içindeki herhangi bir sunucuda yayın/kamera var mı?
                let folderHasVideo = false;
                let folderHasScreen = false;
                folderServers.forEach(fs => {
                    const vChannels = fs.channels?.filter(c => c.type === 'voice') || [];
                    vChannels.forEach(channel => {
                        const users = channelOccupancy[channel.id] || [];
                        users.forEach(u => {
                            if (globalVideoUsers[u.id] || (u as any).isVideoOn) folderHasVideo = true;
                            if (globalScreenUsers[u.id] || (u as any).isScreenSharing) folderHasScreen = true;
                        });
                    });
                });

                return (
                    <div 
                        key={folder.id} 
                        draggable
                        onDragStart={(e) => handleFolderDragStart(e, folder.id)}
                        onDragOver={(e) => { e.preventDefault(); e.stopPropagation(); e.dataTransfer.dropEffect = 'move'; }}
                        onDrop={(e) => handleFolderDrop(e, folder.id)}
                        onDragEnd={handleFolderDragEnd}
                        className={`relative group w-full flex flex-col items-center mb-2 animate-fade-in transition-all duration-200 cursor-grab active:cursor-grabbing ${draggedFolderId === folder.id ? 'opacity-40 scale-95' : 'opacity-100'}`}
                    >
                        {/* ⚪ BEYAZ OKUNMAMIŞ NOKTASI (Klasör Kapalıysa) */}
                        {hasUnread && !isExpanded && (
                            <div 
                                onMouseEnter={(e) => { 
                                    const rect = e.currentTarget.getBoundingClientRect(); 
                                    setHoverTooltip({show: true, text: 'Kaçırdığın mesajlar', top: rect.top + rect.height / 2, left: rect.right + 12, position: 'right'}); 
                                }}
                                onMouseLeave={() => setHoverTooltip(prev => ({...prev, show: false}))}
                                className="absolute left-0 top-7 -translate-y-1/2 w-1.5 h-4 bg-white rounded-r-full animate-fade-in z-[100] shadow-[0_0_10px_rgba(255,255,255,0.8)] cursor-help pointer-events-auto"
                            ></div>
                        )}

                        {/* KLASÖR KAPAK İKONU VE MEDYA ROZETİ (RELATIVE KAPSAYICI) */}
                        <div className="relative w-14">
                            {/* 🚀 MEDYA İKONLARI (KLASÖR KAPALIYKEN - SOL ÜST KÖŞE ZİRVE KALİTE) */}
                            {(folderHasVideo || folderHasScreen) && !isExpanded && (
                                <div className="absolute -top-1.5 -left-1.5 flex items-center gap-1 bg-black/85 backdrop-blur-xl rounded-full px-1.5 py-1 z-[150] shadow-[0_0_10px_rgba(0,0,0,0.8)] border border-white/10 pointer-events-none ring-2 ring-[#030303] dark:ring-[#111214]">
                                    {folderHasVideo && <Video size={14} className="text-blue-400 drop-shadow-[0_0_5px_rgba(96,165,250,0.8)] animate-pulse" />}
                                    {folderHasScreen && <MonitorUp size={14} className="text-emerald-400 drop-shadow-[0_0_5px_rgba(52,211,153,0.8)] animate-pulse" />}
                                </div>
                            )}

                            <div
                                onClick={() => toggleFolder(folder.id)}
                                onMouseEnter={(e) => { 
                                    if(!isExpanded) {
                                        const rect = e.currentTarget.getBoundingClientRect(); 
                                        setHoverTooltip({show: true, text: folder.name, top: rect.top + rect.height / 2, left: rect.right + 16}); 
                                    }
                                }}
                                onMouseLeave={() => setHoverTooltip(prev => ({...prev, show: false}))}
                                className={`relative w-full transition-all duration-300 cursor-pointer flex items-center justify-center overflow-hidden z-20 ${isExpanded ? 'rounded-t-[20px] h-10 shadow-md' : 'rounded-[28px] hover:rounded-[20px] h-14 shadow-sm'}`}
                                style={{ backgroundColor: isExpanded ? `${folder.color}90` : folder.color }}
                            >
                                {hasUnread && !isExpanded && (
                                    <div className="absolute top-0 right-0 w-3 h-3 bg-white rounded-full shadow-[0_0_10px_rgba(255,255,255,0.8)] border-2 border-[#111214] z-30 animate-pulse"></div>
                                )}

                                {!isExpanded ? (
                                    <div className="grid grid-cols-2 gap-[2px] p-2.5 w-full h-full opacity-90">
                                        {folderServers.slice(0, 4).map((fs, idx) => (
                                            <div key={idx} className="w-full h-full rounded-full bg-black/60 overflow-hidden flex items-center justify-center text-[8px] font-bold text-white">
                                                {fs.iconUrl ? <img src={fs.iconUrl.startsWith('http') ? fs.iconUrl : `${BACKEND_URL}${fs.iconUrl}`} className="w-full h-full object-cover"/> : fs.name.charAt(0)}
                                            </div>
                                        ))}
                                    </div>
                                ) : (
                                    <span className="text-[10px] font-black uppercase text-white tracking-widest truncate px-2 drop-shadow-md">{folder.name}</span>
                                )}
                            </div>
                            {/* 🚀 ÇÖZÜM MÜHRÜ 2: KLASÖR KAPALIYKEN DIŞARI ÇIKAN KIRMIZI MENTION ROZETİ */}
                            {folderMentionCount > 0 && !isExpanded && (
                              <div 
                                onMouseEnter={(e) => {
                                   e.stopPropagation();
                                   const rect = e.currentTarget.getBoundingClientRect();
                                   setHoverTooltip({show: true, text: 'Etiketlendin', top: rect.top + rect.height / 2, left: rect.right + 12, position: 'right'});
                                }}
                                onMouseLeave={(e) => {
                                   e.stopPropagation();
                                   setHoverTooltip(prev => ({...prev, show: false}));
                                }}
                                className="absolute -bottom-1 -right-1 bg-red-500 text-white text-[11px] font-black min-w-[22px] h-[22px] px-1 flex items-center justify-center rounded-full z-[160] ring-4 ring-white dark:ring-[#0a0a0c] shadow-[0_0_15px_rgba(239,68,68,0.8)] animate-bounce-short cursor-help pointer-events-auto"
                              >
                                {folderMentionCount > 99 ? '99+' : folderMentionCount}
                              </div>
                            )}
                        </div>
                        

                        {/* AÇILIR LİSTE (KLASÖR İÇİ SUNUCULAR) */}
                        {isExpanded && (
                            <div className="w-14 bg-white/5 dark:bg-[#1e1f22]/60 backdrop-blur-md rounded-b-[20px] pt-3 pb-2 flex flex-col items-center gap-2 shadow-inner border border-white/5 z-10" style={{ backgroundColor: `${folder.color}15` }}>
                                {folderServers.map(server => {
                                    const serverChannels = server.channels || [];
                                    const hasUnreadInner = serverChannels.some(c => unreadChannels[c.id]);
                                    const mentionCountInner = serverChannels.reduce((acc, c) => acc + (channelMentions[c.id] || 0), 0);
                                    
                                    // 🚀 YENİ RADAR: Klasör içindeki bu spesifik sunucuda yayın/kamera var mı?
                                    let innerHasVideo = false;
                                    let innerHasScreen = false;
                                    const vChannelsInner = serverChannels.filter(c => c.type === 'voice');
                                    vChannelsInner.forEach(channel => {
                                        const users = channelOccupancy[channel.id] || [];
                                        users.forEach(u => {
                                            if (globalVideoUsers[u.id] || (u as any).isVideoOn) innerHasVideo = true;
                                            if (globalScreenUsers[u.id] || (u as any).isScreenSharing) innerHasScreen = true;
                                        });
                                    });

                                    return (
                                        <div key={server.id} className="relative group w-full flex justify-center mb-1 transition-all duration-200 cursor-pointer">
                                            
                                        {/* ⚪ İÇ SUNUCU BEYAZ BİLDİRİM NOKTASI */}
{hasUnreadInner && activeServerId !== server.id && (
  <div 
      onMouseEnter={(e) => {
                                                        const rect = e.currentTarget.getBoundingClientRect(); 
                                                        setHoverTooltip({show: true, text: 'Kaçırdığın mesajlar', top: rect.top + rect.height / 2, left: rect.right + 12, position: 'right'}); 
                                                    }}
                                                    onMouseLeave={() => setHoverTooltip(prev => ({...prev, show: false}))}
                                                    className="absolute left-0 top-1/2 -translate-y-1/2 w-1.5 h-4 bg-white rounded-r-full animate-fade-in z-[100] shadow-[0_0_10px_rgba(255,255,255,0.8)] cursor-help pointer-events-auto"
                                                ></div>
                                            )}

                                            <div 
                                                onMouseEnter={(e) => { 
                                                    const rect = e.currentTarget.getBoundingClientRect(); 
                                                    setHoverTooltip({show: true, text: renderServerTooltip(server), top: rect.top + rect.height / 2, left: rect.right + 16}); 
                                                }}
                                                onMouseLeave={() => setHoverTooltip(prev => ({...prev, show: false}))}
                                                className="relative w-12 h-12"
                                            >
                                                {/* 🚀 MEDYA İKONLARI (İÇ SUNUCU - SOL ÜST KÖŞE ZİRVE KALİTE) */}
                                                {(innerHasVideo || innerHasScreen) && (
                                                    <div className="absolute -top-1.5 -left-1.5 flex items-center gap-0.5 bg-black/85 backdrop-blur-xl rounded-full px-1.5 py-0.5 z-[150] shadow-[0_0_10px_rgba(0,0,0,0.8)] border border-white/10 pointer-events-none ring-2 ring-[#030303] dark:ring-[#111214]">
                                                        {innerHasVideo && <Video size={10} className="text-blue-400 drop-shadow-[0_0_5px_rgba(96,165,250,0.8)] animate-pulse" />}
                                                        {innerHasScreen && <MonitorUp size={10} className="text-emerald-400 drop-shadow-[0_0_5px_rgba(52,211,153,0.8)] animate-pulse" />}
                                                    </div>
                                                )}

                                                <div onClick={() => handleServerClick(server.id)} className={`w-12 h-12 rounded-[24px] hover:rounded-[16px] transition-all duration-300 cursor-pointer overflow-hidden border-2 z-10 relative ${activeServerId === server.id ? 'rounded-[16px] border-[#ff2b5e]/50 shadow-[0_0_25px_rgba(255,43,94,0.4)] ring-2 ring-[#ff2b5e]/30' : 'border-transparent bg-white/5 dark:bg-white/5 hover:shadow-xl dark:hover:shadow-[#ff2b5e]/30'}`}>
                                                    {server.iconUrl ? (
                                                        <img src={server.iconUrl.startsWith('http') ? server.iconUrl : `${BACKEND_URL}${server.iconUrl}`} alt={server.name} className="w-full h-full object-cover bg-gray-200 dark:bg-[#1e1f22]" />
                                                    ) : (
                                                        <div className="w-full h-full flex items-center justify-center bg-gray-200 dark:bg-[#1e1f22] text-gray-900 dark:text-white font-black text-lg uppercase">
                                                            {server.name.charAt(0)}
                                                        </div>
                                                    )}
                                                </div>

                                                {mentionCountInner > 0 && (
                                                    <div 
                                                        onMouseEnter={(e) => {
                                                            e.stopPropagation();
                                                            const rect = e.currentTarget.getBoundingClientRect();
                                                            setHoverTooltip({show: true, text: 'Etiketlendin', top: rect.top + rect.height / 2, left: rect.right + 12, position: 'right'});
                                                        }}
                                                        onMouseLeave={(e) => {
                                                            e.stopPropagation();
                                                            setHoverTooltip(prev => ({...prev, show: false}));
                                                        }}
                                                        className="absolute -bottom-1 -right-1 bg-red-500 text-white text-[10px] font-black min-w-[20px] h-[20px] px-1 flex items-center justify-center rounded-full z-[160] ring-2 ring-white dark:ring-[#0a0a0c] shadow-[0_0_15px_rgba(239,68,68,0.8)] animate-bounce-short cursor-help pointer-events-auto scale-[0.8] translate-x-1 translate-y-1"
                                                    >
                                                        {mentionCountInner > 99 ? '99+' : mentionCountInner}
                                                    </div>
                                                )}

                                                {voiceConnected && connectedServerId === server.id && mentionCountInner === 0 && (
                                                    <div className="absolute -bottom-1 -right-1 w-4 h-4 bg-[#050505] rounded-full flex items-center justify-center z-[140] scale-[0.8] translate-x-1 translate-y-1">
                                                        <div className="w-3 h-3 bg-green-500 rounded-full flex items-center justify-center shadow-[0_0_10px_rgba(34,197,94,0.6)]">
                                                            <Volume2 size={8} className="text-[#050505] animate-pulse" fill="currentColor" />
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        )}
                    </div>
                );
            })}
        </>
    );
})()} <div 
  onClick={() => { 
    setShowCreateServerModal(true);
    setIsMobileDrawerOpen(false);
    setHoverTooltip({ show: false, text: '', top: 0, left: 0 });
  }} 
  onMouseEnter={(e) => { const rect = e.currentTarget.getBoundingClientRect(); setHoverTooltip({show: true, text: 'Sunucu Ekle', top: rect.top + rect.height / 2, left: rect.right + 16}); }}
  onMouseLeave={() => setHoverTooltip(prev => ({...prev, show: false}))}
  className="w-14 h-14 bg-gray-100 dark:bg-white/5 hover:bg-gradient-to-tr hover:from-[#ff2b5e] hover:to-[#ff4b72] text-sesgelio hover:text-white rounded-[28px] hover:rounded-[20px] transition-all duration-300 flex items-center justify-center cursor-pointer mt-2 group border border-dashed border-sesgelio/40 hover:border-transparent hover:shadow-[0_6px_20px_rgba(255,43,94,0.5),inset_0_2px_4px_rgba(255,255,255,0.3)] hover:-translate-y-0.5" 
>
  <Plus size={26} strokeWidth={2.5} className="group-hover:rotate-90 transition-transform duration-300" />
</div>
    <div id="tour-ai" className="relative group w-full flex justify-center mt-2">
    <div 
      onClick={() => handleServerClick('gemini-ai')} 
      onMouseEnter={(e) => { const rect = e.currentTarget.getBoundingClientRect(); setHoverTooltip({show: true, text: 'Sesgelio AI', top: rect.top + rect.height / 2, left: rect.right + 16}); }}
      onMouseLeave={() => setHoverTooltip(prev => ({...prev, show: false}))}
      className={`w-14 h-14 rounded-[28px] hover:rounded-[20px] transition-all duration-300 flex items-center justify-center cursor-pointer border border-dashed border-sesgelio/30 dark:border-sesgelio/30 hover:border-transparent shadow-sm ${activeServerId === 'gemini-ai' ? 'bg-gradient-to-tr from-[#ff2b5e] to-[#ff4b72] text-white shadow-[0_6px_20px_rgba(255,43,94,0.6),inset_0_2px_4px_rgba(255,255,255,0.4)] rounded-[20px] ring-2 ring-sesgelio ring-offset-2 ring-offset-gray-50 dark:ring-offset-[#0a0a0c] transform -translate-y-0.5' : 'bg-white dark:bg-[#1e1f22] hover:bg-[#ff2b5e] text-sesgelio hover:text-white hover:shadow-[0_6px_15px_rgba(255,43,94,0.4),inset_0_2px_4px_rgba(255,255,255,0.2)] hover:-translate-y-0.5'}`} 
    >
        <Brain size={26} strokeWidth={2.5} />
    </div>
</div>
       <div className="relative group w-full flex justify-center mt-2">
  <div 
    onClick={() => setActiveServerId('discovery')} 
    onMouseEnter={(e) => { const rect = e.currentTarget.getBoundingClientRect(); setHoverTooltip({show: true, text: 'Keşfet', top: rect.top + rect.height / 2, left: rect.right + 16}); }}
    onMouseLeave={() => setHoverTooltip(prev => ({...prev, show: false}))}
    className={`w-14 h-14 rounded-[28px] hover:rounded-[20px] transition-all duration-300 flex items-center justify-center cursor-pointer border border-dashed border-sesgelio/30 dark:border-sesgelio/30 hover:border-transparent shadow-sm ${activeServerId === 'discovery' ? 'bg-gradient-to-tr from-[#ff2b5e] to-[#ff4b72] text-white shadow-[0_6px_20px_rgba(255,43,94,0.6),inset_0_2px_4px_rgba(255,255,255,0.4)] ring-2 ring-sesgelio ring-offset-2 ring-offset-gray-50 dark:ring-offset-[#0a0a0c] transform -translate-y-0.5' : 'bg-white dark:bg-[#1e1f22] hover:bg-[#ff2b5e] text-sesgelio hover:text-white hover:shadow-[0_6px_15px_rgba(255,43,94,0.4),inset_0_2px_4px_rgba(255,255,255,0.2)] hover:-translate-y-0.5'}`} 
  >
    <Compass size={26} strokeWidth={2.5} />
  </div>
</div>
</nav>

{/* 🚀 KUSURSUZ ANLIK TOOLTIP EKRANI (AKILLI POZİSYON) */}
      {hoverTooltip.show && (
        <div 
          style={{ top: hoverTooltip.top, left: hoverTooltip.left }} 
          className={`fixed px-3.5 py-2 bg-[#111214] border border-white/10 text-white text-[13px] font-black rounded-xl shadow-[0_10px_25px_rgba(0,0,0,0.5)] z-[9999] pointer-events-none flex items-center whitespace-nowrap transition-opacity ${
            hoverTooltip.position === 'top' 
            ? 'transform -translate-x-1/2 -translate-y-full mt-[-8px]' 
            : 'transform -translate-y-1/2'
          }`}
        >
          {hoverTooltip.text}
          {/* Ok / Üçgen - Pozisyona göre değişir */}
          {hoverTooltip.position === 'top' ? (
             <div className="absolute top-full left-1/2 -translate-x-1/2 w-0 h-0 border-x-[6px] border-x-transparent border-t-[6px] border-t-[#111214]"></div>
          ) : (
             <div className="absolute top-1/2 -left-1.5 -translate-y-1/2 w-0 h-0 border-y-[6px] border-y-transparent border-r-[6px] border-r-[#111214]"></div>
          )}
        </div>
      )}

{activeServerId !== 'discovery' && activeServerId !== 'gemini-ai' && (
  <div className="w-64 my-4 mr-4 h-[calc(100dvh-32px)] rounded-[32px] bg-white/60 dark:bg-[#111214]/80 backdrop-blur-2xl flex flex-col border border-gray-200/50 dark:border-white/10 shadow-2xl shadow-black/20 overflow-hidden relative transition-colors z-40">
<div id="tour-server-header" className="h-16 flex items-center justify-between px-4 shadow-sm border-b border-gray-200 dark:border-white/5 bg-white/50 dark:bg-black/10 backdrop-blur-sm sticky top-0 z-10 cursor-pointer" onClick={(e) => { e.stopPropagation(); if (activeServerId !== 'home') setIsServerMenuOpen(!isServerMenuOpen); }}>
  {activeServerId === 'home' ? (
    <h1 className="font-bold text-gray-900 dark:text-white text-base">Ana Sayfa</h1>
  ) : (
    <div className="flex items-center gap-2 flex-1 min-w-0">
      <h1 className="font-black text-gray-900 dark:text-white truncate text-base tracking-tight">
        {activeServer?.name.toUpperCase() || 'SUNUCU'}
      </h1>
      
      {/* 🚀 DİNAMİK ROZET SİSTEMİ */}
      {/* DB'den rozet ismi gelirse otomatik olarak public klasöründen çeker */}
{(activeServer as any)?.badgeImage && (
  <img 
    onClick={(e) => { e.stopPropagation(); setShowBadgePreview(true); }}
    src={(activeServer as any).badgeImage.startsWith('http') 
      ? (activeServer as any).badgeImage 
      : `/${(activeServer as any).badgeImage}`} 
    alt="Topluluk Rozeti" 
    className="w-12 h-12 object-contain flex-shrink-0 drop-shadow-[0_0_8px_rgba(255,255,255,0.15)] animate-fade-in cursor-pointer hover:scale-125 transition-transform"
    title="Onaylı Topluluk (Büyütmek için tıkla)"
  />
)}
    </div>
  )}
</div>

    {/* 🚀 MENÜ VE LİDERLİK BUTONLARI (Kapanmaması İçin Alta Çekildi) */}
    {activeServerId !== 'home' && (
      <div className="flex items-center justify-between px-4 py-2.5 bg-gray-50/80 dark:bg-[#1a1b1e]/80 border-b border-gray-200 dark:border-white/5 backdrop-blur-md z-[9] shrink-0">
        <button 
          onClick={(e) => { e.stopPropagation(); setShowLeaderboardModal(true); }} 
          className="flex items-center gap-1.5 text-xs font-bold text-gray-500 hover:text-yellow-500 transition-colors"
        >
          <Trophy size={14} /> Liderlik
        </button>
        <button 
          onClick={(e) => { e.stopPropagation(); setIsServerMenuOpen(!isServerMenuOpen); }} 
          className="flex items-center gap-1.5 text-xs font-bold text-gray-500 hover:text-sesgelio transition-colors"
        >
          <Settings size={14} /> Ayarlar <ChevronDown size={14} className={`transition-transform ${isServerMenuOpen ? 'rotate-180' : ''}`} />
        </button>
      </div>
    )}

{/* ⚙️ Yönetim Penceresi (Top Değeri Ayarlandı) */}
    {isServerMenuOpen && activeServerId !== 'home' && (
      <div className="absolute top-[104px] left-2 w-60 bg-white dark:bg-[#111214] rounded-lg shadow-2xl border border-gray-200 dark:border-white/10 z-[60] p-1.5 animate-fade-in-up">
        
        {/* 🚀 HERKES İÇİN ORTAK (Kişisel Düzenleme) */}
        <div className="px-2 py-1.5 mb-1"><div className="text-[10px] font-bold text-gray-400 uppercase">Kişisel</div></div>
        <button onClick={() => { setFolderTargetServerId(activeServerId); setShowFolderModal(true); setIsServerMenuOpen(false); }} className="w-full text-left px-2 py-2 rounded text-sm text-indigo-400 hover:bg-indigo-500 hover:text-white flex items-center justify-between transition-colors group">Klasöre Taşı <FolderPlus size={16} /></button>
        <div className="h-px bg-gray-200 dark:bg-white/10 my-1"></div>

        {/* 🛡️ SADECE YETKİLİLER İÇİN (Sunucu Yönetimi) */}
        <div className="px-2 py-1.5 mb-1 mt-1"><div className="text-[10px] font-bold text-gray-400 uppercase">Yönetim</div></div>
        {canManageServer ? (
          <>
            <button onClick={() => setShowServerSettingsModal(true)} className="w-full text-left px-2 py-2 rounded text-sm text-gray-700 dark:text-gray-300 hover:bg-sesgelio hover:text-white flex items-center justify-between transition-colors group">Sunucu Ayarları <Settings size={16} /></button>
            <button onClick={() => { setCreateChannelDefaultType(null); setShowCreateChannelModal(true); }} className="w-full text-left px-2 py-2 rounded text-sm text-gray-700 dark:text-gray-300 hover:bg-sesgelio hover:text-white flex items-center justify-between transition-colors">Kanal Oluştur <Plus size={16} /></button>
          </>
        ) : (
          <div className="text-xs text-gray-500 px-2 py-2 mb-1 italic">Yetkiniz yok.</div>
        )}
        
        <div className="h-px bg-gray-200 dark:bg-white/10 my-1"></div>
        <button onClick={() => { handleLeaveServer(activeServerId); setIsServerMenuOpen(false); }} className="w-full text-left px-2 py-2 rounded text-sm text-red-500 hover:bg-red-500 hover:text-white flex items-center justify-between transition-colors">Sunucudan Ayrıl <LogOut size={16} /></button>
      </div>
    )}

    <div className="flex-1 overflow-y-auto custom-scrollbar p-3 space-y-1">
      {activeServerId === 'home' ? (
        <>
         <div id="tour-friends" onClick={() => { setActiveDmId(null); setActiveChannelId(null); setIsDmMinimized(true); }} className={`flex items-center px-3 py-2.5 rounded-lg cursor-pointer transition-all border shadow-sm mb-3 ${(!activeDmId && !isViewingGroupCall) ? 'bg-gradient-to-r from-gray-200 to-gray-100 dark:from-white/10 dark:to-transparent text-gray-900 dark:text-white border-gray-200 dark:border-white/5' : 'bg-transparent text-gray-500 dark:text-gray-400 border-transparent hover:bg-gray-200 dark:hover:bg-white/10'}`}>
            <div className="w-7 h-7 rounded-lg bg-gray-300 dark:bg-white/10 flex items-center justify-center mr-3"><UserIcon size={16} className={!activeDmId ? 'text-gray-900 dark:text-white' : 'text-gray-500 dark:text-gray-400'} /></div>
            <span className="font-bold text-sm">Arkadaşlar</span>
          </div>

        {/* 🚀 DEVRİMSEL: GRUP ARAMA VE SOHBET BUTONLARI */}
          <div id="tour-group-actions" className="flex flex-col gap-1.5 mb-6 px-1">             
          <button 
                onClick={() => {
                  // Sadece arama penceresini (Modalı) açar
                  setSelectedCallFriends([]);
                  setCallSearchQuery("");
                  setShowGroupCallModal(true);
                }}
                className="flex items-center gap-3 w-full px-3 py-2 rounded-lg bg-emerald-500/10 hover:bg-emerald-500/20 border border-emerald-500/20 hover:border-emerald-500/40 transition-all group active:scale-95"
             >
                <div className="bg-emerald-500/20 p-1.5 rounded-md text-emerald-500 group-hover:text-emerald-400 transition-colors">
                   <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="m22 8-6 4 6 4V8Z"/><rect width="14" height="12" x="2" y="6" rx="2" ry="2"/></svg>
                </div>
                <div className="flex flex-col items-start">
                   <span className="text-emerald-600 dark:text-emerald-400 font-black text-xs uppercase tracking-wider leading-none mb-0.5">Genel Arama</span>
                   <span className="text-[9px] text-emerald-600/70 dark:text-emerald-400/70 font-medium leading-none">Sesli/Görüntülü Grup</span>
                </div>
             </button>

            <button 
                id="tour-arkadas-grubu"
                onClick={() => {
                   // Arama alanını sıfırla ve seçili arkadaşları temizle
                   setSelectedCallFriends([]);
                   setCallSearchQuery("");
                   // Modal'ı aç
                   setShowCreateGroupModal(true); 
                }}
                className="flex items-center gap-3 w-full px-3 py-2 rounded-lg bg-blue-500/10 hover:bg-blue-500/20 border border-blue-500/20 hover:border-blue-500/40 transition-all group active:scale-95"
             >
                <div className="bg-blue-500/20 p-1.5 rounded-md text-blue-500 group-hover:text-blue-400 transition-colors">
                   <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M22 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>
                </div>
                <div className="flex flex-col items-start">
                   <span className="text-blue-600 dark:text-blue-400 font-black text-xs uppercase tracking-wider leading-none mb-0.5">Arkadaş Grubu</span>
                   <span className="text-[9px] text-blue-600/70 dark:text-blue-400/70 font-medium leading-none">Yeni Yazılı Sohbet</span>
                </div>
             </button>
          </div>        
          
       {/* 🚀 GRUP SOHBETLERİ LİSTESİ */}
          {groups.length > 0 && (
            <div className="mb-4">
              <div className="flex items-center justify-between text-gray-500 dark:text-gray-400 px-2 mb-2 hover:text-gray-700 dark:hover:text-gray-200 cursor-pointer group">
                <span className="text-[10px] font-black uppercase tracking-widest opacity-80">GRUP SOHBETLERİ</span>
              </div>
              {groups.map(group => (
                <div 
                  key={group.id} 
                  onClick={async () => { 
                    setActiveServerId('home');
                    setActiveDmId(null); 
                    setActiveGroupId(group.id); 

                    // 1. Ekranda sayacı anında sıfırla (Kırmızı balonu yok et)
                    setGroups(prev => prev.map(g => g.id === group.id ? { ...g, unreadCount: 0 } : g));

                    // 2. MySQL'e "Ben okudum, sıfırla" de
                    try {
                        await fetch(`${BACKEND_URL}/api/groups/${group.id}/reset-unread`, {
                            method: 'POST',
                           
                        });
                    } catch(err) {}
                  }} 
                  className={`flex items-center px-2 py-2 rounded-xl mb-1 cursor-pointer group transition-all ${activeGroupId === group.id ? 'bg-blue-500/10 border border-blue-500/20' : 'hover:bg-gray-200 dark:hover:bg-white/5 border border-transparent'}`}
                >
                  <div className="relative mr-3">
                    <img src={group.iconUrl || 'https://ui-avatars.com/api/?name=G&background=random'} className="w-10 h-10 rounded-xl object-cover" />
                    
                    {/* 🚀 İŞTE BEKLENEN KIRMIZI BALON (SAYAÇ) */}
                    {(group.unreadCount || 0) > 0 && (
                      <div className="absolute -top-1 -right-1 bg-red-500 text-white text-[10px] font-black w-4 h-4 rounded-full flex items-center justify-center animate-pulse shadow-lg ring-2 ring-[#1e1f22]">
                        {group.unreadCount}
                      </div>
                    )}
                  </div>
                  <div className="flex-1 overflow-hidden">
                    <div className={`font-bold text-sm truncate ${activeGroupId === group.id ? 'text-blue-500' : 'text-gray-900 dark:text-white'}`}>{group.name}</div>
                    <div className={`text-[10px] truncate font-medium uppercase tracking-wider ${group.unreadCount > 0 ? 'text-red-500 font-black' : 'opacity-70 text-gray-500'}`}>
                      {group.unreadCount > 0 ? 'Yeni Mesaj' : `${group.members?.length || 0} Üye`}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}

          <div className="flex items-center justify-between text-gray-500 dark:text-gray-400 px-2 mb-2 hover:text-gray-700 dark:hover:text-gray-200 cursor-pointer group"><span className="text-[10px] font-black uppercase tracking-widest opacity-80">ÖZEL MESAJLAR</span><Plus size={14} className="opacity-0 group-hover:opacity-100 transition-opacity" /></div>         
{visibleDms.map(dm => (
            <div key={dm.id} onClick={() => handleDmClick(dm.id)} className={`flex items-center px-2 py-2 rounded-lg mb-1 cursor-pointer group transition-all ${activeDmId === dm.id ? 'bg-gray-200 dark:bg-white/10' : 'hover:bg-gray-200 dark:hover:bg-white/5'}`}>
              <div className="relative mr-3">
<img 
  src={dm.avatarUrl} 
  className="w-9 h-9 rounded-full object-cover shadow-sm"
  style={{ filter: (dm.plan === 'premium' || dm.isPremium || dm.plan === 'elite' || dm.isElite || dm.isBot || dm.id.startsWith('b-')) ? 'none' : 'grayscale(100%)' }}
/>
                {(dm.unreadCount || 0) > 0 && (
                  <div className="absolute -top-1 -right-1 bg-red-500 text-white text-[10px] font-black w-4 h-4 rounded-full flex items-center justify-center animate-pulse shadow-[0_0_10px_rgba(239,68,68,0.5)] ring-2 ring-white dark:ring-[#111214]">{dm.unreadCount}</div>
                )}
                <div className={`absolute bottom-0 right-0 w-3 h-3 rounded-full border-2 border-white dark:border-[#111214] shadow-sm 
                  ${dm.status === 'online' ? 'bg-green-500' : dm.status === 'idle' ? 'bg-yellow-500' : dm.status === 'dnd' ? 'bg-red-500' : 'bg-gray-500'}`}>
                </div>
              </div>
              <div className="flex-1 overflow-hidden">
                {/* 🚀 ÇÖZÜM: md: eklendi, mobilde tıklamayı yutmasın */}
                <div className="font-bold text-sm text-gray-900 dark:text-white truncate md:group-hover:translate-x-1 transition-transform duration-300">{dm.username}</div>
                {/* 🚀 TÜRKÇE VE RENKLİ DURUM YAZISI */}
                <div className={`text-[10px] font-bold uppercase tracking-wider truncate md:group-hover:translate-x-1 transition-transform duration-300 delay-75 
                  ${dm.status === 'online' ? 'text-green-500' : dm.status === 'idle' ? 'text-yellow-500' : dm.status === 'dnd' ? 'text-red-500' : 'text-gray-500'}`}>
                  {dm.status === 'online' ? 'Çevrimiçi' : dm.status === 'idle' ? 'Boşta' : dm.status === 'dnd' ? 'Rahatsız Etmeyin' : 'Çevrimdışı'}
                </div>
              </div>
              {/* 🚀 ÇÖZÜM: Mobilde X butonu ya seçiliyken görünür olur ya da transparan kalır ki tıklama boşa gitmesin */}
              <button onClick={(e) => { e.stopPropagation(); handleCloseDm(dm.id); }} className={`text-gray-500 hover:text-red-500 p-1.5 rounded-lg hover:bg-white/10 transition-all hover:scale-110 ${activeDmId === dm.id ? 'opacity-100' : 'opacity-100 md:opacity-0 md:group-hover:opacity-100'}`}><X size={14} /></button>
            </div>
          ))}
        </>
      ) : (
        <>
{/* 🚀 DEVRİMSEL: KLASÖRLÜ KANAL SİSTEMİ EKRANI */}
        {(() => {
          const channelFolders = (activeServer as any)?.channelFolders || [];
          const folderedChannelIds = channelFolders.flatMap((f: any) => f.channelIds || []);

          const validTextChannels = currentChannels.filter(c => {
            if (c.type !== 'text') return false;
            if (c.name.startsWith('ticket-')) {
              if (canManageServer) return true;
              if ((c as any).creatorId === currentUser?.id) return true;
              return false;
            }
            return true;
          });
          const validVoiceChannels = currentChannels.filter(c => c.type === 'voice');

          const unfolderedTextChannels = validTextChannels.filter(c => !folderedChannelIds.includes(c.id));
          const unfolderedVoiceChannels = validVoiceChannels.filter(c => !folderedChannelIds.includes(c.id));
const renderTextChannel = (channel: any) => {
  const isUnread = unreadChannels[channel.id];
  const mentions = channelMentions[channel.id] || 0;
  const isActive = activeChannelId === channel.id;

  return (
    <div key={channel.id} onClick={() => handleChannelClick(channel)} className={`relative flex items-center px-3 py-2 rounded-xl mb-1 cursor-pointer group transition-all duration-200 ${
      isActive 
        ? 'bg-sesgelio/15 dark:bg-sesgelio/20 backdrop-blur-sm border border-sesgelio/25 shadow-[inset_0_1px_0_rgba(255,255,255,0.08),0_2px_8px_rgba(255,43,94,0.12)] text-sesgelio font-bold' 
        : isUnread 
          ? 'text-gray-900 dark:text-white font-bold hover:bg-white/60 dark:hover:bg-white/5 hover:backdrop-blur-sm border border-transparent hover:border-white/20 dark:hover:border-white/10' 
          : 'text-gray-400 dark:text-gray-500 hover:bg-white/60 dark:hover:bg-white/5 hover:backdrop-blur-sm border border-transparent hover:border-white/20 dark:hover:border-white/10 hover:text-gray-700 dark:hover:text-gray-300'
    }`}>
      
      {/* ⚪ BİLDİRİM NOKTASI */}
      {!isActive && isUnread && (
        <div 
          onMouseEnter={(e) => { 
            const rect = e.currentTarget.getBoundingClientRect(); 
            setHoverTooltip({show: true, text: 'Kaçırdığın mesajlar', top: rect.top + rect.height / 2, left: rect.right + 10, position: 'right'}); 
          }}
          onMouseLeave={() => setHoverTooltip(prev => ({...prev, show: false}))}
          className="absolute -left-1 top-1/2 -translate-y-1/2 w-2 h-2 bg-sesgelio rounded-full shadow-[0_0_8px_rgba(255,43,94,0.7)] animate-fade-in-right z-[100] cursor-help pointer-events-auto"
        ></div>
      )}

{/* # İKONU — Renkli ve Kategoriye Göre */}
      {channel.iconUrl ? (
        <div className="w-7 h-7 rounded-full bg-white dark:bg-white/10 flex items-center justify-center mr-2.5 flex-shrink-0 shadow-sm overflow-hidden border border-gray-200 dark:border-white/5">
          <img src={channel.iconUrl.startsWith('http') ? channel.iconUrl : `${BACKEND_URL}${channel.iconUrl}`} alt="icon" className={`object-contain drop-shadow-md ${channel.iconUrl.includes('gif') ? 'w-full h-full object-cover' : 'w-4 h-4'}`} />
        </div>
      ) : (
        <div className={`w-6 h-6 rounded-lg flex items-center justify-center mr-2.5 flex-shrink-0 transition-all duration-200 ${
          isActive 
            ? 'bg-sesgelio/25 shadow-[0_0_8px_rgba(255,43,94,0.3)]' 
            : 'bg-blue-500/10 group-hover:bg-blue-500/20'
        }`}>
          <Hash size={13} className={isActive ? 'text-sesgelio' : 'text-blue-400 group-hover:text-blue-300'} strokeWidth={2.5} />
        </div>
      )}

      <span className={`truncate text-sm flex-1 font-medium transition-colors ${isActive ? 'text-sesgelio' : ''}`}>{channel.name}</span>

      {/* 🔴 Mention Rozeti */}
      {mentions > 0 && (
        <div className="bg-red-500 text-white text-[10px] font-black px-1.5 py-0.5 rounded-lg ml-auto shadow-[0_0_8px_rgba(239,68,68,0.5)]">
          {mentions}
        </div>
      )}
    </div>
  );
};

const renderVoiceChannel = (channel: any) => {
  const participants = channelOccupancy[channel.id] || [];
  const isConnectingToThis = voiceConnectionStatus === ConnectionState.CONNECTING && activeVoiceChannel === channel.id;
  const isConnected = activeVoiceChannel === channel.id;
  
  return (
<div key={channel.id} onClick={() => handleChannelClick(channel)} className={`flex flex-col rounded-xl mb-1 cursor-pointer group transition-all duration-200 ${
      isConnected 
        ? 'bg-green-500/10 dark:bg-green-500/15 backdrop-blur-sm border border-green-500/25 shadow-[inset_0_1px_0_rgba(255,255,255,0.06),0_2px_8px_rgba(34,197,94,0.1)]' 
        : 'border border-transparent hover:bg-white/60 dark:hover:bg-white/5 hover:backdrop-blur-sm hover:border-white/20 dark:hover:border-white/10'
    }`}>
      <div className={`flex items-center px-3 py-2 ${isConnected ? 'text-green-600 dark:text-green-400' : 'text-gray-400 dark:text-gray-500 group-hover:text-gray-700 dark:group-hover:text-gray-300'}`}>
        {channel.iconUrl ? (
          <div className="w-7 h-7 rounded-full bg-white dark:bg-white/10 flex items-center justify-center mr-2.5 flex-shrink-0 shadow-sm overflow-hidden border border-gray-200 dark:border-white/5">
            <img src={channel.iconUrl.startsWith('http') ? channel.iconUrl : `${BACKEND_URL}${channel.iconUrl}`} alt="icon" className={`object-contain drop-shadow-md ${channel.iconUrl.includes('gif') ? 'w-full h-full object-cover' : 'w-4 h-4'}`} />
          </div>
        ) : channel.voiceMode === 'ai' ? (
          <div className="w-6 h-6 rounded-lg bg-sesgelio/15 flex items-center justify-center mr-2.5 flex-shrink-0">
            <Sparkles size={13} className="text-sesgelio" />
          </div>
        ) : (
          <div className={`w-6 h-6 rounded-lg flex items-center justify-center mr-2.5 flex-shrink-0 transition-all duration-200 ${
            isConnected 
              ? 'bg-green-500/25 shadow-[0_0_8px_rgba(34,197,94,0.3)]' 
              : 'bg-green-500/10 group-hover:bg-green-500/20'
          }`}>
            <Volume2 size={13} className={isConnected ? 'text-green-500 animate-pulse' : 'text-green-500/70 group-hover:text-green-400'} strokeWidth={2.5} />
          </div>
        )}
        <span className={`text-sm truncate flex-1 transition-colors ${isConnected ? 'font-bold text-green-600 dark:text-green-400' : 'font-medium'}`}>{channel.name}</span>
        {isConnectingToThis 
          ? <Loader2 size={14} className="animate-spin text-gray-400" /> 
          : participants.length > 0 && (
            <span className={`text-[10px] px-1.5 py-0.5 rounded-lg ml-2 font-mono font-black ${isConnected ? 'bg-green-500/20 text-green-500' : 'bg-gray-200 dark:bg-white/10 text-gray-600 dark:text-gray-300'}`}>
              {participants.length}
            </span>
          )
        }
      </div>
                  {participants.length > 0 && (
                    <div className="pl-8 pb-2 pr-2 space-y-1">
{participants.map(user => {
  const isCameraOn = globalVideoUsers[user.id] || (user as any).isVideoOn;
  const isScreenOn = globalScreenUsers[user.id] || (user as any).isScreenSharing;
  
  // 🚀 RADAR KONTROLÜ
  const isMicMuted = user.id === currentUser?.id 
    ? isMuted 
    : (globalMutedUsers[user.id] ?? (user as any).isMuted ?? false);
    
  const isAudioDeafened = user.id === currentUser?.id 
    ? isDeafened 
    : (globalDeafenedUsers[user.id] ?? (user as any).isDeafened ?? false);

  return (
    <div key={user.id} className="flex items-center bg-transparent hover:bg-gray-100 dark:hover:bg-white/5 rounded-md p-1 transition-colors">
      {renderChannelAvatar(user)}
      <div className="flex items-center gap-1 min-w-0 ml-1 flex-1">
        <span 
          className={`text-xs truncate transition-all duration-300 ${
            (user.plan === 'elite' || user.isElite) ? '!text-yellow-500 font-bold' 
            : (user.id === currentUser?.id || user.plan === 'premium' || user.isPremium) ? 'text-sesgelio font-medium' 
            : 'text-gray-600 dark:text-gray-300 font-medium'
          }`}
          style={{
            color: (user.plan === 'elite' || user.isElite) ? '#eab308' : undefined,
            textShadow: (user.plan === 'elite' || user.isElite) ? '0 0 10px rgba(234, 179, 8, 0.4)' : 'none'
          }}
        >
          {user.username}
        </span>
        {/* 👑 Elite/Premium Taç */}
        {(user.plan === 'elite' || user.isElite) ? (
          <Crown size={10} className="text-yellow-500 fill-current animate-pulse flex-shrink-0" />
        ) : (user.plan === 'premium' || user.isPremium) ? (
          <Crown size={10} className="text-red-500 fill-current flex-shrink-0" />
        ) : null}
      </div>

{/* 🚀 MEDYA DURUM İKONLARI (BÜYÜTÜLDÜ VE PARLATILDI) */}
      <div className="flex items-center gap-1.5 flex-shrink-0 ml-2">
        {isAudioDeafened && (
          <div className="w-5 h-5 rounded-md bg-red-600/20 flex items-center justify-center border border-red-600/30 shadow-sm" title="Sağırlaştırıldı">
            <PhoneOff size={12} className="text-red-500" strokeWidth={2.5} />
          </div>
        )}
        {isMicMuted && (
          <div className="w-5 h-5 rounded-md bg-red-500/20 flex items-center justify-center border border-red-500/30 shadow-sm" title="Mikrofon Kapalı">
            <MicOff size={12} className="text-red-500" strokeWidth={2.5} />
          </div>
        )}
        {isCameraOn && (
          <div className="w-5 h-5 rounded-md bg-blue-500/20 flex items-center justify-center border border-blue-500/30 shadow-sm" title="Kamera Açık">
            <Video size={12} className="text-blue-400 drop-shadow-[0_0_6px_rgba(96,165,250,0.8)]" strokeWidth={2.5} />
          </div>
        )}
        {isScreenOn && (
          <div className="w-5 h-5 rounded-md bg-emerald-500/20 flex items-center justify-center border border-emerald-500/30 shadow-sm" title="Ekran Paylaşımı">
            <MonitorUp size={12} className="text-emerald-400 drop-shadow-[0_0_6px_rgba(52,211,153,0.8)]" strokeWidth={2.5} />
          </div>
        )}
      </div>
    </div>
  );
})}
                    </div>
                  )}
              </div>
            );
          };

          return (
            <>
{/* 1. KLASÖRLÜ KANALLAR */}
        {channelFolders.map((folder: any) => {
          const folderTextChannels = validTextChannels.filter(c => folder.channelIds?.includes(c.id));
          const folderVoiceChannels = validVoiceChannels.filter(c => folder.channelIds?.includes(c.id));
          const isCollapsed = collapsedChannelFolders.includes(folder.id);

// 🚀 YENİ MANTIK: Görünen Kanallar Mührü
          const visibleTextChannels = isCollapsed 
              ? folderTextChannels.filter(c => c.id === activeChannelId) 
              : folderTextChannels;
          const visibleVoiceChannels = isCollapsed 
              ? folderVoiceChannels.filter(c => c.id === activeVoiceChannel) 
              : folderVoiceChannels;

          if (folderTextChannels.length === 0 && folderVoiceChannels.length === 0) return null;

          return (
            <div key={folder.id} className="mb-4">
              <div 
                onClick={() => setCollapsedChannelFolders(prev => prev.includes(folder.id) ? prev.filter(id => id !== folder.id) : [...prev, folder.id])} 
                className="flex items-center justify-between px-1 mb-1 group cursor-pointer transition-colors"
              >
                <div className="flex items-center gap-1.5 text-gray-500 dark:text-gray-400 group-hover:text-gray-700 dark:group-hover:text-gray-200">
                  <ChevronDown size={12} strokeWidth={3} className={`transition-transform duration-200 ${isCollapsed ? '-rotate-90' : ''}`} />
                  <Folder size={14} strokeWidth={2.5} style={{ color: folder.color || 'inherit' }} />
                  <span className="text-[11px] font-bold uppercase tracking-wider mt-[1px]" style={{ color: folder.color || 'inherit' }}>{folder.name}</span>
                </div>
                {canManageServer && <Plus onClick={(e) => { e.stopPropagation(); setCreateChannelDefaultType(null); setCreateChannelTargetFolderId(folder.id); setShowCreateChannelModal(true); }} size={16} className="text-gray-500 opacity-0 group-hover:opacity-100 cursor-pointer hover:text-sesgelio transition-all" />}
              </div>

              {(visibleTextChannels.length > 0 || visibleVoiceChannels.length > 0) && (
                <div className="mt-1.5 mx-1 rounded-xl overflow-hidden" style={{ background: `linear-gradient(135deg, ${folder.color}08, ${folder.color}04)`, border: `1px solid ${folder.color}20` }}>
                  <div className="p-1.5 space-y-0.5">
                    {/* Klasör İçi Metin Kanalları */}
                    {visibleTextChannels.length > 0 && (
                      <div>
                        {visibleTextChannels.length > 0 && visibleVoiceChannels.length > 0 && (
                          <div className="flex items-center gap-1.5 px-2 py-1 mb-0.5">
                            <div className="w-3 h-3 rounded-sm flex items-center justify-center" style={{ backgroundColor: `${folder.color}30` }}>
                              <Hash size={8} style={{ color: folder.color }} strokeWidth={3} />
                            </div>
                            <span className="text-[9px] font-black uppercase tracking-widest" style={{ color: `${folder.color}99` }}>Metin</span>
                          </div>
                        )}
                        {/* 🚀 ZARİF ŞERİT VE KANAL ARASI ÇİZGİLER (Klasör İçi) */}
                        <div className={`flex flex-col gap-1 divide-y divide-white/5 ${(visibleTextChannels.length > 0 && visibleVoiceChannels.length > 0) ? 'ml-[10px] pl-2 border-l border-white/10' : ''}`}>
                          {visibleTextChannels.map(renderTextChannel)}
                        </div>
                      </div>
                    )}

                    {/* Ayırıcı */}
                    {visibleTextChannels.length > 0 && visibleVoiceChannels.length > 0 && (
                      <div className="my-1.5 mx-2 h-px rounded-full" style={{ backgroundColor: `${folder.color}20` }}></div>
                    )}

                    {/* Klasör İçi Ses Kanalları */}
                    {visibleVoiceChannels.length > 0 && (
                      <div>
                        {visibleTextChannels.length > 0 && visibleVoiceChannels.length > 0 && (
                          <div className="flex items-center gap-1.5 px-2 py-1 mb-0.5">
                            <div className="w-3 h-3 rounded-sm flex items-center justify-center" style={{ backgroundColor: `${folder.color}30` }}>
                              <Volume2 size={8} style={{ color: folder.color }} strokeWidth={3} />
                            </div>
                            <span className="text-[9px] font-black uppercase tracking-widest" style={{ color: `${folder.color}99` }}>Ses</span>
                          </div>
                        )}
                        {/* 🚀 ZARİF ŞERİT VE KANAL ARASI ÇİZGİLER (Klasör İçi) */}
                        <div className={`flex flex-col gap-1 divide-y divide-white/5 ${(visibleTextChannels.length > 0 && visibleVoiceChannels.length > 0) ? 'ml-[10px] pl-2 border-l border-white/10' : ''}`}>
                          {visibleVoiceChannels.map(renderVoiceChannel)}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
          );
        })}

{/* 2. KLASÖRSÜZ METİN KANALLARI */}
              {unfolderedTextChannels.length > 0 && (
                <div id="tour-text-channels" className="mb-4">
                  <div 
                    onClick={() => setIsTextChannelsExpanded(!isTextChannelsExpanded)}
                    className="flex items-center justify-between px-1 mb-1.5 group cursor-pointer"
                  >
                    <div className="flex items-center gap-1.5 text-gray-500 dark:text-gray-400 group-hover:text-gray-700 dark:group-hover:text-gray-200 transition-colors">
                      <ChevronDown size={12} strokeWidth={3} className={`transition-transform duration-200 ${!isTextChannelsExpanded ? '-rotate-90' : ''}`} />
                      <span className="text-[11px] font-bold uppercase tracking-wider mt-[1px]">METİN KANALLARI</span>
                    </div>
                    {canManageServer && <Plus onClick={(e) => { e.stopPropagation(); setCreateChannelDefaultType('text'); setShowCreateChannelModal(true); }} size={16} className="text-gray-500 opacity-0 group-hover:opacity-100 cursor-pointer hover:text-sesgelio transition-all" />}
                  </div>
                  
{/* 🚀 ZARİF ŞERİT VE KANAL ARASI ÇİZGİLER (divide-y) */}
                  {(!isTextChannelsExpanded ? unfolderedTextChannels.filter(c => c.id === activeChannelId) : unfolderedTextChannels).length > 0 && (
                    <div className="ml-[11px] pl-2.5 border-l border-white/10 mt-1 flex flex-col gap-1 divide-y divide-white/5">
                      {(!isTextChannelsExpanded
                          ? unfolderedTextChannels.filter(c => c.id === activeChannelId)
                          : unfolderedTextChannels
                      ).map(renderTextChannel)}
                    </div>
                  )}
                </div>
              )}

{/* 3. KLASÖRSÜZ SES KANALLARI */}
              {unfolderedVoiceChannels.length > 0 && (
                <div id="tour-voice-channels" className="mb-4">
                  <div 
                    onClick={() => setIsVoiceChannelsExpanded(!isVoiceChannelsExpanded)}
                    className="flex items-center justify-between px-1 mb-1.5 group cursor-pointer"
                  >
                    <div className="flex items-center gap-1.5 text-gray-500 dark:text-gray-400 group-hover:text-gray-700 dark:group-hover:text-gray-200 transition-colors">
                      <ChevronDown size={12} strokeWidth={3} className={`transition-transform duration-200 ${!isVoiceChannelsExpanded ? '-rotate-90' : ''}`} />
                      <span className="text-[11px] font-bold uppercase tracking-wider mt-[1px]">SES KANALLARI</span>
                    </div>
                    {canManageServer && <Plus onClick={(e) => { e.stopPropagation(); setCreateChannelDefaultType('voice'); setShowCreateChannelModal(true); }} size={16} className="text-gray-500 opacity-0 group-hover:opacity-100 cursor-pointer hover:text-sesgelio transition-all" />}
                  </div>
                  
                  {/* 🚀 ZARİF ŞERİT VE KANAL ARASI ÇİZGİLER (divide-y) */}
                  {(!isVoiceChannelsExpanded ? unfolderedVoiceChannels.filter(c => c.id === activeVoiceChannel) : unfolderedVoiceChannels).length > 0 && (
                    <div className="ml-[11px] pl-2.5 border-l border-white/10 mt-1 flex flex-col gap-1 divide-y divide-white/5">
                      {(!isVoiceChannelsExpanded 
                          ? unfolderedVoiceChannels.filter(c => c.id === activeVoiceChannel) 
                          : unfolderedVoiceChannels
                      ).map(renderVoiceChannel)}
                    </div>
                  )}
                  
                </div>
              )}
            </>
          );
        })()}
        </>
      )}
    </div>

<div className="bg-[#ebedef] dark:bg-[#141517] border-t border-gray-300 dark:border-white/5 flex flex-col shrink-0 z-10">
    {/* 🚀 ÇÖZÜM MÜHRÜ 2: Gelişmiş Ses Bağlantı Kontrol Paneli (Uyarı Korumalı ve Odaklı) */}
    {voiceConnected && (connectedChannel || activeVoiceChannel?.startsWith('call-')) && currentUser && ( 
     <div className="flex flex-col bg-green-500/5 dark:bg-[#111214] border-b border-green-500/20 dark:border-white/5 p-2 gap-2 animate-fade-in-up">
           {/* Üst Kısım: Sinyal ve Oda Adı */}
           <div className="flex items-center justify-between cursor-pointer group" onClick={() => {
             if(activeVoiceChannel?.startsWith('call-')) {
                setActiveServerId('home'); setActiveGroupId(null); setActiveDmId(null); setActiveChannelId(activeVoiceChannel); setIsDmMinimized(true);
             } else if(connectedServerId) {
                // 🚀 ODAK MÜHRÜ: Sadece sunucuya geç, metin kanalını elleme (Eski handleServerClick yerine manuel geçiş)
                setActiveServerId(connectedServerId); 
                setActiveChannelId(activeVoiceChannel); // Direkt ses kanalını odakla!
                setIsServerMenuOpen(false);
             }
           }}>
                <div className="flex flex-col overflow-hidden">
                    <span className="text-green-600 dark:text-green-500 font-bold text-[11px] flex items-center gap-1.5 uppercase tracking-wide"><Signal size={12} className="animate-pulse" /> Ses Bağlantısı Kuruldu</span>
                    <span className="text-gray-900 dark:text-gray-200 font-bold text-sm truncate group-hover:underline">
                        {activeVoiceChannel?.startsWith('call-') ? 'Özel Grup Çağrısı' : `${connectedChannel?.name} / ${servers.find(s => s.id === connectedServerId)?.name}`}
                    </span>
                </div>
            </div>

           {/* Alt Kısım: Hızlı Kontrol Butonları */}
            <div className="flex items-center justify-between gap-1.5 mt-0.5">
           {/* Kamera Butonu */}
                <button 
                    onMouseEnter={(e) => { const rect = e.currentTarget.getBoundingClientRect(); setHoverTooltip({show: true, text: globalVideoUsers[currentUser.id] ? "Kamerayı Kapat" : "Kamera Aç", top: rect.top, left: rect.left + rect.width / 2, position: 'top'}); }}
                    onMouseLeave={() => setHoverTooltip(prev => ({...prev, show: false}))}
                    onClick={() => {
                        if (!isViewingVoiceChannel && !isViewingGroupCall) {
                            if(activeVoiceChannel?.startsWith('call-')) {
                                setActiveServerId('home'); setActiveGroupId(null); setActiveDmId(null); setActiveChannelId(activeVoiceChannel); setIsDmMinimized(true);
                            } else if(connectedServerId) {
                                setActiveServerId(connectedServerId); 
                                setActiveChannelId(activeVoiceChannel);
                            }
                        }

                        // 🚀 ÇÖZÜM MÜHRÜ: Doğrudan açmak yerine, VoiceStage'e "Kameraya Basıldı" sinyali fırlatıyoruz!
                        window.dispatchEvent(new CustomEvent('sesgelio-external-camera-click'));
                    }} 
                    className={`flex-1 flex justify-center items-center p-1.5 rounded-lg transition-all ${globalVideoUsers[currentUser.id] ? 'text-[#111214] bg-white hover:bg-gray-200' : 'text-gray-500 dark:text-gray-400 bg-gray-200 dark:bg-white/5 hover:bg-gray-300 dark:hover:bg-white/10'}`}
                >
                    {globalVideoUsers[currentUser.id] ? <Video size={18} /> : <VideoOff size={18} />}
                </button>

                {/* Ekran Paylaşımı Butonu */}
                <button 
                    onMouseEnter={(e) => { const rect = e.currentTarget.getBoundingClientRect(); setHoverTooltip({show: true, text: globalScreenUsers[currentUser.id] ? "Yayını Kapat" : "Ekran Paylaş", top: rect.top, left: rect.left + rect.width / 2, position: 'top'}); }}
                    onMouseLeave={() => setHoverTooltip(prev => ({...prev, show: false}))}
                    onClick={() => {
                        if (!isViewingVoiceChannel && !isViewingGroupCall) {
                            if(activeVoiceChannel?.startsWith('call-')) {
                                setActiveServerId('home'); setActiveGroupId(null); setActiveDmId(null); setActiveChannelId(activeVoiceChannel); setIsDmMinimized(true);
                            } else if(connectedServerId) {
                                setActiveServerId(connectedServerId); 
                                setActiveChannelId(activeVoiceChannel);
                            }
                        }
                        window.dispatchEvent(new CustomEvent('sesgelio-toggle-screen'));
                    }} 
                    className={`flex-1 flex justify-center items-center p-1.5 rounded-lg transition-all ${globalScreenUsers[currentUser.id] ? 'text-[#111214] bg-white hover:bg-gray-200' : 'text-gray-500 dark:text-gray-400 bg-gray-200 dark:bg-white/5 hover:bg-gray-300 dark:hover:bg-white/10'}`}
                >
                    {globalScreenUsers[currentUser.id] ? <MonitorUp size={18} /> : <MonitorOff size={18} />}
                </button>

                {/* Tüm Sesleri Sustur Butonu */}
                <button 
                    onMouseEnter={(e) => { const rect = e.currentTarget.getBoundingClientRect(); setHoverTooltip({show: true, text: isDeafened ? "Sesi Aç" : "Sustur", top: rect.top, left: rect.left + rect.width / 2, position: 'top'}); }}
                    onMouseLeave={() => setHoverTooltip(prev => ({...prev, show: false}))}
                    onClick={() => setIsDeafened(!isDeafened)} 
                    className={`flex-1 flex justify-center items-center p-1.5 rounded-lg transition-all ${isDeafened ? 'text-white bg-red-500 hover:bg-red-600' : 'text-gray-500 dark:text-gray-400 bg-gray-200 dark:bg-white/5 hover:bg-gray-300 dark:hover:bg-white/10'}`}
                >
                    {isDeafened ? <PhoneOff size={18} /> : <VolumeX size={18} />} 
                </button>

                {/* Çıkış Butonu */}
                <button 
                    onMouseEnter={(e) => { const rect = e.currentTarget.getBoundingClientRect(); setHoverTooltip({show: true, text: 'Bağlantıyı Kes', top: rect.top, left: rect.left + rect.width / 2, position: 'top'}); }}
                    onMouseLeave={() => setHoverTooltip(prev => ({...prev, show: false}))}
                    onClick={handleDisconnect} 
                    className="flex-1 flex justify-center items-center p-1.5 rounded-lg text-red-500 bg-red-500/10 hover:bg-red-500 hover:text-white transition-all"
                >
                    <PhoneOff size={18} />
                </button>
            </div>
        </div>
    )}
    {/* 🚀 DM ARAMA İNDİKATÖRÜ (Discord Tarzı Sol Alt Panel) */}
    {ongoingDmCall && !voiceConnected && (
        <div className="px-3 py-2 bg-emerald-500/10 border-b border-emerald-500/20 flex items-center justify-between animate-fade-in-up">
            <div className="flex flex-col overflow-hidden mr-2 cursor-pointer hover:underline" onClick={() => { setActiveServerId('home'); setActiveDmId(ongoingDmCall.id); }}>
                <span className="text-emerald-500 font-black text-[10px] flex items-center gap-1.5 uppercase tracking-widest">
                    <Signal size={12} className="animate-pulse" /> Özel Arama
                </span>
                <span className="text-gray-900 dark:text-white font-bold text-xs truncate max-w-[120px]">{ongoingDmCall.name}</span>
            </div>
            <button 
                onClick={(e) => { e.stopPropagation(); window.dispatchEvent(new CustomEvent('force-end-dm-call')); }} 
                className="w-8 h-8 flex items-center justify-center text-red-500 bg-red-500/10 hover:bg-red-500 hover:text-white rounded-lg transition-all transform active:scale-90"
                title="Aramayı Sonlandır"
            >
                <PhoneOff size={14}/>
            </button>
        </div>
    )}

<div id="tour-controls" className="h-[65px] flex items-center justify-between px-2 w-full">
      <div 
        onMouseEnter={(e) => { const rect = e.currentTarget.getBoundingClientRect(); setHoverTooltip({show: true, text: 'Kullanıcı Profili', top: rect.top, left: rect.left + rect.width / 2, position: 'top'}); }}
        onMouseLeave={() => setHoverTooltip(prev => ({...prev, show: false}))}
        className="flex items-center flex-1 min-w-0 mr-1 group cursor-pointer hover:bg-gray-300 dark:hover:bg-white/10 p-1.5 rounded-lg transition-colors overflow-visible relative"
      >
        <div className="relative w-10 h-10 flex-shrink-0">
          {renderSidebarProfileAvatar()}
          <div className="absolute bottom-0 right-0 w-3 h-3 bg-green-500 rounded-full border-2 border-[#ebedef] dark:border-[#141517] z-30"></div>
        </div>
        <div className="ml-2.5 flex-1 min-w-0 flex flex-col justify-center">
            <div className="flex items-center gap-1.5">
                <div 
                    className={`text-sm font-bold truncate leading-none mb-0.5 ${
                        (currentUser?.plan === 'elite' || currentUser?.isElite) 
                        ? 'text-yellow-500 font-black' 
                        : (currentUser?.plan === 'premium' || currentUser?.isPremium)
                        ? 'text-red-600 font-black'
                        : 'text-gray-900 dark:text-white'
                    }`}
                    style={{
                        color: (currentUser?.plan === 'elite' || currentUser?.isElite) 
                          ? '#eab308' 
                          : (currentUser?.plan === 'premium' || currentUser?.isPremium) 
                          ? '#ef4444' 
                          : undefined,
                        textShadow: (currentUser?.plan === 'elite' || currentUser?.isElite) 
                          ? '0 0 10px rgba(234, 179, 8, 0.4)' 
                          : (currentUser?.plan === 'premium' || currentUser?.isPremium) 
                          ? '0 0 8px rgba(239, 68, 68, 0.3)' 
                          : 'none'
                    }}
                >
                    {currentUser?.username}
                </div>
                {/* Sol Alt Profil Taç Kontrolü */}
                {(currentUser?.plan === 'elite' || currentUser?.isElite) ? (
                    <Crown size={14} className="text-yellow-500 fill-current animate-pulse flex-shrink-0" />
                ) : (currentUser?.plan === 'premium' || currentUser?.isPremium) ? (
                    <Crown size={14} className="text-red-600 fill-current flex-shrink-0" />
                ) : null}
            </div>
            <div className="text-xs text-gray-500 dark:text-gray-400 font-mono font-bold leading-none truncate mt-0.5">#{currentUser?.discriminator}</div>
        </div>
      </div>
      <div className="flex items-center gap-0.5 flex-shrink-0">
<button 
          onMouseEnter={(e) => { const rect = e.currentTarget.getBoundingClientRect(); setHoverTooltip({show: true, text: isMuted ? 'Sesi Aç' : 'Sesi Kapat', top: rect.top, left: rect.left + rect.width / 2, position: 'top'}); }}
          onMouseLeave={() => setHoverTooltip(prev => ({...prev, show: false}))}
          onClick={() => {
              if (!hasSystemMic) {
                  alert("Sisteme bağlı bir mikrofon bulunamadı. Sesi açamazsın!");
                  return;
              }
              setIsMuted(!isMuted);
          }} 
          className={`w-8 h-8 flex items-center justify-center rounded-lg ${isMuted ? 'bg-red-500/10 text-red-500' : 'hover:bg-gray-300 dark:hover:bg-white/10'}`}
        >
          {isMuted ? <MicOff size={18}/> : <MicVocal size={18}/>}
        </button>
        <button 
          onMouseEnter={(e) => { const rect = e.currentTarget.getBoundingClientRect(); setHoverTooltip({show: true, text: isDeafened ? 'Sağırlaştırmayı Kapat' : 'Sağırlaştır', top: rect.top, left: rect.left + rect.width / 2, position: 'top'}); }}
          onMouseLeave={() => setHoverTooltip(prev => ({...prev, show: false}))}
          onClick={() => setIsDeafened(!isDeafened)} 
          className={`w-8 h-8 flex items-center justify-center rounded-lg ${isDeafened ? 'bg-red-500/10 text-red-500' : 'hover:bg-gray-300 dark:hover:bg-white/10'}`}
        >
          {isDeafened ? <PhoneOff size={18}/> : <AudioLines size={18}/>}
        </button>
<button 
          onMouseEnter={(e) => { const rect = e.currentTarget.getBoundingClientRect(); setHoverTooltip({show: true, text: 'Kullanıcı Ayarları', top: rect.top, left: rect.left + rect.width / 2, position: 'top'}); }}
          onMouseLeave={() => setHoverTooltip(prev => ({...prev, show: false}))}
          onClick={() => { 
             setSettingsInitialTab('account'); 
             setShowSettings(true); 
             setHoverTooltip({show: false, text: '', top: 0, left: 0}); // 🚀 ÇÖZÜM: Ayarlar açıldığı an yazıyı havada yok et!
          }} 
          className="w-8 h-8 flex items-center justify-center rounded-lg hover:bg-gray-300 dark:hover:bg-white/10"
        >
          <Settings2 size={18}/>
        </button>
      </div>
    </div>
  </div>
</div>
)}     </div>
    <div className="flex-1 my-4 mr-4 h-[calc(100dvh-32px)] rounded-[32px] overflow-hidden bg-transparent flex flex-col min-w-0 transition-colors shadow-2xl border border-gray-200/50 dark:border-white/10 z-30 relative">
        
        {/* 🚀 MÜHÜR 1: ÖLÜMSÜZ DM MOTORU (Arama varsa BURASI çalışır ve ASLA ÖLMEZ) */}
<div style={{ position: 'absolute', inset: 0, zIndex: activeDmId ? 40 : 10, backgroundColor: 'inherit', pointerEvents: 'none' }}>
          {currentUser && [
              ...(activeDmId ? [activeDmId] : []),
              ...(ongoingDmCall && ongoingDmCall.id !== activeDmId ? [ongoingDmCall.id] : [])
          ].map(dmId => {
              const isVisible = dmId === activeDmId && !isDmMinimized && activeServerId === 'home';
              const friendData = dmId === activeDmId ? friendForChat : ongoingFriendForChat;

              return (
                <div key={`dm-wrapper-${dmId}`} style={{ display: isVisible ? 'flex' : 'none', pointerEvents: isVisible ? 'auto' : 'none', width: '100%', height: '100%', flexDirection: 'column' }}>
                  <DirectMessageChat
                     socket={socketRef.current}
                     friend={friendData}
                     currentUser={currentUser}
                     isMuted={isMuted}
                     isDeafened={isDeafened}
                     relationship={((activeFriend?.relationship as any) || 'none')}
                     onAddFriend={() => handleAddFriendFromDm(dmId)}
                     onClose={() => { setActiveDmId(null); setIsDmMinimized(true); }}
                     didAcceptCall={didAcceptCall}
                     incomingSignal={activeCallSignal}
                     clearCallSignal={() => setActiveCallSignal(null)}
                     onBotCommand={handleBotCommand}
                     onRefreshFriends={handleRefreshFriends}
                     globalIceCandidates={globalIceCandidates}
                     clearGlobalIceCandidates={() => setGlobalIceCandidates([])}
                     onUpdateDmWallpaper={(friendId: string, wallpaperUrl: string | null, wallpaperBrightness: number) => { setFriends(prev => prev.map(f => f.id === friendId ? { ...f, wallpaperUrl, wallpaperBrightness } as any : f)); }}
                  />
                </div>
              );
          })}
        </div>
        {/* 🚀 MÜHÜR 2: DİĞER SAYFALARIN YÖNETİMİ */}
      {((isDmMinimized || activeServerId !== 'home' || (!activeDmId && !ongoingDmCall)) || activeVoiceChannel) && (
          <>
            {activeServerId === 'discovery' ? (
              <ServerDiscovery onJoinServer={handlePulseJoin} /> 
            ) : activeServerId === 'gemini-ai' && currentUser ? (
              <GeminiMarketingView 
                currentUser={currentUser} 
                onOpenMarket={() => handleOpenMarket()} 
                onStartVoiceAI={() => setActiveGeminiSession('voice')}
                onStartChatAI={() => setActiveGeminiSession('chat')}
                onBack={() => setActiveServerId('home')}
              />
            ) : activeServerId === 'home' ? ( 
           /* ANA SAYFA İÇİ GÖRÜNÜMLER (Grup Çağrısı veya Ana Menü) */
isViewingGroupCall ? (
                <div className="w-full shrink-0 flex flex-col bg-[#0a0a0c] animate-fade-in z-20">
                    <div className="px-6 py-4 border-b border-white/5 flex items-center justify-center bg-[#111214] shadow-md z-10">
                        <div className="flex items-center gap-4">
                            <div className="w-10 h-10 bg-emerald-500/20 text-emerald-500 rounded-xl flex items-center justify-center animate-pulse shadow-[0_0_15px_rgba(16,185,129,0.3)]">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="m22 8-6 4 6 4V8Z"/><rect width="14" height="12" x="2" y="6" rx="2" ry="2"/></svg>
                            </div>
                            <div className="flex flex-col items-center text-center">
                                <h2 className="text-lg font-black text-white leading-none mb-1">Güvenli İletişim Hattı</h2>
                                <span className="text-[10px] text-emerald-500 uppercase tracking-widest font-bold">Uçtan Uca Şifreli Bağlantı Aktif</span>
                            </div>
                        </div>                   
                    </div>
                </div> 
              ) : activeGroupId && currentUser ? (
                <GroupChatArea 
                   key={`group-${activeGroupId}`}
                   socket={socketRef.current} 
                   currentUser={currentUser} 
                   group={groups.find(g => g.id === activeGroupId)} 
                   onClose={() => setActiveGroupId(null)} 
                   onGroupDeleted={(id) => { setActiveGroupId(null); setGroups(prev => prev.filter(g => g.id !== id)); }}
                />
              ) : (
                currentUser && <HomeDashboard 
                  currentUser={currentUser} 
                  friends={friends} 
                  pulseActivities={pulseActivities} 
                  onDmSelect={handleDmClick} 
                  onAddFriend={handleAddFriend} 
                  onAcceptFriend={handleAcceptFriend} 
                  onDeclineFriend={handleDeclineFriend} 
                  onJoinServer={handlePulseJoin} 
                  joinedServers={servers} 
                  // 👇 İŞTE BURASI: GERÇEK VERİ KABLOLARI BAĞLANDI
              unreadChannels={unreadChannels}
                  channelMentions={channelMentions}
                  onNavigateToChannel={(serverId, channelId) => {
                      handleServerClick(serverId);
                      setTimeout(() => {
                          setActiveChannelId(channelId);
                          // 🚀 ÇÖZÜM MÜHRÜ 1: Gelen kutusundan kanala gidince etiket (mention) ve bildirim balonunu anında yok et!
                          setUnreadChannels(prev => { const next = { ...prev }; delete next[channelId]; return next; });
                          setChannelMentions(prev => { const next = { ...prev }; delete next[channelId]; return next; });
                          fetch(`${BACKEND_URL}/api/channels/${channelId}/read`, { method: 'POST' }).catch(() => {});
                      }, 50);
                  }}

                  groups={groups}
                  onGroupSelect={async (groupId) => {
                      setActiveServerId('home');
                      setActiveDmId(null);
                      setActiveGroupId(groupId);

                      // 🚀 ÇÖZÜM MÜHRÜ 2: Gelen kutusundan gruba tıklandığı an sol bardaki sayacı sıfırla (Kırmızı balonu patlat)
                      setGroups(prev => prev.map(g => g.id === groupId ? { ...g, unreadCount: 0 } : g));

                      // 🚀 ÇÖZÜM MÜHRÜ 3: MySQL'e arka planda "Ben bunu okudum" sinyali gönder
                      try {
                          await fetch(`${BACKEND_URL}/api/groups/${groupId}/reset-unread`, {
                              method: 'POST',
                          });
                      } catch(err) {}
                  }}                
                  onMarkAllAsRead={() => {
                      setUnreadChannels({});
                      setChannelMentions({});
                      setGroups(prev => prev.map(g => ({ ...g, unreadCount: 0 })));
                      setFriends(prev => prev.map(f => ({ ...f, unreadCount: 0 })));
                  }}
                  
                  onBlockFriend={async (friendId) => {
                  if(!window.confirm("Bu operatörü gerçekten engellemek istiyor musun?")) return;
                  try {
                     await fetch(`${BACKEND_URL}/api/friends/block`, {
                        method: 'POST', 
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({ blockerId: currentUser?.id, blockedId: friendId })
                     });
                     setFriends(prev => prev.filter(f => f.id !== friendId));
                     if (activeDmId === friendId) setActiveDmId(null);
                  } catch(err) {}
               }}
               onUnblockFriend={async (friendId) => {
                  try {
                     await fetch(`${BACKEND_URL}/api/friends/unblock`, {
                        method: 'POST', 
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({ blockerId: currentUser?.id, blockedId: friendId })
                     });
                     setFriends(prev => prev.filter(f => f.id !== friendId));
                  } catch(err) {}
               }}
               onRemoveFriend={async (friendId) => {
                     if(!window.confirm("Bu operatörü arkadaş listenden silmek istediğine emin misin?")) return;
                     try {
                        await fetch(`${BACKEND_URL}/api/friends/remove`, {
                           method: 'POST', 
                           headers: { 'Content-Type': 'application/json' },
                           body: JSON.stringify({ userId: currentUser?.id, friendId })
                        });
                        setFriends(prev => prev.filter(f => f.id !== friendId));
                        if (activeDmId === friendId) setActiveDmId(null);
                     } catch(err) {}
                  }}
               />
              ) 
            ) : ( 
!isViewingVoiceChannel && ( 
                <ChatArea socket={socketRef.current} currentUser={currentUser} currentChannel={activeChannel} roles={currentServerRoles} onBanMember={handleBanMember} onKickMember={handleKickMember} members={activeServer?.members || []} onDmOpen={handleOpenDmFromProfile} bots={activeServer?.bots || []} voiceChannels={currentChannels.filter(c => c.type === 'voice')} onMoveBot={handleMoveBot} onServerBotCommand={handleServerBotCommand as any} serverId={activeServerId} serverOwnerId={activeServer?.ownerId} serverName={activeServer?.name} serverDescription={(activeServer as any)?.description}  onOpenMarket={handleOpenMarket} onUpdateMemberRole={handleUpdateMemberRole} wallpaperUrl={activeServer?.wallpaperUrl || undefined} wallpaperBrightness={(activeServer as any)?.wallpaperBrightness} friends={friends} onAddFriend={handleAddFriend} /> 
              )
            )}
            
          {activeVoiceChannel && currentUser && ( 
    <VoiceStage
                key={`${activeVoiceChannel}-${voiceSessionId}`}
                serverId={activeServerId}
                channelId={activeVoiceChannel!}
                channelName={activeVoiceChannel.startsWith('call-') ? 'Özel Grup Çağrısı' : (connectedChannel?.name || 'Ses Kanalı')} 
                voiceMode={connectedChannel?.voiceMode || 'standard'} 
                currentUser={currentUser} 
                echoCancellation={currentUser.echoCancellation ?? true}
                noiseSuppression={currentUser.noiseSuppression ?? true}
                autoGainControl={currentUser.autoGainControl ?? true}
                onDisconnect={handleDisconnect} 
                isMuted={isMuted} 
                isDeafened={isDeafened} 
                participants={channelOccupancy[activeVoiceChannel] || []} 
                musicStatus={musicState} 
                connectionStatus={voiceConnectionStatus} 
                onStatusChange={(status) => setVoiceConnectionStatus(status)} 
  style={{ 
    display: 'flex',
    flex: (isViewingVoiceChannel || isViewingGroupCall) ? 1 : undefined,
    minHeight: 0,
    position: 'absolute',
    width: (isViewingVoiceChannel || isViewingGroupCall) ? '100%' : '1px',
    height: (isViewingVoiceChannel || isViewingGroupCall) ? '100%' : '1px',
    overflow: 'hidden',
    pointerEvents: (isViewingVoiceChannel || isViewingGroupCall) ? 'auto' : 'none',
    opacity: (isViewingVoiceChannel || isViewingGroupCall) ? 1 : 0,
    zIndex: (isViewingVoiceChannel || isViewingGroupCall) ? 30 : -1
}}
                isGlobalMicMuted={isMuted}
              />
            )}
          </>
        )}
      </div>

      {/* 🚀 DEVRİMSEL: GRUP ARAMA MODALI BURAYA GELDİ */}
      {showGroupCallModal && (
        <div className="fixed inset-0 z-[400] bg-black/80 backdrop-blur-sm flex items-center justify-center p-4 animate-fade-in" onClick={() => setShowGroupCallModal(false)}>
          <div className="bg-[#111214] border border-emerald-500/30 rounded-2xl w-full max-w-md shadow-[0_0_50px_rgba(16,185,129,0.15)] flex flex-col overflow-hidden animate-scale-in" onClick={(e) => e.stopPropagation()}>
            
            {/* Üst Kısım: Başlık ve Kapatma */}
            <div className="p-5 border-b border-white/5 flex items-center justify-between bg-emerald-500/5">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-xl bg-emerald-500/20 text-emerald-500 flex items-center justify-center shadow-inner">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="m22 8-6 4 6 4V8Z"/><rect width="14" height="12" x="2" y="6" rx="2" ry="2"/></svg>
                </div>
                <div>
                  <h3 className="text-lg font-black text-white uppercase tracking-tight">Kimi Arıyoruz?</h3>
                  <p className="text-[10px] font-bold text-emerald-500/80 uppercase tracking-widest">En Fazla 10 Kişi Seçebilirsin</p>
                </div>
              </div>
              <button onClick={() => setShowGroupCallModal(false)} className="text-gray-500 hover:text-white transition-colors">
                <X size={24} />
              </button>
            </div>

            {/* Arama Çubuğu */}
            <div className="p-4 border-b border-white/5 bg-black/20">
              <div className="relative">
                <input 
                  type="text" 
                  placeholder="Arkadaşlarını ara..." 
                  value={callSearchQuery}
                  onChange={(e) => setCallSearchQuery(e.target.value)}
                  className="w-full bg-gray-900 border border-gray-800 rounded-xl py-2.5 px-4 text-sm text-white placeholder-gray-600 outline-none focus:border-emerald-500/50 transition-colors"
                />
              </div>
            </div>

            {/* Arkadaş Listesi (Sadece Online Olanlar ve Arama Filtresi) */}
            <div className="flex-1 max-h-72 overflow-y-auto custom-scrollbar p-2">
              {friends
                .filter(f => f.status === 'online') 
                .filter(f => f.username.toLowerCase().includes(callSearchQuery.toLowerCase()))
                .map(friend => {
                  const isSelected = selectedCallFriends.includes(friend.id);
                  
                  return (
                    <div 
                      key={friend.id} 
                      onClick={() => {
                        if (isSelected) {
                          setSelectedCallFriends(prev => prev.filter(id => id !== friend.id));
                        } else {
                          if (selectedCallFriends.length >= 10) return alert("nöral dostum en fazla 10 kişiyi aynı anda arayabilirsin!");
                          setSelectedCallFriends(prev => [...prev, friend.id]);
                        }
                      }}
                      className={`flex items-center justify-between p-3 mb-1 rounded-xl cursor-pointer transition-all group ${isSelected ? 'bg-emerald-500/10 border border-emerald-500/30' : 'bg-transparent border border-transparent hover:bg-white/5'}`}
                    >
                      <div className="flex items-center gap-3">
                        <div className="relative">
                          <img src={friend.avatarUrl} alt={friend.username} className={`w-10 h-10 rounded-full object-cover transition-all ${isSelected ? 'ring-2 ring-emerald-500' : ''}`} />
                          <div className="absolute bottom-0 right-0 w-3 h-3 bg-green-500 rounded-full border-2 border-[#111214]"></div>
                        </div>
                        <div className="flex flex-col">
                          <span className={`text-sm font-bold ${isSelected ? 'text-emerald-400' : 'text-gray-200'}`}>{friend.username}</span>
                          <span className="text-[10px] text-gray-500 uppercase tracking-wider font-bold">Aktif</span>
                        </div>
                      </div>
                      
                      {/* Seçim Butonu (Check) */}
                      <div className={`w-6 h-6 rounded-full border-2 flex items-center justify-center transition-all ${isSelected ? 'bg-emerald-500 border-emerald-500 text-[#111214]' : 'border-gray-600 group-hover:border-gray-400 text-transparent'}`}>
                        <Check size={14} strokeWidth={3} />
                      </div>
                    </div>
                  )
              })}
              
              {friends.filter(f => f.status === 'online').length === 0 && (
                <div className="flex flex-col items-center justify-center py-10 text-center opacity-60">
                  <div className="w-16 h-16 rounded-full bg-white/5 flex items-center justify-center mb-3">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-gray-500"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><line x1="19" y1="8" x2="19" y2="14"/><line x1="22" y1="11" x2="16" y2="11"/></svg>
                  </div>
                  <span className="text-sm font-bold text-gray-400">Aktif Operatör Yok</span>
                  <span className="text-xs text-gray-500 mt-1">Arama başlatmak için arkadaşlarının online olması gerekir.</span>
                </div>
              )}
            </div>

         {/* Alt Kısım: Arama Başlat Butonu */}
            <div className="p-4 border-t border-white/5 bg-black/20">
             <button 
                disabled={selectedCallFriends.length === 0}
           onClick={() => {
                  ensureMicrophonePermission(() => {
                      // 1. Odayı oluştur ve arkadaşları çağır
                      const newRoomId = `call-${Date.now()}`;
                      
                      socketRef.current?.emit('start-group-call', {
                          targetIds: selectedCallFriends,
                          roomId: newRoomId
                      });

                      // 2. Modalı kapat
                      setShowGroupCallModal(false);
                      setSelectedCallFriends([]);
                      setCallSearchQuery("");
                      
                      // 🚀 YENİ MÜHÜR: Grup çağrısı başlarken arka planda DM araması varsa KES!
                     if (voiceConnected && activeVoiceChannel?.startsWith('call-')) {
    alert("Zaten aktif bir grup aramasındasın !");
    return;
}
window.dispatchEvent(new CustomEvent('force-end-dm-call'));

                      // 3. Odaya bağlan!
                      // 🚀 KUSURSUZ MOTOR ATEŞLEMESİ
                      setVoiceConnectionStatus(ConnectionState.CONNECTING);
                      setActiveVoiceChannel(newRoomId);
                      setActiveChannelId(newRoomId);
                      setVoiceSessionId(Date.now());
                      setVoiceConnected(true); // Sistemi ayağa kaldırır
                      setActiveServerId('home'); // Ana sayfada kalmayı zorlar

                      // 🚀 OPTİMİSTİK ARAYÜZ MÜHRÜ: Çağrı başlar başlamaz kendi avatarını ekrana bas!
                      if (currentUser) {
                          setChannelOccupancy(prev => ({ ...prev, [newRoomId]: [currentUser] }));
                      }
                  });
                }}
                className={`w-full py-3.5 rounded-xl font-black text-sm uppercase tracking-wider flex items-center justify-center gap-2 transition-all active:scale-95 ${selectedCallFriends.length > 0 ? 'bg-emerald-500 hover:bg-emerald-400 text-[#111214] shadow-[0_0_20px_rgba(16,185,129,0.3)]' : 'bg-gray-800 text-gray-600 cursor-not-allowed'}`}
              >
                Çağrıyı Başlat {selectedCallFriends.length > 0 && `(${selectedCallFriends.length})`}
              </button>
            </div>
            
          </div>
        </div>
      )}

      {/* 🚀 DEVRİMSEL: YAZILI GRUP OLUŞTURMA MODALI */}
      {showCreateGroupModal && (
        <div className="fixed inset-0 z-[400] bg-black/80 backdrop-blur-sm flex items-center justify-center p-4 animate-fade-in" onClick={() => setShowCreateGroupModal(false)}>
          <div className="bg-[#111214] border border-blue-500/30 rounded-2xl w-full max-w-md shadow-[0_0_50px_rgba(59,130,246,0.15)] flex flex-col overflow-hidden animate-scale-in" onClick={(e) => e.stopPropagation()}>
            
           {/* Üst Kısım: Başlık ve Kapatma */}
            <div className="p-5 border-b border-white/5 flex items-center justify-between bg-blue-500/5">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-xl bg-blue-500/20 text-blue-500 flex items-center justify-center shadow-inner">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M22 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>
                </div>
                <div>
                  <h3 className="text-lg font-black text-white uppercase tracking-tight">Grup Kur / Katıl</h3>
                  <p className="text-[10px] font-bold text-blue-500/80 uppercase tracking-widest">Sohbete Başla</p>
                </div>
              </div>
              <button onClick={() => setShowCreateGroupModal(false)} className="text-gray-500 hover:text-white transition-colors">
                <X size={24} />
              </button>
            </div>

            {/* 🚀 YENİ: DAVET KODU İLE KATILMA ALANI */}
            <div className="p-4 border-b border-white/5 bg-blue-500/10">
              <label className="block text-xs font-bold text-blue-400 uppercase tracking-widest mb-2">Davet Koduyla Katıl</label>
              <div className="flex items-center gap-2">
                <input 
                  type="text" 
                  placeholder="Kodu Buraya Gir (Örn: X7A9BQ1L)" 
                  value={groupInviteCode}
                  onChange={(e) => setGroupInviteCode(e.target.value)}
                  className="flex-1 bg-black/40 border border-blue-500/30 rounded-xl py-2.5 px-4 text-sm text-white placeholder-gray-500 outline-none focus:border-blue-500 transition-colors uppercase tracking-widest font-mono"
                />
                <button 
                  onClick={handleJoinGroup}
                  disabled={!groupInviteCode.trim()}
                  className="bg-blue-600 hover:bg-blue-500 disabled:bg-gray-800 disabled:text-gray-600 text-white font-bold py-2.5 px-5 rounded-xl transition-all shadow-[0_0_15px_rgba(59,130,246,0.3)] active:scale-95"
                >
                  Katıl
                </button>
              </div>
            </div>

            {/* ARAYA ŞIK BİR AYRAÇ */}
            <div className="w-full text-center py-2 bg-black/20 border-b border-white/5">
                <span className="text-[10px] font-bold text-gray-500 uppercase tracking-widest">VEYA YENİ GRUP KUR</span>
            </div>

            {/* Arama Çubuğu */}
            <div className="p-4 border-b border-white/5 bg-black/20">
              <div className="relative">
                <input 
                  type="text" 
                  placeholder="Arkadaşlarını ara..." 
                  value={callSearchQuery}
                  onChange={(e) => setCallSearchQuery(e.target.value)}
                  className="w-full bg-gray-900 border border-gray-800 rounded-xl py-2.5 px-4 text-sm text-white placeholder-gray-600 outline-none focus:border-blue-500/50 transition-colors"
                />
              </div>
            </div>

            {/* Arkadaş Listesi (Online kısıtlaması yok, herkesi listele) */}
            <div className="flex-1 max-h-72 overflow-y-auto custom-scrollbar p-2">
              {friends
                .filter(f => f.relationship === 'friend') 
                .filter(f => f.username.toLowerCase().includes(callSearchQuery.toLowerCase()))
                .map(friend => {
                  const isSelected = selectedCallFriends.includes(friend.id);
                  
                  return (
                    <div 
                      key={friend.id} 
                      onClick={() => {
                        if (isSelected) {
                          setSelectedCallFriends(prev => prev.filter(id => id !== friend.id));
                        } else {
                          if (selectedCallFriends.length >= 20) return alert("nöral dostum bir gruba en fazla 20 kişi ekleyebilirsin!");
                          setSelectedCallFriends(prev => [...prev, friend.id]);
                        }
                      }}
                      className={`flex items-center justify-between p-3 mb-1 rounded-xl cursor-pointer transition-all group ${isSelected ? 'bg-blue-500/10 border border-blue-500/30' : 'bg-transparent border border-transparent hover:bg-white/5'}`}
                    >
                      <div className="flex items-center gap-3">
                        <div className="relative">
                          <img src={friend.avatarUrl} alt={friend.username} className={`w-10 h-10 rounded-full object-cover transition-all ${isSelected ? 'ring-2 ring-blue-500' : ''}`} />
                          <div className={`absolute bottom-0 right-0 w-3 h-3 rounded-full border-2 border-[#111214] ${friend.status === 'online' ? 'bg-green-500' : 'bg-gray-500'}`}></div>
                        </div>
                        <div className="flex flex-col">
                          <span className={`text-sm font-bold ${isSelected ? 'text-blue-400' : 'text-gray-200'}`}>{friend.username}</span>
                          <span className="text-[10px] text-gray-500 uppercase tracking-wider font-bold">{friend.status === 'online' ? 'Aktif' : 'offline'}</span>
                        </div>
                      </div>
                      
                      {/* Seçim Butonu (Check) */}
                      <div className={`w-6 h-6 rounded-full border-2 flex items-center justify-center transition-all ${isSelected ? 'bg-blue-500 border-blue-500 text-[#111214]' : 'border-gray-600 group-hover:border-gray-400 text-transparent'}`}>
                        <Check size={14} strokeWidth={3} />
                      </div>
                    </div>
                  )
              })}
            </div>

            {/* Alt Kısım: Grubu Kur Butonu */}
            <div className="p-4 border-t border-white/5 bg-black/20">
              <button 
                disabled={selectedCallFriends.length === 0}
                onClick={async () => {
                   if(selectedCallFriends.length === 0) return;
                   
                   try {
                       const res = await fetch(`${BACKEND_URL}/api/groups`, {
                           method: 'POST',
                           headers: {
                               'Content-Type': 'application/json',
                               
                           },
                           body: JSON.stringify({
                               name: "Yeni Grup", 
                               iconUrl: "",
                               memberIds: selectedCallFriends
                           })
                       });
                       
                     if(res.ok) {
                           const newGroup = await res.json();
                           
                           // 🚀 DÜZELTME: Yeni grubu ANINDA kendi listemize ekliyoruz (Gri ekranı yok eder)
                           setGroups(prev => {
                               if (prev.some(g => g.id === newGroup.id)) return prev;
                               return [{ ...newGroup, unreadCount: 0 }, ...prev];
                           });

                           // Modalı Kapat
                           setShowCreateGroupModal(false);
                           setSelectedCallFriends([]);
                           setCallSearchQuery("");
                           
                           // 🚀 Anında yeni açılan gruba geçiş yap!
                           setActiveDmId(null);
                           setActiveGroupId(newGroup.id);
                       }else {
                           const err = await res.json();
                           alert(err.error);
                       }
                   } catch(err) {
                       console.error(err);
                       alert("Grup Kurulamadı");
                   }
                }}
                className={`w-full py-3.5 rounded-xl font-black text-sm uppercase tracking-wider flex items-center justify-center gap-2 transition-all active:scale-95 ${selectedCallFriends.length > 0 ? 'bg-blue-500 hover:bg-blue-400 text-white shadow-[0_0_20px_rgba(59,130,246,0.3)]' : 'bg-gray-800 text-gray-600 cursor-not-allowed'}`}
              >
                Grubu Oluştur {selectedCallFriends.length > 0 && `(${selectedCallFriends.length})`}
              </button>
            </div>
            
          </div>
        </div>
      )}

      {/* 📞 GELEN GRUP ÇAĞRISI (TELEFON ÇALIYOR) EKRANI */}
      {incomingGroupCall && (
        <div className="fixed inset-0 z-[500] bg-black/90 backdrop-blur-md flex items-center justify-center p-4 animate-fade-in">
          <div className="bg-[#111214] border border-emerald-500/50 rounded-3xl p-8 max-w-sm w-full shadow-[0_0_100px_rgba(16,185,129,0.2)] flex flex-col items-center text-center animate-scale-in relative overflow-hidden">
            
            {/* Arka plan dalga efekti */}
            <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
              <div className="w-32 h-32 bg-emerald-500/20 rounded-full animate-ping absolute"></div>
              <div className="w-48 h-48 bg-emerald-500/10 rounded-full animate-ping absolute" style={{ animationDelay: '0.2s' }}></div>
            </div>

            <div className="relative w-24 h-24 mb-6">
              <img src={incomingGroupCall.callerAvatar} alt="Arayan" className="w-full h-full rounded-full object-cover border-4 border-[#111214] shadow-xl relative z-10" />
              <div className="absolute bottom-0 right-0 w-6 h-6 bg-emerald-500 rounded-full border-4 border-[#111214] z-20 flex items-center justify-center animate-pulse">
                 <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#111214" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/></svg>
              </div>
            </div>

            <h2 className="text-2xl font-black text-white mb-1 relative z-10">{incomingGroupCall.callerName}</h2>
            <p className="text-sm font-bold text-emerald-500 uppercase tracking-widest mb-8 relative z-10 animate-pulse">Görüntülü/Sesli Çağrı Geliyor...</p>

          <div className="flex items-center gap-6 w-full relative z-10">
              <button 
                onClick={() => setIncomingGroupCall(null)}
                className="flex-1 py-3.5 rounded-2xl bg-red-500/10 text-red-500 hover:bg-red-500 hover:text-white border border-red-500/30 font-black uppercase tracking-wider transition-all active:scale-95"
              >
                Reddet
              </button>
           <button 
               onClick={() => {
                  ensureMicrophonePermission(() => {
                      // 🚀 YENİ MÜHÜR: Gelen grup çağrısını açınca arka plandaki DM aramasını KES!
                      window.dispatchEvent(new CustomEvent('force-end-dm-call'));

                      setVoiceConnectionStatus(ConnectionState.CONNECTING);
                  setActiveVoiceChannel(incomingGroupCall.roomId);
setActiveChannelId(incomingGroupCall.roomId);
setVoiceSessionId(Date.now());
setVoiceConnected(true);
setActiveServerId('home');
setActiveDmId(null);
setActiveGroupId(null);
setIsDmMinimized(true);

                      // 🚀 OPTİMİSTİK ARAYÜZ MÜHRÜ: Aramayı açtığın an avatarın ekrana düşsün!
                      if (currentUser) {
                          setChannelOccupancy(prev => {
                              const currentUsers = prev[incomingGroupCall.roomId] || [];
                              if (currentUsers.some(u => u.id === currentUser.id)) return prev;
                              return { ...prev, [incomingGroupCall.roomId]: [...currentUsers, currentUser] };
                          });
                      }
                      
                      setIncomingGroupCall(null);
                  });
                }}
                className="flex-1 py-3.5 rounded-2xl bg-emerald-500 text-[#111214] hover:bg-emerald-400 font-black uppercase tracking-wider transition-all shadow-[0_0_20px_rgba(16,185,129,0.4)] active:scale-95 flex items-center justify-center gap-2"
              >
                Kabul Et
              </button>
            </div>
            
          </div>
        </div>
      )}
      {showCreateServerModal && <CreateServerModal onClose={() => setShowCreateServerModal(false)} onCreate={handleCreateServer} onJoin={handleJoinServer} onDiscover={() => { setActiveServerId('discovery'); setShowCreateServerModal(false); }} />}

{/* 🚀 DEVRİMSEL: UYGULAMA SEÇİM MODALI (AKILLI KONTROL) */}
        {inviteChoiceCode && !showDownloadPrompt && (
          <div className="fixed inset-0 z-[99999] bg-black/80 backdrop-blur-md flex items-center justify-center p-4 animate-fade-in">
            <div className="bg-[#111214] border border-sesgelio/50 rounded-3xl p-8 max-w-sm w-full shadow-[0_0_100px_rgba(255,43,94,0.2)] flex flex-col items-center text-center animate-scale-in relative overflow-hidden">
              <div className="w-20 h-20 bg-sesgelio/20 rounded-2xl flex items-center justify-center text-sesgelio mb-6 border border-sesgelio/30 shadow-inner rotate-3">
                <Compass size={40} />
              </div>
              <h2 className="text-2xl font-black text-white mb-2 uppercase tracking-tight">Sunucuya Katıl</h2>
              <p className="text-sm font-medium text-gray-400 mb-8">Daveti nerede açmak istiyorsun nöral dostum?</p>

              <div className="flex flex-col gap-3 w-full relative z-10">
                <button 
                  onClick={() => {
                    // 1. Masaüstü uygulamasını tetikle!
                    window.location.href = `sesgelio://davet/${inviteChoiceCode}`;
                    
                    // 🚀 2. AKILLI KRONOMETRE: 2.5 Saniye sonra adam hala ekrandaysa uygulama yok demektir!
                    setTimeout(() => {
                       if (!document.hidden) {
                           setShowDownloadPrompt(true); // İndirme ekranını çıkart!
                       } else {
                           setInviteChoiceCode(null); // Uygulama açıldıysa modalı temizle
                       }
                    }, 2500);
                  }}
                  className="w-full py-4 rounded-xl bg-sesgelio hover:bg-[#ff4b72] text-white font-black uppercase tracking-wider transition-all shadow-[0_0_20px_rgba(255,43,94,0.4)] active:scale-95 flex items-center justify-center gap-2"
                >
                  <MonitorUp size={18} /> Uygulamada Aç
                </button>
                
                <button 
                  onClick={() => {
                    if (currentUser) {
                      handleJoinServer(inviteChoiceCode, currentUser);
                    } else {
                      localStorage.setItem('pendingInvite', inviteChoiceCode);
                    }
                    setInviteChoiceCode(null);
                  }}
                  className="w-full py-4 rounded-xl bg-white/5 hover:bg-white/10 text-gray-300 hover:text-white border border-white/10 font-bold uppercase tracking-wider transition-all active:scale-95 flex items-center justify-center gap-2"
                >
                  Tarayıcıda Devam Et
                </button>
              </div>
            </div>
          </div>
        )}

       {/* 🚀 YENİ: UYGULAMA BULUNAMADI / İNDİR MODALI (PREMIUM TASARIM) */}
        {showDownloadPrompt && inviteChoiceCode && (
          <div className="fixed inset-0 z-[99999] bg-black/80 backdrop-blur-md flex items-center justify-center p-4 animate-fade-in">
            {/* 🚀 ÇÖZÜM: Tooltip'lerin kesilmemesi için overflow-hidden kaldırıldı! */}
            <div className="bg-[#0a0a0c] border border-gray-800 rounded-3xl p-6 max-w-sm w-full shadow-[0_0_100px_rgba(255,255,255,0.03)] flex flex-col items-center text-center animate-scale-in relative">
              
              <div className="w-16 h-16 bg-gray-800/30 rounded-2xl flex items-center justify-center text-gray-400 mb-4 border border-gray-700/50 shadow-inner">
                <Monitor size={32} className="text-sesgelio" />
              </div>
              <h2 className="text-xl font-black text-white mb-1 uppercase tracking-tight">Uygulama Yok</h2>
              <p className="text-xs font-medium text-gray-400 mb-6 px-2">Sesgelio cihazında yüklü değil. Hemen işletim sistemine uygun sürümü indir!</p>

              {/* 🚀 SENİN EFSANE MENÜ TASARIMIN (MODAL İÇİNE UYARLANDI) */}
              <div className="flex flex-col gap-2 w-full relative z-10 mb-6 text-left">
                
                {/* Windows */}
                <a href="/downloads/Sesgelio%20Setup%201.0.0.exe" download className="group relative flex items-center gap-3 px-3 py-3 rounded-xl bg-white/5 border border-white/5 hover:bg-white/10 hover:border-blue-500/30 transition-all cursor-pointer">
                  <div className="relative z-10 w-10 h-10 bg-[#111214] border border-blue-500/20 rounded-xl flex items-center justify-center shrink-0 shadow-[0_0_15px_rgba(59,130,246,0.15)] group-hover:scale-110 transition-all duration-300 text-blue-400">
                    <svg viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5 group-hover:brightness-125 transition-all">
                      <path d="M0 0h11.4v11.4H0zm12.6 0H24v11.4H12.6zM0 12.6h11.4V24H0zm12.6 0H24V24H12.6z"/>
                    </svg>
                  </div>
                  <div className="flex flex-col relative z-10 flex-1">
                    <span className="text-white text-sm font-bold group-hover:text-blue-400 transition-colors duration-300">Windows</span>
                    <span className="text-gray-500 text-[10px] font-medium">Setup 1.0.0 · 64-bit</span>
                  </div>
                  <span className="relative z-10 text-[10px] font-black text-white bg-blue-600 hover:bg-blue-500 px-3 py-1.5 rounded-lg uppercase tracking-wider shadow-[0_0_15px_rgba(37,99,235,0.4)] transition-all active:scale-95">
                    İNDİR
                  </span>
                </a>

                {/* macOS */}
                <a href="/downloads/Sesgelio-1.0.0-arm64.dmg" download className="group relative flex items-center gap-3 px-3 py-3 rounded-xl bg-white/5 border border-white/5 hover:bg-white/10 hover:border-gray-500/30 transition-all cursor-pointer">
                  <div className="relative z-10 w-10 h-10 bg-[#111214] border border-gray-500/20 rounded-xl flex items-center justify-center shrink-0 shadow-[0_0_15px_rgba(156,163,175,0.15)] group-hover:scale-110 transition-all duration-300">
                    <img src="https://cdn.simpleicons.org/apple/9ca3af" alt="macOS" className="w-5 h-5 group-hover:brightness-125 transition-all" />
                  </div>
                  <div className="flex flex-col relative z-10 flex-1">
                    <div className="flex items-center gap-1.5 relative group/tooltip">
                      <span className="text-white text-sm font-bold group-hover:text-gray-300 transition-colors duration-300">macOS</span>
                      <div onClick={(e) => { e.preventDefault(); e.stopPropagation(); }} className="text-gray-400 hover:text-white transition-colors p-1 bg-white/5 hover:bg-white/10 rounded-md cursor-help">
                        <Info size={13} />
                      </div>
                      <div className="absolute left-1/2 bottom-full mb-2 -translate-x-1/2 w-48 p-3 bg-[#0a0a0c]/95 backdrop-blur-3xl border border-gray-700 rounded-xl shadow-[0_20px_50px_rgba(0,0,0,0.9)] opacity-0 invisible group-hover/tooltip:opacity-100 group-hover/tooltip:visible transition-all duration-300 z-[99999] pointer-events-none transform translate-y-2 group-hover/tooltip:translate-y-0 text-left">
                        <div className="absolute bottom-[-5px] left-1/2 -translate-x-1/2 w-2.5 h-2.5 bg-[#0a0a0c] border-b border-r border-gray-700 transform rotate-45"></div>
                        <h4 className="font-black text-white text-[9px] uppercase tracking-widest mb-1.5 flex items-center gap-1.5">
                          <ShieldAlert size={10} className="text-sesgelio" /> Kurulum Uyarısı
                        </h4>
                        <ol className="list-decimal pl-3 space-y-0.5 text-[8px] text-gray-300 font-medium">
                          <li>İndirdiğiniz dosyaya <strong className="text-white">Sağ Tıklayın</strong></li>
                          <li>Menüden <strong className="text-white">"Aç"</strong>a tıklayın</li>
                          <li>Uyarıdaki <strong className="text-white bg-white/10 px-1 rounded">Aç</strong> butonuna basın.</li>
                        </ol>
                      </div>
                    </div>
                    <span className="text-gray-500 text-[10px] font-medium">Apple Silicon (M Serisi)</span>
                  </div>
                  <span className="relative z-10 text-[10px] font-black text-white bg-gray-700 hover:bg-gray-600 px-3 py-1.5 rounded-lg uppercase tracking-wider shadow-[0_0_15px_rgba(75,85,99,0.4)] transition-all active:scale-95">
                    İNDİR
                  </span>
                </a>

                {/* Linux */}
                <a href="/downloads/Sesgelio-1.0.0.AppImage" download className="group relative flex items-center gap-3 px-3 py-3 rounded-xl bg-white/5 border border-white/5 hover:bg-white/10 hover:border-orange-500/30 transition-all cursor-pointer">
                  <div className="relative z-10 w-10 h-10 bg-[#111214] border border-orange-500/20 rounded-xl flex items-center justify-center shrink-0 shadow-[0_0_15px_rgba(249,115,22,0.15)] group-hover:scale-110 transition-all duration-300">
                    <img src="https://cdn.simpleicons.org/ubuntu/f97316" alt="Linux" className="w-5 h-5 group-hover:brightness-125 transition-all" />
                  </div>
                  <div className="flex flex-col relative z-10 flex-1">
                    <span className="text-white text-sm font-bold group-hover:text-orange-400 transition-colors duration-300">Linux</span>
                    <span className="text-gray-500 text-[10px] font-medium">AppImage · x64</span>
                  </div>
                  <span className="relative z-10 text-[10px] font-black text-white bg-orange-600 hover:bg-orange-500 px-3 py-1.5 rounded-lg uppercase tracking-wider shadow-[0_0_15px_rgba(234,88,12,0.4)] transition-all active:scale-95">
                    İNDİR
                  </span>
                </a>
                
              </div>

              {/* Alt Buton: Tarayıcıda Devam Et */}
              <button 
                onClick={() => {
                  if (currentUser) {
                    handleJoinServer(inviteChoiceCode, currentUser);
                  } else {
                    localStorage.setItem('pendingInvite', inviteChoiceCode);
                  }
                  setInviteChoiceCode(null);
                  setShowDownloadPrompt(false);
                }}
                className="w-full py-3.5 rounded-xl bg-transparent hover:bg-white/5 text-gray-400 hover:text-white border border-gray-800 hover:border-gray-600 font-bold uppercase tracking-wider transition-all active:scale-95 text-xs flex items-center justify-center gap-2"
              >
                Şimdilik Tarayıcıda Devam Et
              </button>

            </div>
          </div>
        )}


</div>
    </Suspense>
  );
};

export default App;